let strings = [
  {
    English: "Submit",
    French: "Soumettre",
    Spanish: "Entregar",
    key: "Submit",
  },
  {
    English: "Info",
    French: "Informations",
    Spanish: "Información",
    key: "Info",
  },
  {
    English: "Overview",
    French: "Aperçu",
    Spanish: "Descripción general",
    key: "Overview",
  },
  {
    English: "Settings",
    French: "Paramètres",
    Spanish: "Ajustes",
    key: "Settings",
  },
  {
    English: "Please enter valid email",
    French: "Veuillez entrer une adresse e-mail valide",
    Spanish: "Por favor ingrese un correo electrónico válido",
    key: "Please_enter_valid_email",
  },
  {
    English: "Dashboard",
    French: "Tableau de bord",
    Spanish: "Panel",
    key: "Dashboard",
  },
  {
    English: "System Users",
    French: "Utilisateurs du système",
    Spanish: "Usuarios del sistema",
    key: "System_Users",
  },
  {
    English: "Plans",
    French: "Forfaits",
    Spanish: "Planes",
    key: "Plans",
  },
  {
    English: "Advisors",
    French: "Conseillers",
    Spanish: "Asesores",
    key: "Advisors",
  },
  {
    English: "Payables",
    French: "Dettes",
    Spanish: "Cuentas por pagar",
    key: "Payables",
  },
  {
    English: "Corporate Customers",
    French: "Clients Entreprises",
    Spanish: "Clientes corporativos",
    key: "Corporate_Customers",
  },
  {
    English: "Members",
    French: "Membres",
    Spanish: "Miembros",
    key: "Members",
  },
  {
    English: "Invoices",
    French: "Factures",
    Spanish: "Facturas",
    key: "Invoices",
  },
  {
    English: "Reports",
    French: "Rapports",
    Spanish: "Informes",
    key: "Reports",
  },
  {
    English: "Change Password",
    French: "Changer le mot de passe",
    Spanish: "Cambiar la contraseña",
    key: "Change_Password",
  },
  {
    English: "Old Password",
    French: "Ancien mot de passe",
    Spanish: "Contraseña anterior",
    key: "Old_Password",
  },
  {
    English: "New Password",
    French: "Nouveau mot de passe",
    Spanish: "Nueva contraseña",
    key: "New_Password",
  },
  {
    English: "Confirm Password",
    French: "Confirmez le mot de passe",
    Spanish: "confirmar Contraseña",
    key: "Confirm_Password",
  },
  {
    English: "Please enter new password",
    French: "Veuillez entrer un nouveau mot de passe",
    Spanish: "Por favor ingrese una nueva contraseña",
    key: "Please_enter_new_password",
  },
  {
    English: "Passwords did not match",
    French: "Les mots de passe ne correspondent pas",
    Spanish: "Las contraseñas no coincidieron",
    key: "Passwords_did_not_match",
  },
  {
    English: "Close",
    French: "Fermer",
    Spanish: "Cerca",
    key: "Close",
  },
  {
    English: "Error",
    French: "Erreur",
    Spanish: "Error",
    key: "Error",
  },
  {
    English: "Welcome",
    French: "Accueillir",
    Spanish: "Bienvenido",
    key: "Welcome",
  },
  {
    English: "My Plans",
    French: "Mes projets",
    Spanish: "Mis planes",
    key: "My_Plans",
  },
  {
    English: "Downloads",
    French: "Téléchargements",
    Spanish: "Descargas",
    key: "Downloads",
  },
  {
    English: "Member Support",
    French: "Soutien aux membres",
    Spanish: "Soporte para miembros",
    key: "Member_Support",
  },
  {
    English: "Member Booklets",
    French: "Livrets des membres",
    Spanish: "Folletos para miembros",
    key: "Member_Booklets",
  },
  {
    English: "Membership Cards",
    French: "Cartes de membre",
    Spanish: "Tarjetas de membresía",
    key: "Membership_Cards",
  },
  {
    English: "My Applications",
    French: "Mes candidatures",
    Spanish: "Mis aplicaciones",
    key: "My_Applications",
  },
  {
    English: "Record of Enrollment",
    French: "Dossier d'inscription",
    Spanish: "Registro de inscripción",
    key: "Record_of_Enrollment",
  },
  {
    English: "Download Card",
    French: "Télécharger la carte",
    Spanish: "Descargar tarjeta",
    key: "Download_Card",
  },
  {
    English: "Order your services",
    French: "Commandez vos services",
    Spanish: "Ordene sus servicios",
    key: "Order_your_services",
  },
  {
    English: "Visit RxFood online",
    French: "Visitez RxFood en ligne",
    Spanish: "Visite RxFood en línea",
    key: "Visit_RxFood_online",
  },
  {
    English: "How to Submit Claims Online",
    French: "Comment soumettre des réclamations en ligne",
    Spanish: "Cómo presentar reclamaciones en línea",
    key: "How_to_Submit_Claims_Online",
  },
  {
    English: "Claims Line",
    French: "Ligne de réclamation",
    Spanish: "Línea de Reclamos",
    key: "Claims_Line",
  },
  {
    English: "Draft",
    French: "Brouillon",
    Spanish: "Borrador",
    key: "Draft",
  },
  {
    English: "View Invoice",
    French: "Afficher la facture",
    Spanish: "Ver factura",
    key: "View_Invoice",
  },
  {
    English: "Download",
    French: "Télécharger",
    Spanish: "Descargar",
    key: "Download",
  },
  {
    English: "Payment Method",
    French: "Méthode de Paiement",
    Spanish: "Método de Pago",
    key: "Payment_Method",
  },
  {
    English: "Bank Id",
    French: "Numéro d'identification bancaire",
    Spanish: "Identificación bancaria",
    key: "Bank_Id",
  },
  {
    English: "Transit",
    French: "Transit",
    Spanish: "Tránsito",
    key: "Transit",
  },
  {
    English: "Account",
    French: "Compte",
    Spanish: "Cuenta",
    key: "Account",
  },
  {
    English: "Bank Details",
    French: "Coordonnées bancaires",
    Spanish: "Detalles bancarios",
    key: "Bank_Details",
  },
  {
    English: "Pre-Authorized Debit (PAD)",
    French: "Débit préautorisé (DPA)",
    Spanish: "Débito Preautorizado (PAD)",
    key: "Pre_Authorized_Debit_PAD",
  },
  {
    English: "Update PAD",
    French: "Mettre à jour le PAD",
    Spanish: "Actualizar PAD",
    key: "Update_PAD",
  },
  {
    English: "Update PAD Details",
    French: "Mettre à jour les détails du PAD",
    Spanish: "Actualizar detalles de PAD",
    key: "Update_PAD_Details",
  },
  {
    English: "Clear",
    French: "Clair",
    Spanish: "Claro",
    key: "Clear",
  },
  {
    English: "Click here to view Void Cheque",
    French: "Cliquez ici pour voir le chèque annulé",
    Spanish: "Haga clic aquí para ver el cheque anulado",
    key: "Click_here_to_view_Void_Cheque",
  },
  {
    English: "Preview",
    French: "Aperçu",
    Spanish: "Avance",
    key: "Preview",
  },
  {
    English: "Upload",
    French: "Télécharger",
    Spanish: "Subir",
    key: "Upload",
  },
  {
    English: "Continue",
    French: "Continuer",
    Spanish: "Continuar",
    key: "Continue",
  },
  {
    English: "Change to Credit Card",
    French: "Changement de carte de crédit",
    Spanish: "Cambiar a tarjeta de crédito",
    key: "Change_to_Credit_Card",
  },
  {
    English: "First Name",
    French: "Prénom",
    Spanish: "Nombre",
    key: "First_Name",
  },
  {
    English: "Please enter first name",
    French: "Veuillez saisir votre prénom",
    Spanish: "Por favor ingrese el nombre",
    key: "Please_enter_first_name",
  },
  {
    English: "Last Name",
    French: "Nom de Famille",
    Spanish: "Apellido",
    key: "Last_Name",
  },
  {
    English: "Please enter last name",
    French: "Veuillez entrer votre nom de famille",
    Spanish: "Por favor ingrese el apellido",
    key: "Please_enter_last_name",
  },
  {
    English: "Credit Card Number",
    French: "Numéro de Carte de Crédit",
    Spanish: "Número de Tarjeta de Crédito",
    key: "Credit_Card_Number",
  },
  {
    English: "Please enter card number",
    French: "Veuillez saisir le numéro de carte",
    Spanish: "Por favor ingrese el número de tarjeta",
    key: "Please_enter_card_number",
  },
  {
    English: "Expiration",
    French: "Expiration",
    Spanish: "Vencimiento",
    key: "Expiration",
  },
  {
    English: "Please select expiration month",
    French: "Veuillez sélectionner le mois d'expiration",
    Spanish: "Por favor seleccione el mes de vencimiento",
    key: "Please_select_expiration_month",
  },
  {
    English: "Please select expiration year",
    French: "Veuillez sélectionner l'année d'expiration",
    Spanish: "Por favor seleccione el año de vencimiento",
    key: "Please_select_expiration_year",
  },
  {
    English: "Please enter CVV",
    French: "Veuillez entrer CVV",
    Spanish: "Por favor introduce CVV",
    key: "Please_enter_CVV",
  },
  {
    English: "Please enter email",
    French: "Veuillez saisir votre adresse e-mail",
    Spanish: "Por favor ingrese el correo electrónico",
    key: "Please_enter_email",
  },
  {
    English: "Update Payment Method",
    French: "Mettre à jour le mode de paiement",
    Spanish: "Actualizar método de pago",
    key: "Update_Payment_Method",
  },
  {
    English: "Update Credit Card",
    French: "Mettre à jour la carte de crédit",
    Spanish: "Actualizar tarjeta de crédito",
    key: "Update_Credit_Card",
  },
  {
    English: "Change to PAD",
    French: "Passer au PAD",
    Spanish: "Cambiar a PAD",
    key: "Change_to_PAD",
  },
  {
    English: "Do you want to change payment method to Pre-Authorized Debit?",
    French:
      "Voulez-vous changer le mode de paiement pour le débit préautorisé ?",
    Spanish: "¿Quieres cambiar el método de pago a Débito Preautorizado?",
    key: "Do_you_want_to_change_payment_method_to_Pre_Authorized_Debit",
  },
  {
    English: "Please enter bank number",
    French: "Veuillez saisir le numéro de banque",
    Spanish: "Por favor ingrese el número de banco",
    key: "Please_enter_bank_number",
  },
  {
    English: "Please enter transit number",
    French: "Veuillez entrer le numéro de transit",
    Spanish: "Por favor ingrese el número de tránsito",
    key: "Please_enter_transit_number",
  },
  {
    English: "Please enter account number",
    French: "Veuillez entrer le numéro de compte",
    Spanish: "Por favor ingrese el número de cuenta",
    key: "Please_enter_account_number",
  },
  {
    English: "Account number minimum 5 digits",
    French: "Numéro de compte minimum 5 chiffres",
    Spanish: "Número de cuenta mínimo 5 dígitos",
    key: "Account_number_minimum_5_digits",
  },
  {
    English: "Verify",
    French: "Vérifier",
    Spanish: "Verificar",
    key: "Verify",
  },
  {
    English: "Review and Sign the PAD Agreement",
    French: "Examiner et signer l’accord PAD",
    Spanish: "Revisar y firmar el Acuerdo PAD",
    key: "Review_and_Sign_the_PAD_Agreement",
  },
  {
    English: "PAD Agreement",
    French: "Accord DPA",
    Spanish: "Acuerdo PAD",
    key: "PAD_Agreement",
  },
  {
    English: "Sign & Agree",
    French: "Signer et accepter",
    Spanish: "Firmar y aceptar",
    key: "Sign_Agree",
  },
  {
    English: "Reject",
    French: "Rejeter",
    Spanish: "Rechazar",
    key: "Reject",
  },
  {
    English: "Signature",
    French: "Signature",
    Spanish: "Firma",
    key: "Signature",
  },
  {
    English: "Confirm",
    French: "Confirmer",
    Spanish: "Confirmar",
    key: "Confirm",
  },
  {
    English: "Member Information",
    French: "Informations sur les membres",
    Spanish: "Información de miembro",
    key: "Member_Information",
  },
  {
    English: "Please enter Primary Number",
    French: "Veuillez entrer le numéro principal",
    Spanish: "Por favor ingrese el número principal",
    key: "Please_enter_Primary_Number",
  },
  {
    English: "Phone number must be equal to 10 digits",
    French: "Le numéro de téléphone doit être égal à 10 chiffres",
    Spanish: "El número de teléfono debe tener 10 dígitos.",
    key: "Phone_number_must_be_equal_to_10_digits",
  },
  {
    English: "Please enter street address",
    French: "Veuillez entrer l'adresse postale",
    Spanish: "Por favor ingrese la dirección",
    key: "Please_enter_street_address",
  },
  {
    English: "Please enter city",
    French: "Veuillez entrer la ville",
    Spanish: "Por favor ingresa la ciudad",
    key: "Please_enter_city",
  },
  {
    English: "Please enter valid postal code",
    French: "Veuillez entrer un code postal valide",
    Spanish: "Por favor, introduzca el código postal válido",
    key: "Please_enter_valid_postal_code",
  },
  {
    English: "Please enter postal code",
    French: "Veuillez entrer le code postal",
    Spanish: "Por favor ingrese el código postal",
    key: "Please_enter_postal_code",
  },
  {
    English: "Cancel",
    French: "Annuler",
    Spanish: "Cancelar",
    key: "Cancel",
  },
  {
    English: "Update",
    French: "Mise à jour",
    Spanish: "Actualizar",
    key: "Update",
  },
  {
    English: "Dependent Info",
    French: "Informations dépendantes",
    Spanish: "Información dependiente",
    key: "Dependent_Info",
  },
  {
    English: "Update Spouse's Details",
    French: "Mettre à jour les détails du conjoint",
    Spanish: "Actualizar los detalles del cónyuge",
    key: "Update_Spouse_s_Details",
  },
  {
    English:
      "Is your spouse covered by another Health and/or Dental insurance plan through their employer?",
    French:
      "Votre conjoint est-il couvert par un autre régime d'assurance maladie et/ou dentaire par l'intermédiaire de son employeur ?",
    Spanish:
      "¿Su cónyuge está cubierto por otro plan de seguro médico y/o dental a través de su empleador?",
    key: "Is_your_spouse_covered_by_another_Health_and_or_Dental_insurance_plan_through_their_employer",
  },
  {
    English: "Please enter name of carrier",
    French: "Veuillez entrer le nom du transporteur",
    Spanish: "Por favor ingrese el nombre del transportista",
    key: "Please_enter_name_of_carrier",
  },
  {
    English: "Coverage",
    French: "Couverture",
    Spanish: "Cobertura",
    key: "Coverage",
  },
  {
    English: "Please enter COB coverage",
    French: "Veuillez saisir la couverture COB",
    Spanish: "Por favor ingrese la cobertura COB",
    key: "Please_enter_COB_coverage",
  },
  {
    English: "Update Dependent Info",
    French: "Mettre à jour les informations dépendantes",
    Spanish: "Actualizar información dependiente",
    key: "Update_Dependent_Info",
  },
  {
    English:
      "Is your dependent covered by another Health and/or Dental Insurance plan?",
    French:
      "La personne à votre charge est-elle couverte par un autre régime d'assurance maladie et/ou dentaire ?",
    Spanish:
      "¿Su dependiente está cubierto por otro plan de seguro médico y/o dental?",
    key: "Is_your_dependent_covered_by_another_Health_and_or_Dental_Insurance_plan",
  },
  {
    English: "Dependent with Special Needs",
    French: "Personne à charge ayant des besoins spéciaux",
    Spanish: "Dependiente con Necesidades Especiales",
    key: "Dependent_with_Special_Needs",
  },
  {
    English: "Life Event Change",
    French: "Changement d'événement de la vie",
    Spanish: "Cambio de evento de vida",
    key: "Life_Event_Change",
  },
  {
    English: "Add",
    French: "Ajouter",
    Spanish: "Agregar",
    key: "Add",
  },
  {
    English: "Name",
    French: "Nom",
    Spanish: "Nombre",
    key: "Name",
  },
  {
    English: "Percentage",
    French: "Pourcentage*",
    Spanish: "Porcentaje",
    key: "Percentage",
  },
  {
    English: "Action",
    French: "Action",
    Spanish: "Acción",
    key: "Action",
  },
  {
    English: "Delete",
    French: "Supprimer",
    Spanish: "Borrar",
    key: "Delete",
  },
  {
    English:
      "In the last 12 months, have you used, in any form whatsoever, tobacco, nicotine or cannabis mixed with tobacco?",
    French:
      "Au cours des 12 derniers mois, avez-vous consommé, sous quelque forme que ce soit, du tabac, de la nicotine ou du cannabis mélangé à du tabac ?",
    Spanish:
      "En los últimos 12 meses, ¿ha consumido, en cualquier forma, tabaco, nicotina o cannabis mezclado con tabaco?",
    key: "In_the_last_12_months_have_you_used_in_any_form_whatsoever_tobacco_nicotine_or_cannabis_mixed_with_tobacco",
  },
  {
    English: "Telephone",
    French: "Téléphone",
    Spanish: "Teléfono",
    key: "Telephone",
  },
  {
    English: "Street Address",
    French: "Adresse de la rue",
    Spanish: "Dirección",
    key: "Street_Address",
  },
  {
    English: "City",
    French: "Ville",
    Spanish: "Ciudad",
    key: "City",
  },
  {
    English: "Province",
    French: "Province",
    Spanish: "Provincia",
    key: "Province",
  },
  {
    English: "Postal Code",
    French: "Code Postal",
    Spanish: "Código Postal",
    key: "Postal_Code",
  },
  {
    English: "Previous",
    French: "Précédent",
    Spanish: "Anterior",
    key: "Previous",
  },
  {
    English: "Version",
    French: "Version",
    Spanish: "Versión",
    key: "Version",
  },
  {
    English: "Please enter valid Oldpassword",
    French: "Veuillez saisir un ancien mot de passe valide",
    Spanish: "Por favor ingrese una contraseña anterior válida",
    key: "Please_enter_valid_Oldpassword",
  },
  {
    English: "Log_Out",
    French: "Déconnexion",
    Spanish: "Cerrar sesión",
    key: "Log_Out",
  },
  {
    English: "Show",
    French: "Montrer",
    Spanish: "Espectáculo",
    key: "Show",
  },
  {
    English: "entries",
    French: "entrées",
    Spanish: "entradas",
    key: "entries",
  },
  {
    English: "Select",
    French: "Sélectionner",
    Spanish: "Seleccionar",
    key: "Select",
  },
  {
    English: "Active",
    French: "Actif",
    Spanish: "Activo",
    key: "Active",
  },
  {
    English: "Inactive",
    French: "Inactif",
    Spanish: "Inactivo",
    key: "Inactive",
  },
  {
    English: "Search",
    French: "Recherche",
    Spanish: "Buscar",
    key: "Search",
  },
  {
    English: "Employee list for",
    French: "Liste des employés pour",
    Spanish: "lista de empleados para",
    key: "Employee_list_for",
  },
  {
    English: "Corporate Account",
    French: "Compte d'entreprise",
    Spanish: "Cuenta corporativa",
    key: "Corporate_Account",
  },
  {
    English: "Phone",
    French: "Téléphone",
    Spanish: "Teléfono",
    key: "Phone",
  },
  {
    English: "Status",
    French: "Statut",
    Spanish: "Estado",
    key: "Status",
  },
  {
    English: "Employee List",
    French: "Liste des employés",
    Spanish: "Lista de empleados",
    key: "Employee_List",
  },
  {
    English: "Hold",
    French: "Tenir",
    Spanish: "Sostener",
    key: "Hold",
  },
  {
    English: "Cancelled",
    French: "Annulé",
    Spanish: "Anulado",
    key: "Cancelled",
  },
  {
    English: "Plan activation date",
    French: "Date d'activation du plan",
    Spanish: "Fecha de activación del plan",
    key: "Plan_activation_date",
  },
  {
    English: "Terminate",
    French: "Mettre fin",
    Spanish: "Terminar",
    key: "Terminate",
  },
  {
    English: "Please choose Termination Date",
    French: "Veuillez choisir la date de résiliation",
    Spanish: "Por favor elija Fecha de Terminación",
    key: "Please_choose_Termination_Date",
  },
  {
    English: "Please Select Date",
    French: "Veuillez sélectionner une date",
    Spanish: "Por favor seleccione fecha",
    key: "Please_Select_Date",
  },
  {
    English: "Customer Type:",
    French: "Type de client",
    Spanish: "Tipo de cliente:",
    key: "Customer_Type",
  },
  {
    English: "Plan Enrollment Date",
    French: "Date d'adhésion au plan",
    Spanish: "Fecha de inscripción del plan",
    key: "Plan_Enrollment_Date",
  },
  {
    English: "Termination Date",
    French: "Date de résiliation",
    Spanish: "Fecha de terminación",
    key: "Termination_Date",
  },
  {
    English: "Service Type:",
    French: "Type de service :",
    Spanish: "Tipo de servicio:",
    key: "Service_Type",
  },
  {
    English: "Refund Details",
    French: "Détails du remboursement",
    Spanish: "Detalles del reembolso",
    key: "Refund_Details",
  },
  {
    English: "Refund Applicable",
    French: "Remboursement applicable",
    Spanish: "Reembolso aplicable",
    key: "Refund_Applicable",
  },
  {
    English: "CREDIT CARD",
    French: "CARTE DE CRÉDIT",
    Spanish: "TARJETA DE CRÉDITO",
    key: "CREDIT_CARD",
  },
  {
    English: "Service",
    French: "Service",
    Spanish: "Servicio",
    key: "Service",
  },
  {
    English: "Policy",
    French: "Politique",
    Spanish: "Política",
    key: "Policy",
  },
  {
    English: "Proceed With Equitable",
    French: "Procéder de manière équitable",
    Spanish: "Continuar con equitativo",
    key: "Proceed_With_Equitable",
  },
  {
    English: "Reason",
    French: "Raison",
    Spanish: "Razón",
    key: "Reason",
  },
  {
    English: "Declined Coverage",
    French: "Couverture refusée",
    Spanish: "Cobertura rechazada",
    key: "Declined_Coverage",
  },
  {
    English: "Deceased",
    French: "Décédé",
    Spanish: "Fallecido",
    key: "Deceased",
  },
  {
    English: "All others",
    French: "Tous les autres",
    Spanish: "Todos los demás",
    key: "All_others",
  },
  {
    English: "Member Invitation mail sent successfully",
    French: "Le courrier d'invitation des membres a été envoyé avec succès",
    Spanish: "El correo de invitación para miembros se envió correctamente",
    key: "Member_Invitation_mail_sent_successfully",
  },
  {
    English: "Plan Headcount",
    French: "Effectifs du plan",
    Spanish: "Planificar plantilla",
    key: "Plan_Headcount",
  },
  {
    English: "Group Plans list for",
    French: "Liste des régimes collectifs pour",
    Spanish: "Lista de planes grupales para",
    key: "Group_Plans_list_for",
  },
  {
    English: "Bulk Plan Details",
    French: "Détails du plan de masse",
    Spanish: "Detalles del plan masivo",
    key: "Bulk_Plan_Details",
  },
  {
    English: "Quantity",
    French: "Quantité",
    Spanish: "Cantidad",
    key: "Quantity",
  },
  {
    English: "Provisioning",
    French: "Approvisionnement",
    Spanish: "Aprovisionamiento",
    key: "Provisioning",
  },
  {
    English: "Employee list",
    French: "Liste des employés",
    Spanish: "lista de empleados",
    key: "Employee_list",
  },
  {
    English: "suspended",
    French: "suspendu",
    Spanish: "suspendido",
    key: "suspended",
  },
  {
    English: "Incomplete",
    French: "Incomplet",
    Spanish: "Incompleto",
    key: "Incomplete",
  },
  {
    English: "Are you sure you want to change status",
    French: "Êtes-vous sûr de vouloir changer de statut ?",
    Spanish: "¿Estás seguro de que quieres cambiar el estado?",
    key: "Are_you_sure_you_want_to_change_status",
  },
  {
    English: "Proceed",
    French: "Procéder",
    Spanish: "Proceder",
    key: "Proceed",
  },
  {
    English: "plan activation date",
    French: "date d'activation du plan",
    Spanish: "fecha de activación del plan",
    key: "plan_activation_date",
  },
  {
    English: "Corporate admin email",
    French: "Courriel de l'administrateur de l'entreprise",
    Spanish: "Correo electrónico del administrador corporativo",
    key: "Corporate_admin_email",
  },
  {
    English: "Add member",
    French: "Ajouter un membre",
    Spanish: "Agregar miembro",
    key: "Add_member",
  },
  {
    English: "Please select atleast one group contact to send mail",
    French:
      "Veuillez sélectionner au moins un contact du groupe pour l'envoi du courrier.",
    Spanish: "Seleccione al menos un contacto de grupo para enviar correo",
    key: "Please_select_atleast_one_group_contact_to_send_mail",
  },
  {
    English: "Document",
    French: "Document",
    Spanish: "Documento",
    key: "Document",
  },
  {
    English: "Employee profiles",
    French: "Profils des employés",
    Spanish: "Perfiles de empleados",
    key: "Employee_profiles",
  },
  {
    English: "Effective Termination Date",
    French: "Date de résiliation effective",
    Spanish: "Fecha de terminación efectiva",
    key: "Effective_Termination_Date",
  },
  {
    English: "Last day of coverage",
    French: "Dernier jour de couverture",
    Spanish: "Último día de cobertura",
    key: "Last_day_of_coverage",
  },
  {
    English: "Refund Actual Amount",
    French: "Montant réel du remboursement",
    Spanish: "Monto real del reembolso",
    key: "Refund_Actual_Amount",
  },
  {
    English: "Filter By Status",
    French: "Filtrer par statut",
    Spanish: "Filtrar por estado",
    key: "Filter_By_Status",
  },
  {
    English: "Search here",
    French: "Rechercher ici",
    Spanish: "Busca aquí",
    key: "Search_here",
  },
  {
    English: "IGBMS ID",
    French: "Identifiant IGBMS",
    Spanish: "ID del IGBMS",
    key: "IGBMS_ID",
  },
  {
    English:
      "Plan enrollment date is-\nenrollment date is the earliest selection",
    French:
      "La date d'adhésion au régime est le \nLa date d'adhésion est la première sélection.",
    Spanish:
      "La fecha de inscripción del plan es- La fecha de inscripción es la primera selección",
    key: "Plan_enrollment_date_is_enrollment_date_is_the_earliest_selection",
  },
  {
    English: "Refund Based on Payments",
    French: "Remboursement basé sur les paiements",
    Spanish: "Reembolso basado en pagos",
    key: "Refund_Based_on_Payments",
  },
  {
    English: "Broker/Advisor Name",
    French: "Nom du courtier/conseiller",
    Spanish: "Nombre del corredor/asesor",
    key: "Broker_Advisor_Name",
  },
  {
    English: "First day without coverage",
    French: "Premier jour sans couverture",
    Spanish: "Primer día sin cobertura",
    key: "First_day_without_coverage",
  },
  {
    English: "Termination of Employment (No Longer Employed)",
    French: "Cessation d'emploi (Plus d'emploi)",
    Spanish: "Terminación del empleo (ya no está empleado)",
    key: "Termination_of_Employment_No_Longer_Employed",
  },
  {
    English: "Audit (Only for Test)",
    French: "Audit (uniquement pour le test)",
    Spanish: "Auditoría (solo para prueba)",
    key: "Audit_Only_for_Test",
  },
  {
    English: "Member cancelled at Staxbill",
    French: "Membre annulé à Staxbill",
    Spanish: "Miembro cancelado en Staxbill",
    key: "Member_cancelled_at_Staxbill",
  },
  {
    English: "Membership Id",
    French: "Identifiant de membre",
    Spanish: "Identificación de membresía",
    key: "Membership_Id",
  },
  {
    English: "Member is cancelled at IGBMS",
    French: "L'adhésion est annulée à l'IGBMS",
    Spanish: "Miembro cancelado en IGBMS",
    key: "Member_is_cancelled_at_IGBMS",
  },
  {
    English: "Move to Spousal Plan / Opted out of Benefits",
    French: "Passage au régime du conjoint / retrait des prestations",
    Spanish: "Pasar al plan conyugal / Optar por no recibir beneficios",
    key: "Move_to_Spousal_Plan_Opted_out_of_Benefits",
  },
  {
    English:
      "Greenshield termination is in progress. Please check mail for the update\n\n",
    French:
      "La résiliation du Greenshield est en cours. Veuillez consulter le courrier pour la mise à jour.",
    Spanish:
      "La terminación de Greenshield está en curso. Por favor, revise el correo para ver la actualización",
    key: "Greenshield_termination_is_in_progress_Please_check_mail_for_the_update",
  },
  {
    English:
      "Equitable termination is not possible as Cert. id is missing.Please handle it manually.A mail will be  sent with details, please check.",
    French:
      "La résiliation équitable n'est pas possible car l'identifiant du certificat est manquant. Veuillez le traiter manuellement. Un courrier sera envoyé avec les détails, veuillez vérifier.",
    Spanish:
      "La terminación equitativa no es posible ya que falta el ID de certificado. Por favor, manéjelo manualmente. Se enviará un correo electrónico con los detalles, por favor compruébelo.",
    key: "Equitable_termination_is_not_possible_as_Cert_id_is_missing_Please_handle_it_manually_A_mail_will_be_sent_with_details_please_check",
  },
  {
    English: "Expiry for the subscription with id is set successfully",
    French: "Expiration de l’abonnement avec id",
    Spanish:
      "La caducidad de la suscripción con ID se ha configurado correctamente",
    key: "Expiry_for_the_subscription_with_id_is_set_successfully",
  },
  {
    English: "Send access link to Member Portal for ?",
    French: "Envoyer le lien d'accès au portail des membres pour Z Suma Test ?",
    Spanish: "Enviar enlace de acceso al Portal de miembros para ?",
    key: "Send_access_link_to_Member_Portal_for",
  },
  {
    English: "Send Invite",
    French: "Envoyer une invitation",
    Spanish: "Enviar invitación",
    key: "Send_Invite",
  },
  {
    English: "Send portal access link to:",
    French: "Envoyez le lien d’accès au portail à :",
    Spanish: "Enviar enlace de acceso al portal a:",
    key: "Send_portal_access_link_to",
  },
  {
    English: "Invitation successfully sent to",
    French: "Invitation envoyée avec succès à",
    Spanish: "Invitación enviada exitosamente a",
    key: "Invitation_successfully_sent_to",
  },
  {
    English: "Select the following contacts to be CC'ed",
    French: "Sélectionnez les contacts suivants à mettre en copie",
    Spanish: "Seleccione los siguientes contactos para recibir CC",
    key: "Select_the_following_contacts_to_be_CC_ed",
  },
  {
    English: "Required backdated selection contact Administrator",
    French: "Contact de sélection antidaté requis Administrateur",
    Spanish: "Administrador de contacto de selección retroactivo requerido",
    key: "Required_backdated_selection_contact_Administrator",
  },
  {
    English: "enrollment date is the earliest selection",
    French: "la date d'inscription est la première sélection",
    Spanish: "la fecha de inscripción es la selección más temprana",
    key: "enrollment_date_is_the_earliest_selection",
  },
  {
    English: "Invoice Number",
    French: "Numéro de facture",
    Spanish: "Número de factura",
    key: "Invoice_Number",
  },
  {
    English: "Payment Status",
    French: "Statut de paiement",
    Spanish: "Estado del pago",
    key: "Payment_Status",
  },
  {
    English: "Monthly Premium",
    French: "Prime mensuelle",
    Spanish: "Prima Mensual",
    key: "Monthly_Premium",
  },
  {
    English: "No",
    French: "Non",
    Spanish: "No",
    key: "No",
  },
  {
    English: "Member Data",
    French: "Données des membres",
    Spanish: "Datos de miembro",
    key: "Member_Data",
  },
  {
    English: "Amount",
    French: "Montant",
    Spanish: "Cantidad",
    key: "Amount",
  },
  {
    English: "Invoice Id",
    French: "Numéro de facture",
    Spanish: "ID de factura",
    key: "Invoice_Id",
  },
  {
    English: "Yes",
    French: "Oui",
    Spanish: "Sí",
    key: "Yes",
  },
  {
    English: "Proceed With Smartchoice",
    French: "Continuez avec Smartchoice",
    Spanish: "Continuar con Smartchoice",
    key: "Proceed_With_Smartchoice",
  },
  {
    English: "Today is the earliest selection",
    French: "Aujourd'hui, c'est la première sélection",
    Spanish: "Hoy es la primera selección.",
    key: "Today_is_the_earliest_selection",
  },
  {
    English: "please enter valid email",
    French: "veuillez entrer une adresse email valide",
    Spanish: "por favor ingrese un correo electrónico válido",
    key: "please_enter_valid_email",
  },
  {
    English: "Can select from 3 months from the past",
    French: "Peut sélectionner parmi 3 mois dans le passé",
    Spanish: "Puede seleccionar entre 3 meses del pasado",
    key: "Can_select_from_3_months_from_the_past",
  },
  {
    English: "Duplicate Mail",
    French: "Courrier en double",
    Spanish: "Correo duplicado",
    key: "Duplicate_Mail",
  },
  {
    English: "Add New",
    French: "Ajouter un nouveau",
    Spanish: "Agregar nuevo",
    key: "Add_New",
  },
  {
    English: "Email",
    French: "Courriel",
    Spanish: "Correo Electrónico",
    key: "Email",
  },
  {
    English: "Plan enrollment date is-\n",
    French: "La date d’inscription au plan est-",
    Spanish: "La fecha de inscripción del plan es-",
    key: "Plan_enrollment_date_is",
  },
  {
    English: "Error in setting up expiry for the subscription with id:",
    French:
      "Erreur lors de la configuration de l’expiration de l’abonnement avec id :",
    Spanish: "Error al configurar el vencimiento de la suscripción con ID:",
    key: "Error_in_setting_up_expiry_for_the_subscription_with_id",
  },
  {
    English: "Proceed With Greenshield",
    French: "Continuer avec Greenshield",
    Spanish: "Continuar con Greenshield",
    key: "Proceed_With_Greenshield",
  },
  {
    English: "Corporate Information",
    French: "Informations sur l'entreprise",
    Spanish: "Información corporativa",
    key: "Corporate_Information",
  },
  {
    English: "Brokers",
    French: "Courtiers",
    Spanish: "Corredores",
    key: "Brokers",
  },
  {
    English: "Select Profile",
    French: "Sélectionnez un profil",
    Spanish: "Seleccionar perfil",
    key: "Select_Profile",
  },
  {
    English: "Name of Corporation",
    French: "Nom de la société",
    Spanish: "Nombre de la Corporación",
    key: "Name_of_Corporation",
  },
  {
    English: "Policy Start Date",
    French: "Date de début de la police",
    Spanish: "Fecha de inicio de la póliza",
    key: "Policy_Start_Date",
  },
  {
    English: "Provincial offices in Operation",
    French: "Bureaux provinciaux en opération",
    Spanish: "Oficinas provinciales en Operación",
    key: "Provincial_offices_in_Operation",
  },
  {
    English: "Street address",
    French: "Adresse de la rue",
    Spanish: "dirección postal",
    key: "Street_address",
  },
  {
    English: "Unit/Apt/Suite",
    French: "Unité/Appartement/Suite",
    Spanish: "Unidad/Apto/Suite",
    key: "Unit_Apt_Suite",
  },
  {
    English: "Street address line 2",
    French: "Adresse postale, ligne 2",
    Spanish: "Línea de dirección 2",
    key: "Street_address_line_2",
  },
  {
    English: "Country",
    French: "Pays",
    Spanish: "País",
    key: "Country",
  },
  {
    English: "Please enter Corporation name",
    French: "Veuillez entrer le nom de la société",
    Spanish: "Por favor ingrese el nombre de la corporación",
    key: "Please_enter_Corporation_name",
  },
  {
    English: "Please select Policy start Date",
    French: "Veuillez sélectionner la date de début de la police",
    Spanish: "Por favor seleccione Fecha de inicio de la póliza",
    key: "Please_select_Policy_start_Date",
  },
  {
    English: "Please select Atleast one Province",
    French: "Veuillez sélectionner au moins une province",
    Spanish: "Por favor seleccione Al menos una Provincia",
    key: "Please_select_Atleast_one_Province",
  },
  {
    English: "Please select country",
    French: "Veuillez sélectionner un pays",
    Spanish: "Por favor seleccione el país",
    key: "Please_select_country",
  },
  {
    English: "Please select Province",
    French: "Veuillez sélectionner une province",
    Spanish: "Por favor seleccione Provincia",
    key: "Please_select_Province",
  },
  {
    English: "Corporation name should be 2 characters",
    French: "Le nom de la société doit comporter 2 caractères",
    Spanish: "El nombre de la corporación debe tener 2 caracteres.",
    key: "Corporation_name_should_be_2_characters",
  },
  {
    English: "Group Contacts",
    French: "Contacts du groupe",
    Spanish: "Contactos del grupo",
    key: "Group_Contacts",
  },
  {
    English: "First name should be 3 characters",
    French: "Le prénom doit être composé de 3 caractères",
    Spanish: "El nombre debe tener 3 caracteres.",
    key: "First_name_should_be_3_characters",
  },
  {
    English: "Please enter Last name",
    French: "Veuillez saisir votre nom de famille",
    Spanish: "Por favor ingrese el apellido",
    key: "Please_enter_Last_name",
  },
  {
    English: "Last name should be 2 characters",
    French: "Le nom de famille doit comporter 2 caractères",
    Spanish: "El apellido debe tener 2 caracteres.",
    key: "Last_name_should_be_2_characters",
  },
  {
    English: "Phone Number",
    French: "Numéro de Téléphone",
    Spanish: "Número de Teléfono",
    key: "Phone_Number",
  },
  {
    English: "Please enter phone number",
    French: "Veuillez entrer le numéro de téléphone",
    Spanish: "Por favor ingrese el número de teléfono",
    key: "Please_enter_phone_number",
  },
  {
    English: "Phone number minimum of 10 digits",
    French: "Numéro de téléphone à 10 chiffres minimum",
    Spanish: "Número de teléfono mínimo de 10 dígitos",
    key: "Phone_number_minimum_of_10_digits",
  },
  {
    English: "Role",
    French: "Rôle",
    Spanish: "Role",
    key: "Role",
  },
  {
    English: "Please select role",
    French: "Veuillez sélectionner un rôle",
    Spanish: "Por favor seleccione rol",
    key: "Please_select_role",
  },
  {
    English: "Edit group contact",
    French: "Modifier le contact du groupe",
    Spanish: "Editar contacto de grupo",
    key: "Edit_group_contact",
  },
  {
    English: "Add More",
    French: "Ajouter plus",
    Spanish: "Añadir más",
    key: "Add_More",
  },
  {
    English: "Add Group contact",
    French: "Ajouter un contact au groupe",
    Spanish: "Agregar contacto de grupo",
    key: "Add_Group_contact",
  },
  {
    English: "Are you sure you want to delete this group contact?",
    French: "Êtes-vous sûr de vouloir supprimer ce contact de groupe ?",
    Spanish: "¿Estás seguro de que deseas eliminar este contacto de grupo?",
    key: "Are_you_sure_you_want_to_delete_this_group_contact",
  },
  {
    English: "Enrollment start date for new hires",
    French: "Date de début d’inscription pour les nouvelles recrues",
    Spanish: "Fecha de inicio de inscripción para nuevas incorporaciones",
    key: "Enrollment_start_date_for_new_hires",
  },
  {
    English: "Waiting period for new hires",
    French: "Délai d'attente pour les nouvelles recrues",
    Spanish: "Periodo de espera para nuevas contrataciones",
    key: "Waiting_period_for_new_hires",
  },
  {
    English: "None",
    French: "Aucun",
    Spanish: "Ninguno",
    key: "None",
  },
  {
    English: "Three Months",
    French: "Trois mois",
    Spanish: "tres meses",
    key: "Three_Months",
  },
  {
    English: "Six Months",
    French: "Six mois",
    Spanish: "Seis meses",
    key: "Six_Months",
  },
  {
    English: "Custom",
    French: "Coutume",
    Spanish: "Costumbre",
    key: "Custom",
  },
  {
    English: "Months",
    French: "Mois",
    Spanish: "Meses",
    key: "Months",
  },
  {
    English: "Please enter months",
    French: "Veuillez entrer les mois",
    Spanish: "Por favor ingrese meses",
    key: "Please_enter_months",
  },
  {
    English: "Please enter valid number of months",
    French: "Veuillez entrer un nombre de mois valide",
    Spanish: "Por favor ingrese un número válido de meses",
    key: "Please_enter_valid_number_of_months",
  },
  {
    English: "Waiting period for Employees on initial sign up",
    French:
      "Délai d'attente pour les employés lors de leur première inscription",
    Spanish: "Período de espera para los empleados en el registro inicial",
    key: "Waiting_period_for_Employees_on_initial_sign_up",
  },
  {
    English: "Please Select waiting period for employees on initial signup",
    French:
      "Veuillez sélectionner la période d'attente pour les employés lors de l'inscription initiale",
    Spanish:
      "Seleccione el período de espera para los empleados en el registro inicial",
    key: "Please_Select_waiting_period_for_employees_on_initial_signup",
  },
  {
    English: "Payment Information",
    French: "Informations de paiement",
    Spanish: "Información de pago",
    key: "Payment_Information",
  },
  {
    English: "Pre-Authorized Debit",
    French: "Débit préautorisé",
    Spanish: "Débito Preautorizado",
    key: "Pre_Authorized_Debit",
  },
  {
    English: "Credit Card",
    French: "Carte de crédit",
    Spanish: "Tarjeta de crédito",
    key: "Credit_Card",
  },
  {
    English: "Corporate Logo",
    French: "Logo d'entreprise",
    Spanish: "Logotipo Corporativo",
    key: "Corporate_Logo",
  },
  {
    English: "Click to upload COMPANY LOGO Max. 300x100 px .png,.jpg",
    French:
      "Cliquez pour télécharger le logo de l'entreprise Max. 300x100px .png,.jpg",
    Spanish:
      "Haga clic para cargar el LOGOTIPO DE LA EMPRESA Máx. 300x100 píxeles.png,.jpg",
    key: "Click_to_upload_COMPANY_LOGO_Max_300x100_px_png_jpg",
  },
  {
    English: "Delete Logo",
    French: "Supprimer le logo",
    Spanish: "Eliminar logotipo",
    key: "Delete_Logo",
  },
  {
    English: "Show Employer Name for Signups",
    French: "Afficher le nom de l'employeur pour les inscriptions",
    Spanish: "Mostrar el nombre del empleador para las inscripciones",
    key: "Show_Employer_Name_for_Signups",
  },
  {
    English: "Auto-select plans for Employee",
    French: "Plans de sélection automatique pour les employés",
    Spanish: "Planes de selección automática para empleados",
    key: "Auto_select_plans_for_Employee",
  },
  {
    English: "GroupBenefitz WalletTM for employees",
    French: "GroupBenefitz WalletTM pour les employés",
    Spanish: "GroupBenefitz WalletTM para empleados",
    key: "GroupBenefitz_WalletTM_for_employees",
  },
  {
    English: "Create classification tiers of coverage",
    French: "Créer des niveaux de couverture de classification",
    Spanish: "Crear niveles de clasificación de cobertura",
    key: "Create_classification_tiers_of_coverage",
  },
  {
    English: "Please select wallet configuration",
    French: "Veuillez sélectionner la configuration du portefeuille",
    Spanish: "Por favor seleccione la configuración de la billetera",
    key: "Please_select_wallet_configuration",
  },
  {
    English: "Please select tier configuration",
    French: "Veuillez sélectionner la configuration du niveau",
    Spanish: "Seleccione la configuración de niveles",
    key: "Please_select_tier_configuration",
  },
  {
    English: "No. of Employees",
    French: "Nombre d'employés",
    Spanish: "No. de empleados",
    key: "No_of_Employees",
  },
  {
    English: "Save & Next",
    French: "Enregistrer et suivant",
    Spanish: "Guardar y siguiente",
    key: "Save_Next",
  },
  {
    English: "Corporate Level Group Plans",
    French: "Régimes collectifs au niveau de l'entreprise",
    Spanish: "Planes grupales a nivel corporativo",
    key: "Corporate_Level_Group_Plans",
  },
  {
    English: "GroupBenefitz Home & Auto Protection Package",
    French: "Forfait de protection habitation et automobile GroupBenefitz",
    Spanish:
      "Paquete de protección para el hogar y el automóvil de GroupBenefitz",
    key: "GroupBenefitz_Home_Auto_Protection_Package",
  },
  {
    English: "Core Plans (Premium paid 100% by employer).",
    French: "Plans de base (prime payée à 100 % par l'employeur).",
    Spanish: "Planes Básicos (Prima pagada 100% por el empleador).",
    key: "Core_Plans_Premium_paid_100_by_employer",
  },
  {
    English: "Corporate Level Group Plans",
    French: "Régimes collectifs au niveau de l'entreprise",
    Spanish: "Planes grupales a nivel corporativo",
    key: "Corporate_Level_Group_Plans",
  },
  {
    English:
      "Upgrade Plans (Premium difference paid by employee through payroll deduction).",
    French:
      "Plans de mise à niveau (différence de prime payée par l'employé par retenue sur salaire).",
    Spanish:
      "Planes de Upgrade (Diferencia de prima pagada por el empleado mediante deducción de nómina).",
    key: "Upgrade_Plans_Premium_difference_paid_by_employee_through_payroll_deduction",
  },
  {
    English: "Voluntary Plans (Premium paid 100% by employee directly).",
    French:
      "Régimes volontaires (prime payée à 100 % directement par l'employé).",
    Spanish:
      "Planes Voluntarios (Prima pagada 100% directamente por el empleado).",
    key: "Voluntary_Plans_Premium_paid_100_by_employee_directly",
  },
  {
    English: "Enabled?",
    French: "Activé?",
    Spanish: "¿Activado?",
    key: "Enabled",
  },
  {
    English: "Please select one voluntary plan",
    French: "Veuillez sélectionner un plan volontaire",
    Spanish: "Por favor seleccione un plan voluntario",
    key: "Please_select_one_voluntary_plan",
  },
  {
    English:
      "Please select at least one plan which is paid by the Company or include a Corporate Bulk Plan",
    French:
      "Veuillez sélectionner au moins un forfait payé par l'entreprise ou inclure un forfait d'entreprise en gros.",
    Spanish:
      "Seleccione al menos un plan pagado por la empresa o incluya un plan corporativo masivo",
    key: "Please_select_at_least_one_plan_which_is_paid_by_the_Company_or_include_a_Corporate_Bulk_Plan",
  },
  {
    English:
      "Plan is in Unpublished State.Selecting this plan will not be available on the signup forms.",
    French:
      "Le plan est dans un état non publié. La sélection de ce plan ne sera pas disponible sur les formulaires d'inscription.",
    Spanish:
      "El plan se encuentra en estado no publicado. Seleccionar este plan no estará disponible en los formularios de inscripción.",
    key: "Plan_is_in_Unpublished_State_Selecting_this_plan_will_not_be_available_on_the_signup_forms",
  },
  {
    English: "Please enter head count for",
    French: "Veuillez saisir le nombre d'employés pour",
    Spanish: "Por favor ingrese el número de personas para",
    key: "Please_enter_head_count_for",
  },
  {
    English: "Please enter head count",
    French: "Veuillez entrer le nombre de personnes",
    Spanish: "Por favor ingrese el número de personas",
    key: "Please_enter_head_count",
  },
  {
    English: "Template",
    French: "Modèle",
    Spanish: "Plantilla",
    key: "Template",
  },
  {
    English: "Starter",
    French: "Démarreur",
    Spanish: "Motor de arranque",
    key: "Starter",
  },
  {
    English: "Standard",
    French: "Standard",
    Spanish: "Estándar",
    key: "Standard",
  },
  {
    English: "Executive",
    French: "Exécutif",
    Spanish: "Ejecutivo",
    key: "Executive",
  },
  {
    English: "Custom",
    French: "Coutume",
    Spanish: "Costumbre",
    key: "Custom",
  },
  {
    English: "Add Employees to Health & Wellness Plans",
    French: "Ajouter des employés aux plans de santé et de bien-être",
    Spanish: "Agregar empleados a planes de salud y bienestar",
    key: "Add_Employees_to_Health_Wellness_Plans",
  },
  {
    English: "Max Employees",
    French: "Nombre maximum d'employés",
    Spanish: "Empleados máximos",
    key: "Max_Employees",
  },
  {
    English: "Employee Count",
    French: "Nombre d'employés",
    Spanish: "Recuento de empleados",
    key: "Employee_Count",
  },
  {
    English: "Download Template",
    French: "Télécharger le modèle",
    Spanish: "Descargar plantilla",
    key: "Download_Template",
  },
  {
    English: "Upload Employee List",
    French: "Télécharger la liste des employés",
    Spanish: "Cargar lista de empleados",
    key: "Upload_Employee_List",
  },
  {
    English: "Add",
    French: "Ajouter",
    Spanish: "Agregar",
    key: "Add",
  },
  {
    English: "Type",
    French: "Taper",
    Spanish: "Tipo",
    key: "Type",
  },
  {
    English: "Date of Hire",
    French: "Date d’embauche",
    Spanish: "Fecha de contratación",
    key: "Date_of_Hire",
  },
  {
    English: "Prov of Employment",
    French: "Preuve d'emploi",
    Spanish: "Prueba de Empleo",
    key: "Prov_of_Employment",
  },
  {
    English: "Date of Birth",
    French: "Date de naissance",
    Spanish: "Fecha de nacimiento",
    key: "Date_of_Birth",
  },
  {
    English: "Gender",
    French: "Genre",
    Spanish: "Género",
    key: "Gender",
  },
  {
    English: "Add Employee For Individual Plans",
    French: "Ajouter un employé pour les plans individuels",
    Spanish: "Agregar empleado para planes individuales",
    key: "Add_Employee_For_Individual_Plans",
  },
  {
    English: "Employee ID",
    French: "ID d'employé",
    Spanish: "ID de empleado",
    key: "Employee_ID",
  },
  {
    English: "Date of Hire",
    French: "Date d'embauche",
    Spanish: "Fecha de contratación",
    key: "Date_of_Hire",
  },
  {
    English: "Province of Employment",
    French: "Province d'emploi",
    Spanish: "Provincia de Empleo",
    key: "Province_of_Employment",
  },
  {
    English: "Marital Status",
    French: "État civil",
    Spanish: "Estado civil",
    key: "Marital_Status",
  },
  {
    English: "Edit Employee",
    French: "Modifier un employé",
    Spanish: "Editar empleado",
    key: "Edit_Employee",
  },
  {
    English: "Are you sure you want to delete this employee?",
    French: "Êtes-vous sûr de vouloir supprimer cet employé ?",
    Spanish: "¿Está seguro de que desea eliminar a este empleado?",
    key: "Are_you_sure_you_want_to_delete_this_employee",
  },
  {
    English: "Setup Status",
    French: "État de la configuration",
    Spanish: "Estado de configuración",
    key: "Setup_Status",
  },
  {
    English: "Employees Enrolled",
    French: "Employés inscrits",
    Spanish: "Empleados inscritos",
    key: "Employees_Enrolled",
  },
  {
    English: "Send to Company Administrator",
    French: "Envoyer à l'administrateur de l'entreprise",
    Spanish: "Enviar al administrador de la empresa",
    key: "Send_to_Company_Administrator",
  },
  {
    English: "Employee ID can't be empty",
    French: "Le numéro d'employé ne peut pas être vide",
    Spanish: "El ID de empleado no puede estar vacío",
    key: "Employee_ID_can_t_be_empty",
  },
  {
    English: "Expected Premium",
    French: "Prime attendue",
    Spanish: "Prima esperada",
    key: "Expected_Premium",
  },
  {
    English: "Deleted successfully",
    French: "Supprimé avec succès",
    Spanish: "Eliminado exitosamente",
    key: "Deleted_successfully",
  },
  {
    English:
      "The request body is invalid.See error object 'details` property for more info.",
    French:
      "Le corps de la requête n'est pas valide. Consultez la propriété « détails » de l'objet d'erreur pour plus d'informations.",
    Spanish:
      'El cuerpo de la solicitud no es válido. Consulte la propiedad "detalles" del objeto de error para obtener más información.',
    key: "The_request_body_is_invalid_See_error_object_details_property_for_more_info",
  },
  {
    English:
      "Corporate profile created and sent to corporate plan administrators for approval",
    French:
      "Profil d'entreprise créé et envoyé aux administrateurs du plan d'entreprise pour approbation",
    Spanish:
      "Perfil corporativo creado y enviado a los administradores del plan corporativo para su aprobación.",
    key: "Corporate_profile_created_and_sent_to_corporate_plan_administrators_for_approval",
  },
  {
    English: "Profile",
    French: "Profil",
    Spanish: "Perfil",
    key: "Profile",
  },
  {
    English: "Select a subdomain for the corporate insurance portal",
    French:
      "Sélectionnez un sous-domaine pour le portail d'assurance d'entreprise",
    Spanish: "Seleccione un subdominio para el portal de seguros corporativos",
    key: "Select_a_subdomain_for_the_corporate_insurance_portal",
  },
  {
    English: "Signuplink",
    French: "Lien d'inscription",
    Spanish: "Enlace de registro",
    key: "Signuplink",
  },
  {
    English: "CORPORATE Customer Name",
    French: "Nom du client ENTREPRISE",
    Spanish: "Nombre del cliente CORPORATIVO",
    key: "CORPORATE_Customer_Name",
  },
  {
    English: "Account Status:Incomplete",
    French: "Statut du compte : incomplet",
    Spanish: "Estado de la cuenta: incompleta",
    key: "Account_Status_Incomplete",
  },
  {
    English: "Incomplete:Completed",
    French: "Incomplet : terminé",
    Spanish: "Incompleto: Completado",
    key: "Incomplete_Completed",
  },
  {
    English: "First name must not exceed 20 characters",
    French: "Le prénom ne doit pas dépasser 20 caractères",
    Spanish: "El nombre no debe exceder los 20 caracteres",
    key: "First_name_must_not_exceed_20_characters",
  },
  {
    English: "Please enter other role",
    French: "Veuillez entrer un autre rôle",
    Spanish: "Por favor ingrese otro rol",
    key: "Please_enter_other_role",
  },
  {
    English: "Please save Group Contact",
    French: "Veuillez enregistrer le contact du groupe",
    Spanish: "Por favor guarde el contacto del grupo",
    key: "Please_save_Group_Contact",
  },
  {
    English: "Plan Administrator",
    French: "Administrateur du régime",
    Spanish: "Administrador del plan",
    key: "Plan_Administrator",
  },
  {
    English: "Other",
    French: "Autre",
    Spanish: "Otro",
    key: "Other",
  },
  {
    English: "System Administrator",
    French: "Administrateur du système",
    Spanish: "Administrador del sistema",
    key: "System_Administrator",
  },
  {
    English: "Accountant",
    French: "Comptable",
    Spanish: "Contador",
    key: "Accountant",
  },
  {
    English: "Save",
    French: "Enregistrer",
    Spanish: "Guardar",
    key: "Save",
  },
  {
    English: "Wellness Champion",
    French: "Championne du bien-être",
    Spanish: "Campeón de bienestar",
    key: "Wellness_Champion",
  },
  {
    English: "Last name must not exceed 20 characters",
    French: "Le nom de famille ne doit pas dépasser 20 caractères",
    Spanish: "El apellido no debe exceder los 20 caracteres.",
    key: "Last_name_must_not_exceed_20_characters",
  },
  {
    English: "Others",
    French: "Autres",
    Spanish: "Otros",
    key: "Others",
  },
  {
    English:
      "Numerics, Special Characters, Blank Spaces are not  allowed in First Name.",
    French:
      "Los números, los caracteres especiales y los espacios en blanco no están permitidos en el nombre.",
    Spanish: "Les chiffres, les caractères spéciaux et les espaces ne sont pas",
    key: "Numerics_Special_Characters_Blank_Spaces_are_not_allowed_in_First_Name",
  },
  {
    English: "Phone number maximum of 10 digits",
    French: "Numéro de téléphone de 10 chiffres maximum",
    Spanish: "Número de teléfono máximo de 10 dígitos",
    key: "Phone_number_maximum_of_10_digits",
  },
  {
    English: "Invoice Monthly",
    French: "Facture mensuelle",
    Spanish: "Factura Mensual",
    key: "Invoice_Monthly",
  },
  {
    English: "Please select payment information",
    French: "Veuillez sélectionner les informations de paiement",
    Spanish: "Por favor seleccione información de pago",
    key: "Please_select_payment_information",
  },
  {
    English: "Please upload corporate logo",
    French: "Veuillez télécharger le logo de l'entreprise",
    Spanish: "Por favor suba el logo corporativo",
    key: "Please_upload_corporate_logo",
  },
  {
    English: "Please enter no.of employees\n ",
    French: "Introduzca el número de empleados",
    Spanish: "Veuillez entrer le nombre d’employés",
    key: "Please_enter_no_of_employees",
  },
  {
    English: "Single",
    French: "Célibataire",
    Spanish: "Soltero",
    key: "Single",
  },
  {
    English: "Couple",
    French: "Couple",
    Spanish: "Pareja",
    key: "Couple",
  },
  {
    English: "Family",
    French: "Famille",
    Spanish: "Familia",
    key: "Family",
  },
  {
    English: "GroupBenefitz Wallet",
    French: "Portefeuille GroupBenefitz",
    Spanish: "Cartera GroupBenefitz",
    key: "GroupBenefitz_Wallet",
  },
  {
    English: "Classification Tiers",
    French: "Niveaux de classification",
    Spanish: "Niveles de clasificación",
    key: "Classification_Tiers",
  },
  {
    English: "Annual Income",
    French: "Revenu annuel",
    Spanish: "Renta anual",
    key: "Annual_Income",
  },
  {
    English: "Please enter Employee ID",
    French: "Veuillez saisir le numéro d'identification de l'employé",
    Spanish: "Por favor ingrese el ID del empleado",
    key: "Please_enter_Employee_ID",
  },
  {
    English: "First name must not exceed 20 characters",
    French: "Le prénom ne doit pas dépasser 20 caractères",
    Spanish: "El nombre no debe exceder los 20 caracteres",
    key: "First_name_must_not_exceed_20_characters",
  },
  {
    English: "Please select date of hire",
    French: "Veuillez sélectionner la date de location",
    Spanish: "Por favor seleccione la fecha de contratación",
    key: "Please_select_date_of_hire",
  },
  {
    English:
      "Date of hire Shouldn't allow numbers, special characters and blank spaces",
    French:
      "Date d'embauche Ne doit pas autoriser de chiffres, de caractères spéciaux et d'espaces vides",
    Spanish:
      "Fecha de contratación No debe permitir números, caracteres especiales ni espacios en blanco.",
    key: "Date_of_hire_Shouldn_t_allow_numbers_special_characters_and_blank_spaces",
  },
  {
    English: "Job Title",
    French: "Titre d'emploi",
    Spanish: "Título profesional",
    key: "Job_Title",
  },
  {
    English: "Please enter occupation",
    French: "Veuillez entrer la profession",
    Spanish: "Por favor ingrese la ocupación",
    key: "Please_enter_occupation",
  },
  {
    English: "Job title not allow numbers, special characters and blank spaces",
    French:
      "Le titre du poste n'autorise pas les chiffres, les caractères spéciaux et les espaces vides",
    Spanish:
      "El puesto de trabajo no permite números, caracteres especiales ni espacios en blanco.",
    key: "Job_title_not_allow_numbers_special_characters_and_blank_spaces",
  },
  {
    English: "Please select date of hire",
    French: "Veuillez sélectionner la date d’embauche",
    Spanish: "Por favor, seleccione la fecha de contratación",
    key: "Please_select_date_of_hire",
  },
  {
    English:
      "Date of birth Shouldn't allow numbers, special characters and blank spaces",
    French:
      "Date de naissance Ne doit pas autoriser les chiffres, les caractères spéciaux et les espaces",
    Spanish:
      "Fecha de nacimiento No debe permitir números, caracteres especiales ni espacios en blanco.",
    key: "Date_of_birth_Shouldn_t_allow_numbers_special_characters_and_blank_spaces",
  },
  {
    English: "Registraion age must be greater than 16",
    French: "L'âge d'inscription doit être supérieur à 16 ans",
    Spanish: "La edad de registro debe ser mayor de 16 años.",
    key: "Registraion_age_must_be_greater_than_16",
  },
  {
    English: "Registraion age must be less than 60",
    French: "L'âge d'inscription doit être inférieur à 60 ans",
    Spanish: "La edad de registro debe ser inferior a 60 años.",
    key: "Registraion_age_must_be_less_than_60",
  },
  {
    English: "Male",
    French: "Mâle",
    Spanish: "Masculino",
    key: "Male",
  },
  {
    English: "Female",
    French: "Femelle",
    Spanish: "Femenino",
    key: "Female",
  },
  {
    English: "Non-Binary",
    French: "Non binaire",
    Spanish: "No binario",
    key: "Non_Binary",
  },
  {
    English: "Undisclosed",
    French: "Non divulgué",
    Spanish: "No revelado",
    key: "Undisclosed",
  },
  {
    English: "Please select gender",
    French: "Veuillez sélectionner le sexe",
    Spanish: "Por favor seleccione género",
    key: "Please_select_gender",
  },
  {
    English: " Please select Marital Status",
    French: "Por favor, seleccione Estado civil",
    Spanish: "Veuillez sélectionner l’état civil",
    key: "Please_select_Marital_Status",
  },
  {
    English: " Annual Income",
    French: "Ingresos Anuales",
    Spanish: "Revenu annuel",
    key: "Annual_Income",
  },
  {
    English: " Please enter annual income",
    French: "Por favor, introduzca los ingresos anuales",
    Spanish: "Veuillez entrer le revenu annuel",
    key: "Please_enter_annual_income",
  },
  {
    English:
      " Annual Income Shouldn't allow numbers, special characters and blank spaces",
    French:
      "Ingresos anuales No debe permitir números, caracteres especiales ni espacios en blanco",
    Spanish:
      "Le revenu annuel ne doit pas autoriser les chiffres, les caractères spéciaux et les espaces vides",
    key: "Annual_Income_Shouldn_t_allow_numbers_special_characters_and_blank_spaces",
  },
  {
    English: " Close",
    French: "Cerrar",
    Spanish: "Fermer",
    key: "Close",
  },
  {
    English: " Please enter Employee ID",
    French: "Introduzca el ID de empleado",
    Spanish: "Veuillez saisir l’identifiant de l’employé",
    key: "Please_enter_Employee_ID",
  },
  {
    English: "Please select profile",
    French: "Veuillez sélectionner un profil",
    Spanish: "Por favor seleccione perfil",
    key: "Please_select_profile",
  },
  {
    English: "Corporation name must not exceed 255 characters",
    French: "Le nom de la société ne doit pas dépasser 255 caractères",
    Spanish: "El nombre de la corporación no debe exceder los 255 caracteres.",
    key: "Corporation_name_must_not_exceed_255_characters",
  },
  {
    English: "Special Characters not allowed in corporation name.",
    French: "Caractères spéciaux non autorisés dans le nom de la société.",
    Spanish:
      "Caracteres especiales no permitidos en el nombre de la corporación.",
    key: "Special_Characters_not_allowed_in_corporation_name",
  },
  {
    English:
      "Special Characters, Blank Spaces are not allowed in street address.",
    French:
      "Les caractères spéciaux et les espaces vides ne sont pas autorisés dans l'adresse postale.",
    Spanish:
      "No se permiten caracteres especiales ni espacios en blanco en la dirección postal.",
    key: "Special_Characters_Blank_Spaces_are_not_allowed_in_street_address",
  },
  {
    English: "Please select",
    French: "Veuillez sélectionner",
    Spanish: "Por favor seleccione",
    key: "Please_select",
  },
  {
    English: "Please select",
    French: "Veuillez sélectionner",
    Spanish: "Por favor, seleccionePor favor, seleccione",
    key: "Please_select",
  },
  {
    English: "Special Characters, Blank Spaces are not allowed in city",
    French:
      "Les caractères spéciaux et les espaces vides ne sont pas autorisés en ville",
    Spanish:
      "No se permiten caracteres especiales ni espacios en blanco en la ciudad.",
    key: "Special_Characters_Blank_Spaces_are_not_allowed_in_city",
  },
  {
    English:
      "Last Name Shouldn't allow numbers, special characters and blank spaces",
    French:
      "Nom de famille Ne doit pas autoriser les chiffres, les caractères spéciaux et les espaces",
    Spanish:
      "El apellido no debe permitir números, caracteres especiales ni espacios en blanco.",
    key: "Last_Name_Shouldn_t_allow_numbers_special_characters_and_blank_spaces",
  },
  {
    English: "Please select date of birth",
    French: "Veuillez sélectionner la date de naissance",
    Spanish: "Por favor seleccione fecha de nacimiento",
    key: "Please_select_date_of_birth",
  },
  {
    English:
      "First Name Shouldn't allow numbers, special characters and blank spaces",
    French:
      "Prénom Ne doit pas autoriser les chiffres, les caractères spéciaux et les espaces",
    Spanish:
      "El nombre no debe permitir números, caracteres especiales ni espacios en blanco.",
    key: "First_Name_Shouldn_t_allow_numbers_special_characters_and_blank_spaces",
  },
  {
    English: "Existing Emails",
    French: "E-mails existants",
    Spanish: "Correos electrónicos existentes",
    key: "Existing_Emails",
  },
  {
    English: "Special Characters, Blank Spaces are not allowed in city.",
    French:
      "Les caractères spéciaux et les espaces vides ne sont pas autorisés en ville.",
    Spanish:
      "No se permiten caracteres especiales ni espacios en blanco en la ciudad.",
    key: "Special_Characters_Blank_Spaces_are_not_allowed_in_city",
  },
  {
    English: "Full Year Allotment",
    French: "Allocation pour l'année complète",
    Spanish: "Asignación para todo el año",
    key: "Full_Year_Allotment",
  },
  {
    English: "Pro-Rated",
    French: "Au prorata",
    Spanish: "Prorrateado",
    key: "Pro_Rated",
  },
  {
    English: "Health Spending Account (non-taxable)",
    French: "Compte dépenses-santé (non imposable)",
    Spanish: "Cuenta de gastos de salud (no sujeta a impuestos)",
    key: "Health_Spending_Account_non_taxable",
  },
  {
    English: "State",
    French: "État",
    Spanish: "Estado",
    key: "State",
  },
  {
    English: "Zip Code",
    French: "Code postal",
    Spanish: "Código postal",
    key: "Zip_Code",
  },
  {
    English: "Both",
    French: "Les deux",
    Spanish: "Ambos",
    key: "Both",
  },
  {
    English: "Wellness Spending Account (taxable)",
    French: "Compte de dépenses bien-être (imposable)",
    Spanish: "Cuenta de gastos de bienestar (sujeta a impuestos)",
    key: "Wellness_Spending_Account_taxable",
  },
  {
    English: "Configure",
    French: "Configurer",
    Spanish: "Configurar",
    key: "Configure",
  },
  {
    English: "Set up group GroupBenefitz WalletTM for employees",
    French: "Créer un groupe GroupBenefitz WalletTM pour les employés",
    Spanish: "Configurar el grupo GroupBenefitz WalletTM para empleados",
    key: "Set_up_group_GroupBenefitz_WalletTM_for_employees",
  },
  {
    English: "Health and Wellness Spending Accounts",
    French: "Comptes de dépenses de santé et de bien-être",
    Spanish: "Cuentas de gastos de salud y bienestar",
    key: "Health_and_Wellness_Spending_Accounts",
  },
  {
    English: "Roll over of Unused GroupBenefitz Wallet Funds",
    French: "Reconduction des fonds du portefeuille GroupBenefitz inutilisés",
    Spanish: "Transferencia de fondos de billetera GroupBenefitz no utilizados",
    key: "Roll_over_of_Unused_GroupBenefitz_Wallet_Funds",
  },
  {
    English: "Health and Wellness Spending Accounts",
    French: "Comptes de dépenses de santé et de bien-être",
    Spanish: "Cuentas de Gastos en Salud y Bienestar",
    key: "Health_and_Wellness_Spending_Accounts",
  },
  {
    English: "Roll over unused employee's limit to the next calendar year?",
    French:
      "Reporter la limite inutilisée de l'employé à l'année civile suivante ?",
    Spanish:
      "¿Transferir el límite de empleados no utilizados al siguiente año calendario?",
    key: "Roll_over_unused_employee_s_limit_to_the_next_calendar_year",
  },
  {
    English: "No (recommended)",
    French: "Non (recommandé)",
    Spanish: "No (recomendado)",
    key: "No_recommended",
  },
  {
    English: "How does the company want to pay for the service?",
    French: "Comment l’entreprise souhaite-t-elle payer pour le service ?",
    Spanish: "¿Cómo quiere la empresa pagar el servicio?",
    key: "How_does_the_company_want_to_pay_for_the_service",
  },
  {
    English: "Pre-Funded (Monthly)",
    French: "Préfinancé (mensuel)",
    Spanish: "Prefinanciado (mensual)",
    key: "Pre_Funded_Monthly",
  },
  {
    English: "(total annual limit for all staff + 10% + tax divided by 12)",
    French:
      "(plafond annuel total pour tout le personnel + 10 % + taxe divisé par 12)",
    Spanish:
      "(límite anual total para todo el personal + 10% + impuestos dividido por 12)",
    key: "total_annual_limit_for_all_staff_10_tax_divided_by_12",
  },
  {
    English: "Pre-Funded (Quarterly)",
    French: "Préfinancé (trimestriel)",
    Spanish: "Prefinanciado (trimestral)",
    key: "Pre_Funded_Quarterly",
  },
  {
    English: "(total annual limit for all staff + 10% + tax divided by 4)",
    French:
      "(plafond annuel total pour tout le personnel + 10% + taxe divisé par 4)",
    Spanish:
      "(límite anual total para todo el personal + 10% + impuestos dividido por 4)",
    key: "total_annual_limit_for_all_staff_10_tax_divided_by_4",
  },
  {
    English: "Pre-Funded (Semi-Yearly)",
    French: "Préfinancé (semestriel)",
    Spanish: "Prefinanciado (semestral)",
    key: "Pre_Funded_Semi_Yearly",
  },
  {
    English: "(total annual limit for all staff + 10% + tax divided by 2)",
    French:
      "(plafond annuel total pour tout le personnel + 10% + taxe divisé par 2)",
    Spanish:
      "(límite anual total para todo el personal + 10% + impuestos dividido por 2)",
    key: "total_annual_limit_for_all_staff_10_tax_divided_by_2",
  },
  {
    English: "Pay-as-you-go",
    French: "Paiement à l'utilisation",
    Spanish: "Pago por uso",
    key: "Pay_as_you_go",
  },
  {
    English: "(claims + 10% + tax as claims are submitted)",
    French:
      "(réclamations + 10% + taxes au fur et à mesure du dépôt des réclamations)",
    Spanish:
      "(reclamos + 10% + impuestos a medida que se presentan los reclamos)",
    key: "claims_10_tax_as_claims_are_submitted",
  },
  {
    English: "GroupBenefitz WalletTM",
    French: "GroupBenefitz WalletTM",
    Spanish: "GroupBenefitz WalletTM",
    key: "GroupBenefitz_WalletTM",
  },
  {
    English: "GroupBenefitz WalletTM Spending Limit",
    French: "Limite de dépenses GroupBenefitz WalletTM",
    Spanish: "Límite de gasto de GroupBenefitz WalletTM",
    key: "GroupBenefitz_WalletTM_Spending_Limit",
  },
  {
    English: "Please choose health and wellness spending account",
    French: "Veuillez choisir un compte de dépenses de santé et de bien-être",
    Spanish: "Por favor elija la cuenta de gastos de salud y bienestar",
    key: "Please_choose_health_and_wellness_spending_account",
  },
  {
    English: "Please choose pay for the service",
    French: "Veuillez choisir de payer pour le service",
    Spanish: "Por favor elige pagar por el servicio",
    key: "Please_choose_pay_for_the_service",
  },
  {
    English: "Invalid file type. Only jpg, png image,pdf files are allowed.",
    French:
      "Type de fichier invalide. Seuls les fichiers jpg, image png et pdf sont autorisés.",
    Spanish:
      "Tipo de archivo no válido. Sólo se permiten archivos jpg, imagen png y pdf.",
    key: "Invalid_file_type_Only_jpg_png_image_pdf_files_are_allowed",
  },
  {
    English: "Please select one plan from above",
    French: "Veuillez sélectionner un plan ci-dessus",
    Spanish: "Por favor seleccione un plan de arriba",
    key: "Please_select_one_plan_from_above",
  },
  {
    English: "Please enter spending limit",
    French: "Veuillez saisir la limite de dépenses",
    Spanish: "Por favor ingrese el límite de gasto",
    key: "Please_enter_spending_limit",
  },
  {
    English: "Please select subdomain for your portal",
    French: "Veuillez sélectionner un sous-domaine pour votre portail",
    Spanish: "Por favor seleccione el subdominio para su portal",
    key: "Please_select_subdomain_for_your_portal",
  },
  {
    English: "File size is too large,maximum file size is 300kb",
    French:
      "La taille du fichier est trop grande, la taille maximale du fichier est de 300 Ko",
    Spanish:
      "El tamaño del archivo es demasiado grande, el tamaño máximo del archivo es 300 kb",
    key: "File_size_is_too_large_maximum_file_size_is_300kb",
  },
  {
    English: "First Name can't be empty",
    French: "Le prénom ne peut pas être vide",
    Spanish: "El nombre no puede estar vacío",
    key: "First_Name_can_t_be_empty",
  },
  {
    English: "Last Name can't be empty",
    French: "Le nom de famille ne peut pas être vide",
    Spanish: "El apellido no puede estar vacío",
    key: "Last_Name_can_t_be_empty",
  },
  {
    English: "Email can't be empty",
    French: "L'e-mail ne peut pas être vide",
    Spanish: "El correo electrónico no puede estar vacío.",
    key: "Email_can_t_be_empty",
  },
  {
    English: "Age should not exceed 16 years",
    French: "L'âge ne doit pas dépasser 16 ans",
    Spanish: "La edad no debe exceder los 16 años.",
    key: "Age_should_not_exceed_16_years",
  },
  {
    English: "Phone Number can't be empty",
    French: "Le numéro de téléphone ne peut pas être vide",
    Spanish: "El número de teléfono no puede estar vacío",
    key: "Phone_Number_can_t_be_empty",
  },
  {
    English: "Duplicate Employee ID exists, please check",
    French: "Il existe un identifiant d'employé en double, veuillez vérifier",
    Spanish: "Existe una identificación de empleado duplicada, verifique",
    key: "Duplicate_Employee_ID_exists_please_check",
  },
  {
    English: "Country can't be empty",
    French: "Le pays ne peut pas être vide",
    Spanish: "El país no puede estar vacío.",
    key: "Country_can_t_be_empty",
  },
  {
    English: "Street Address can't be empty",
    French: "L'adresse postale ne peut pas être vide",
    Spanish: "La dirección postal no puede estar vacía",
    key: "Street_Address_can_t_be_empty",
  },
  {
    English: "Province can't be empty",
    French: "La province ne peut pas être vide",
    Spanish: "La provincia no puede estar vacía",
    key: "Province_can_t_be_empty",
  },
  {
    English: "City can't be empty",
    French: "La ville ne peut pas être vide",
    Spanish: "La ciudad no puede estar vacía.",
    key: "City_can_t_be_empty",
  },
  {
    English: "Some fields have invalid postal code, please check",
    French: "Certains champs ont un code postal invalide, veuillez vérifier",
    Spanish: "Algunos campos tienen un código postal no válido, verifíquelo",
    key: "Some_fields_have_invalid_postal_code_please_check",
  },
  {
    English: "PostalCode can't be empty",
    French: "PostalCode ne peut pas être vide",
    Spanish: "El código postal no puede estar vacío",
    key: "PostalCode_can_t_be_empty",
  },
  {
    English: "Do you want to replace or append the employee list?",
    French: "Voulez-vous remplacer ou ajouter la liste des employés ?",
    Spanish: "¿Quiere reemplazar o agregar la lista de empleados?",
    key: "Do_you_want_to_replace_or_append_the_employee_list",
  },
  {
    English: "Append",
    French: "Ajouter",
    Spanish: "Añadir",
    key: "Append",
  },
  {
    English: "Employees Added",
    French: "Employés ajoutés",
    Spanish: "Empleados agregados",
    key: "Employees_Added",
  },
  {
    English: "Invalid file type. Only xlsx files are allowed",
    French: "Type de fichier invalide. Seuls les fichiers xlsx sont autorisés",
    Spanish: "Tipo de archivo no válido. Sólo se permiten archivos xlsx",
    key: "Invalid_file_type_Only_xlsx_files_are_allowed",
  },
  {
    English: "Do you want to delete this employee and update head count?",
    French: "Voulez-vous supprimer cet employé et mettre à jour l'effectif ?",
    Spanish: "¿Quiere eliminar a este empleado y actualizar el recuento?",
    key: "Do_you_want_to_delete_this_employee_and_update_head_count",
  },
  {
    English: "Employees Exists",
    French: "Les employés existent",
    Spanish: "Los empleados existen",
    key: "Employees_Exists",
  },
  {
    English: "Replace",
    French: "Remplacer",
    Spanish: "Reemplazar",
    key: "Replace",
  },
  {
    English: "Alert",
    French: "Alerte",
    Spanish: "Alerta",
    key: "Alert",
  },
  {
    English: "Select All",
    French: "Sélectionner tout",
    Spanish: "Seleccionar todo",
    key: "Select_All",
  },
  {
    English: "Deselect All",
    French: "Désélectionner tout",
    Spanish: "Deseleccionar todo",
    key: "Deselect_All",
  },
  {
    English: "Please provide email for employee",
    French: "Veuillez fournir l'e-mail de l'employé",
    Spanish: "Proporcione el correo electrónico del empleado.",
    key: "Please_provide_email_for_employee",
  },
  {
    English: "Divorced",
    French: "Divorcé",
    Spanish: "Divorciado",
    key: "Divorced",
  },
  {
    English: "Married",
    French: "Marié",
    Spanish: "Casado",
    key: "Married",
  },
  {
    English: "Separated",
    French: "Séparé",
    Spanish: "Apartado",
    key: "Separated",
  },
  {
    English: "Secondary",
    French: "Secondaire",
    Spanish: "Secundario",
    key: "Secondary",
  },
  {
    English: "Address",
    French: "Adresse",
    Spanish: "DIRECCIÓN",
    key: "Address",
  },
  {
    English: "Street Address Line 2",
    French: "Adresse postale, ligne 2",
    Spanish: "Dirección de calle Línea 2",
    key: "Street_Address_Line_2",
  },
  {
    English: "Primary",
    French: "Primaire",
    Spanish: "Primario",
    key: "Primary",
  },
  {
    English: "Graduation Date",
    French: "Date d'obtention du diplôme",
    Spanish: "Fecha de graduación",
    key: "Graduation_Date",
  },
  {
    English: "Please choose graduation date",
    French: "Veuillez choisir la date d'obtention du diplôme",
    Spanish: "Por favor elija la fecha de graduación",
    key: "Please_choose_graduation_date",
  },
  {
    English: "Invoice",
    French: "Facture",
    Spanish: "Factura",
    key: "Invoice",
  },
  {
    English: "Widowed",
    French: "Veuf",
    Spanish: "Viudo",
    key: "Widowed",
  },
  {
    English: "No Upcoming Details",
    French: "Aucun détail à venir",
    Spanish: "No hay detalles próximos",
    key: "No_Upcoming_Details",
  },
  {
    English: "Graduation Day",
    French: "Jour de remise des diplômes",
    Spanish: "día de graduación",
    key: "Graduation_Day",
  },
  {
    English: "Common-Law",
    French: "Common Law",
    Spanish: "Derecho consuetudinario",
    key: "Common_Law",
  },
  {
    English: "Date",
    French: "Date",
    Spanish: "Fecha",
    key: "Date",
  },
  {
    English: "History",
    French: "Histoire",
    Spanish: "Historia",
    key: "History",
  },
  {
    English: "Upcoming",
    French: "Prochain",
    Spanish: "Próximo",
    key: "Upcoming",
  },
  {
    English: "Back",
    French: "Dos",
    Spanish: "Atrás",
    key: "Back",
  },
  {
    English: "Description",
    French: "Description",
    Spanish: "Descripción",
    key: "Description",
  },
  {
    English: "Health Insurance Cards Details",
    French: "Détails des cartes d'assurance maladie",
    Spanish: "Detalles de las tarjetas de seguro médico",
    key: "Health_Insurance_Cards_Details",
  },
  {
    English: "Health Plan Booklets Download",
    French: "Téléchargement des livrets du plan de santé",
    Spanish: "Descargar folletos del plan de salud",
    key: "Health_Plan_Booklets_Download",
  },
  {
    English: "Card holder name",
    French: "Nom du titulaire de la carte",
    Spanish: "Nombre del titular de la tarjeta",
    key: "Card_holder_name",
  },
  {
    English: "Card Number",
    French: "Numéro de carte",
    Spanish: "Número de tarjeta",
    key: "Card_Number",
  },
  {
    English: "Mobile",
    French: "Mobile",
    Spanish: "Móvil",
    key: "Mobile",
  },
  {
    English: "Dependent Name",
    French: "Nom à charge",
    Spanish: "Nombre del dependiente",
    key: "Dependent_Name",
  },
  {
    English: "Dependents",
    French: "Personnes à charge",
    Spanish: "Dependientes",
    key: "Dependents",
  },
  {
    English: "Student VIP",
    French: "Étudiant VIP",
    Spanish: "Estudiante VIP",
    key: "Student_VIP",
  },
  {
    English: "Please choose effective date",
    French: "Veuillez choisir la date d'entrée en vigueur",
    Spanish: "Por favor elija la fecha de vigencia",
    key: "Please_choose_effective_date",
  },
  {
    English: "COB",
    French: "ÉPI",
    Spanish: "MAZORCA",
    key: "COB",
  },
  {
    English: "Update Credit Card Info",
    French: "Mettre à jour les informations de la carte de crédit",
    Spanish: "Actualizar información de tarjeta de crédito",
    key: "Update_Credit_Card_Info",
  },
  {
    English: "No Data Found",
    French: "Aucune donnée trouvée",
    Spanish: "No se encontraron datos",
    key: "No_Data_Found",
  },
  {
    English: "Please select province",
    French: "Veuillez sélectionner une province",
    Spanish: "Por favor seleccione provincia",
    key: "Please_select_province",
  },
  {
    English: "Last Name minimum of 2 Characters and without numbers",
    French: "Nom de famille minimum de 2 caractères et sans chiffres",
    Spanish: "Apellido mínimo de 2 Caracteres y sin números",
    key: "Last_Name_minimum_of_2_Characters_and_without_numbers",
  },
  {
    English: "First Name minimum of 2 Characters and without numbers",
    French: "Prénom minimum de 2 caractères et sans chiffres",
    Spanish: "Nombre mínimo de 2 Caracteres y sin números",
    key: "First_Name_minimum_of_2_Characters_and_without_numbers",
  },
  {
    English: "Please select marital status",
    French: "Veuillez sélectionner votre état civil",
    Spanish: "Por favor seleccione estado civil",
    key: "Please_select_marital_status",
  },
  {
    English: "Please choose spouse insurance status",
    French: "Veuillez choisir le statut d'assurance du conjoint",
    Spanish: "Elija el estado del seguro del cónyuge",
    key: "Please_choose_spouse_insurance_status",
  },
  {
    English: "Add another dependent",
    French: "Ajouter une autre personne à charge",
    Spanish: "Agregar otro dependiente",
    key: "Add_another_dependent",
  },
  {
    English: "Invoice Details",
    French: "Détails de la facture",
    Spanish: "Detalles de la factura",
    key: "Invoice_Details",
  },
  {
    English: "Please choose dependent insurance status",
    French: "Veuillez choisir le statut d'assurance personne à charge",
    Spanish: "Por favor elija el estado del seguro de dependiente",
    key: "Please_choose_dependent_insurance_status",
  },
  {
    English: "Effective Date",
    French: "Date d'entrée en vigueur",
    Spanish: "Fecha de vigencia",
    key: "Effective_Date",
  },
  {
    English: "Draft Invoices Details",
    French: "Détails des factures provisoires",
    Spanish: "Detalles de borradores de facturas",
    key: "Draft_Invoices_Details",
  },
  {
    English: "Currently ROE is not available",
    French: "Le ROE n'est actuellement pas disponible",
    Spanish: "Actualmente ROE no está disponible",
    key: "Currently_ROE_is_not_available",
  },
  {
    English: "View Plan Booklets",
    French: "Voir les livrets du plan",
    Spanish: "Ver folletos de planos",
    key: "View_Plan_Booklets",
  },
  {
    English: "Card number must be equal to 16 digits",
    French: "Le numéro de carte doit être égal à 16 chiffres",
    Spanish: "El número de tarjeta debe tener 16 dígitos.",
    key: "Card_number_must_be_equal_to_16_digits",
  },
  {
    English: "CVV number minimum 3 digits",
    French: "Numéro CVV minimum 3 chiffres",
    Spanish: "Número CVV mínimo 3 dígitos",
    key: "CVV_number_minimum_3_digits",
  },
  {
    English: "CVV number maximum 4 digits",
    French: "Numéro CVV maximum 4 chiffres",
    Spanish: "Número CVV máximo 4 dígitos",
    key: "CVV_number_maximum_4_digits",
  },
  {
    English: "Account number maximum 12 digits",
    French: "Numéro de compte maximum 12 chiffres",
    Spanish: "Número de cuenta máximo 12 dígitos",
    key: "Account_number_maximum_12_digits",
  },
  {
    English: "Bank number must be equal to 3 digits",
    French: "Le numéro de banque doit être égal à 3 chiffres",
    Spanish: "El número de banco debe tener 3 dígitos",
    key: "Bank_number_must_be_equal_to_3_digits",
  },
  {
    English: "Transit number must be equal to 5 digits",
    French: "Le numéro de transit doit être égal à 5 ​​chiffres",
    Spanish: "El número de tránsito debe tener 5 dígitos.",
    key: "Transit_number_must_be_equal_to_5_digits",
  },
  {
    English: "Please check back later or contact your Advisor",
    French: "Veuillez revenir plus tard ou contacter votre conseiller",
    Spanish: "Vuelva a consultar más tarde o comuníquese con su asesor.",
    key: "Please_check_back_later_or_contact_your_Advisor",
  },
  {
    English: "Member has no dependents",
    French: "Le membre n'a aucune personne à charge",
    Spanish: "El miembro no tiene dependientes",
    key: "Member_has_no_dependents",
  },
  {
    English: "Please enter Date of Birth",
    French: "Veuillez entrer la date de naissance",
    Spanish: "Por favor ingrese la fecha de nacimiento",
    key: "Please_enter_Date_of_Birth",
  },
  {
    English: "Are you sure want to add?",
    French: "Êtes-vous sûr de vouloir ajouter ?",
    Spanish: "¿Estás seguro de que quieres agregar?",
    key: "Are_you_sure_want_to_add",
  },
  {
    English: "Next",
    French: "Suivant",
    Spanish: "Próximo",
    key: "Next",
  },
  {
    English: "Head Count",
    French: "Nombre de personnes",
    Spanish: "Conteo de cabezas",
    key: "Head_Count",
  },
  {
    English: "Go to Dashboard",
    French: "Aller au tableau de bord",
    Spanish: "Ir al panel",
    key: "Go_to_Dashboard",
  },
  {
    English: "Please enter broker name",
    French: "Veuillez entrer le nom du courtier",
    Spanish: "Por favor ingrese el nombre del corredor",
    key: "Please_enter_broker_name",
  },
  {
    English: "Name of Broker",
    French: "Nom du courtier",
    Spanish: "Nombre del corredor",
    key: "Name_of_Broker",
  },
  {
    English: "Secondary Email",
    French: "E-mail secondaire",
    Spanish: "Correo electrónico secundario",
    key: "Secondary_Email",
  },
  {
    English: "Advisor",
    French: "Conseiller",
    Spanish: "Tutor",
    key: "Advisor",
  },
  {
    English: "Brokerage",
    French: "Courtage",
    Spanish: "Corretaje",
    key: "Brokerage",
  },
  {
    English: "Association",
    French: "Association",
    Spanish: "Asociación",
    key: "Association",
  },
  {
    English: "Secondary Phone",
    French: "Téléphone secondaire",
    Spanish: "Teléfono secundario",
    key: "Secondary_Phone",
  },
  {
    English: "Brokerage / Parent Advisor Select Advisor Portal",
    French: "Courtage / Conseiller Parent Portail Conseiller Sélect",
    Spanish: "Corretaje / Asesor de padres Portal de asesor selecto",
    key: "Brokerage_Parent_Advisor_Select_Advisor_Portal",
  },
  {
    English: "TPA/MGA",
    French: "TPA/MGA",
    Spanish: "TPA/MGA",
    key: "TPA_MGA",
  },
  {
    English: "Third Email",
    French: "Troisième e-mail",
    Spanish: "Tercer correo electrónico",
    key: "Third_Email",
  },
  {
    English: "Please enter street address name",
    French: "Veuillez entrer le nom de l'adresse postale",
    Spanish: "Por favor ingrese el nombre de la dirección",
    key: "Please_enter_street_address_name",
  },
  {
    English: "Please enter city name",
    French: "Veuillez entrer le nom de la ville",
    Spanish: "Por favor ingrese el nombre de la ciudad",
    key: "Please_enter_city_name",
  },
  {
    English: "Canada",
    French: "Canada",
    Spanish: "Canadá",
    key: "Canada",
  },
  {
    English: "Please enter business number",
    French: "Veuillez entrer le numéro d'entreprise",
    Spanish: "Por favor ingrese el número de negocio",
    key: "Please_enter_business_number",
  },
  {
    English: "Broker name must not exceed 255 characters",
    French: "Le nom du courtier ne doit pas dépasser 255 caractères",
    Spanish: "El nombre del corredor no debe exceder los 255 caracteres.",
    key: "Broker_name_must_not_exceed_255_characters",
  },
  {
    English: "Business Number",
    French: "Numéro d'entreprise",
    Spanish: "Número de negocio",
    key: "Business_Number",
  },
  {
    English: "Broker name must be atleast 3 characters",
    French: "Le nom du courtier doit comporter au moins 3 caractères",
    Spanish: "El nombre del corredor debe tener al menos 3 caracteres.",
    key: "Broker_name_must_be_atleast_3_characters",
  },
  {
    English: "ok",
    French: "d'accord",
    Spanish: "OK",
    key: "ok",
  },
  {
    English: "Broker name already exists. Kindly check the details",
    French: "Le nom du courtier existe déjà. Veuillez vérifier les détails",
    Spanish: "El nombre del corredor ya existe. Por favor revise los detalles",
    key: "Broker_name_already_exists_Kindly_check_the_details",
  },
  {
    English: "Please enter first Name",
    French: "Veuillez saisir votre prénom",
    Spanish: "Por favor ingrese el nombre",
    key: "Please_enter_first_Name",
  },
  {
    English: "Please enter Last Name",
    French: "Veuillez entrer votre nom de famille",
    Spanish: "Por favor ingrese el apellido",
    key: "Please_enter_Last_Name",
  },
  {
    English: "Please enter Phone Number",
    French: "Veuillez entrer le numéro de téléphone",
    Spanish: "Por favor ingrese el número de teléfono",
    key: "Please_enter_Phone_Number",
  },
  {
    English: "Support",
    French: "Soutien",
    Spanish: "Apoyo",
    key: "Support",
  },
  {
    English: "Please select Role",
    French: "Veuillez sélectionner Rôle",
    Spanish: "Por favor seleccione Rol",
    key: "Please_select_Role",
  },
  {
    English: "Administrator",
    French: "Administrateur",
    Spanish: "Administrador",
    key: "Administrator",
  },
  {
    English: "Group Admin Added Successfully",
    French: "Administrateur de groupe ajouté avec succès",
    Spanish: "Administrador de grupo agregado exitosamente",
    key: "Group_Admin_Added_Successfully",
  },
  {
    English: "please enter role.",
    French: "veuillez entrer le rôle.",
    Spanish: "por favor ingrese el rol.",
    key: "please_enter_role",
  },
  {
    English: "Add Group Contact",
    French: "Ajouter un contact au groupe",
    Spanish: "Agregar contacto de grupo",
    key: "Add_Group_Contact",
  },
  {
    English: "Email aldready exists",
    French: "L'e-mail existe déjà",
    Spanish: "El correo electrónico ya existe",
    key: "Email_aldready_exists",
  },
  {
    English: "Edit Group Contact",
    French: "Modifier le contact du groupe",
    Spanish: "Editar contacto de grupo",
    key: "Edit_Group_Contact",
  },
  {
    English: "Are you sure you want to delete this Group Contact?",
    French: "Êtes-vous sûr de vouloir supprimer ce contact de groupe ?",
    Spanish: "¿Está seguro de que desea eliminar este contacto de grupo?",
    key: "Are_you_sure_you_want_to_delete_this_Group_Contact",
  },
  {
    English: "License Information",
    French: "Informations sur la licence",
    Spanish: "Información de licencia",
    key: "License_Information",
  },
  {
    English: "Please enter license number",
    French: "Veuillez entrer le numéro de licence",
    Spanish: "Por favor ingrese el número de licencia",
    key: "Please_enter_license_number",
  },
  {
    English: "License",
    French: "Licence",
    Spanish: "Licencia",
    key: "License",
  },
  {
    English: "Accident and Sickness",
    French: "Accident et Maladie",
    Spanish: "Accidente y enfermedad",
    key: "Accident_and_Sickness",
  },
  {
    English: "Please select license coverage",
    French: "Veuillez sélectionner la couverture de licence",
    Spanish: "Por favor seleccione la cobertura de la licencia",
    key: "Please_select_license_coverage",
  },
  {
    English: "Life",
    French: "Vie",
    Spanish: "Vida",
    key: "Life",
  },
  {
    English: "Coverage*Select Both (Life, Accident and Sickness)",
    French: "Couverture*Sélectionnez les deux (vie, accident et maladie)",
    Spanish: "Cobertura*Seleccione ambas (vida, accidente y enfermedad)",
    key: "Coverage_Select_Both_Life_Accident_and_Sickness",
  },
  {
    English: "Expiry Date",
    French: "Date d'expiration",
    Spanish: "Fecha de vencimiento",
    key: "Expiry_Date",
  },
  {
    English: "Please select expiry date",
    French: "Veuillez sélectionner la date d'expiration",
    Spanish: "Por favor seleccione la fecha de vencimiento",
    key: "Please_select_expiry_date",
  },
  {
    English: "Reminder Days",
    French: "Jours de rappel",
    Spanish: "Días de recordatorio",
    key: "Reminder_Days",
  },
  {
    English: "Please enter reminder email days",
    French: "Veuillez saisir les jours d'e-mail de rappel",
    Spanish:
      "Por favor ingrese los días del correo electrónico de recordatorio",
    key: "Please_enter_reminder_email_days",
  },
  {
    English: "License number already exist",
    French: "Le numéro de licence existe déjà",
    Spanish: "El número de licencia ya existe",
    key: "License_number_already_exist",
  },
  {
    English: "Edit License",
    French: "Modifier la licence",
    Spanish: "Editar licencia",
    key: "Edit_License",
  },
  {
    English: "Insurer Name",
    French: "Nom de l'assureur",
    Spanish: "Nombre de la aseguradora",
    key: "Insurer_Name",
  },
  {
    English: "Please enter Insurance name",
    French: "Veuillez entrer le nom de l'assurance",
    Spanish: "Por favor ingrese el nombre del seguro",
    key: "Please_enter_Insurance_name",
  },
  {
    English: "Are you sure you want to delete this License?",
    French: "Êtes-vous sûr de vouloir supprimer cette licence ?",
    Spanish: "¿Está seguro de que desea eliminar esta licencia?",
    key: "Are_you_sure_you_want_to_delete_this_License",
  },
  {
    English: "License number must be atleast 3 characters",
    French: "Le numéro de licence doit comporter au moins 3 caractères",
    Spanish: "El número de licencia debe tener al menos 3 caracteres.",
    key: "License_number_must_be_atleast_3_characters",
  },
  {
    English: "Certificate",
    French: "Certificat",
    Spanish: "Certificado",
    key: "Certificate",
  },
  {
    English: "Please select Certificate Name",
    French: "Veuillez sélectionner le nom du certificat",
    Spanish: "Por favor seleccione el nombre del certificado",
    key: "Please_select_Certificate_Name",
  },
  {
    English: "Please enter Policy Number",
    French: "Veuillez entrer le numéro de police",
    Spanish: "Por favor ingrese el número de póliza",
    key: "Please_enter_Policy_Number",
  },
  {
    English: "Expiry Date",
    French: "Date d'expiration",
    Spanish: "Fecha de vencimiento",
    key: "Expiry_Date",
  },
  {
    English: "Please select expiry date",
    French: "Veuillez sélectionner la date d'expiration",
    Spanish: "Por favor seleccione la fecha de vencimiento",
    key: "Please_select_expiry_date",
  },
  {
    English: "Are you sure you want to delete this EO?",
    French: "Êtes-vous sûr de vouloir supprimer cet EO ?",
    Spanish: "¿Está seguro de que desea eliminar esta EO?",
    key: "Are_you_sure_you_want_to_delete_this_EO",
  },
  {
    English:
      "One state allow only one type of license coverage please check license coverage",
    French:
      "Un État n'autorise qu'un seul type de couverture de licence, veuillez vérifier la couverture de licence",
    Spanish:
      "Un estado permite solo un tipo de cobertura de licencia. Verifique la cobertura de la licencia.",
    key: "One_state_allow_only_one_type_of_license_coverage_please_check_license_coverage",
  },
  {
    English: "Insurer name must be atleast 3 characters",
    French: "Le nom de l'assureur doit comporter au moins 3 caractères",
    Spanish: "El nombre de la aseguradora debe tener al menos 3 caracteres.",
    key: "Insurer_name_must_be_atleast_3_characters",
  },
  {
    English: "Summary Details",
    French: "Détails du résumé",
    Spanish: "Detalles resumidos",
    key: "Summary_Details",
  },
  {
    English: "General Details",
    French: "Détails généraux",
    Spanish: "Detalles generales",
    key: "General_Details",
  },
  {
    English: "Sales Tracking code",
    French: "Code de suivi des ventes",
    Spanish: "Código de seguimiento de ventas",
    key: "Sales_Tracking_code",
  },
  {
    English: "Commissions",
    French: "Commissions",
    Spanish: "Comisiones",
    key: "Commissions",
  },
  {
    English: "License Details",
    French: "Détails de la licence",
    Spanish: "Detalles de la licencia",
    key: "License_Details",
  },
  {
    English: "Reminder days",
    French: "Jours de rappel",
    Spanish: "Días de recordatorio",
    key: "Reminder_days",
  },
  {
    English: "E&O Details",
    French: "Détails E&O",
    Spanish: "Detalles de E&O",
    key: "E_O_Details",
  },
  {
    English: "Use Parent Logo?",
    French: "Utiliser le logo des parents ?",
    Spanish: "¿Usar el logotipo principal?",
    key: "Use_Parent_Logo",
  },
  {
    English: "Use Parent Disclosure?Use Parent Disclosure?",
    French:
      "Utiliser la divulgation parentale ? Utiliser la divulgation parentale ?",
    Spanish:
      "¿Usar la divulgación de los padres? ¿Usar la divulgación de los padres?",
    key: "Use_Parent_Disclosure_Use_Parent_Disclosure",
  },
  {
    English: "Insurer Name",
    French: "Nom de l'assureur",
    Spanish: "Nombre de la aseguradora",
    key: "Insurer_Name",
  },
  {
    English: "Logo",
    French: "Logo",
    Spanish: "Logo",
    key: "Logo",
  },
  {
    English: "Click to upload LOGO Max. 300x100 px .png,.jpg",
    French: "Cliquez pour télécharger LOGO Max. 300x100px .png,.jpg",
    Spanish: "Haga clic para cargar LOGO Max. 300x100 píxeles.png,.jpg",
    key: "Click_to_upload_LOGO_Max_300x100_px_png_jpg",
  },
  {
    English: "Disclosure Agreement",
    French: "Accord de divulgation",
    Spanish: "Acuerdo de divulgación",
    key: "Disclosure_Agreement",
  },
  {
    English: "Click to upload Disclosure Agreement",
    French: "Cliquez pour télécharger l'accord de divulgation",
    Spanish: "Haga clic para cargar el Acuerdo de divulgación",
    key: "Click_to_upload_Disclosure_Agreement",
  },
  {
    English: "Do You Want To Create A Signup Form?",
    French: "Voulez-vous créer un formulaire d'inscription ?",
    Spanish: "¿Quieres crear un formulario de registro?",
    key: "Do_You_Want_To_Create_A_Signup_Form",
  },
  {
    English: "Select Profile for signup",
    French: "Sélectionnez le profil pour vous inscrire",
    Spanish: "Seleccione perfil para registrarse",
    key: "Select_Profile_for_signup",
  },
  {
    English: "Title",
    French: "Titre",
    Spanish: "Título",
    key: "Title",
  },
  {
    English: "Please enter form title",
    French: "Veuillez saisir le titre du formulaire",
    Spanish: "Por favor ingrese el título del formulario",
    key: "Please_enter_form_title",
  },
  {
    English: "Please enter form description",
    French: "Veuillez saisir la description du formulaire",
    Spanish: "Por favor ingrese la descripción del formulario",
    key: "Please_enter_form_description",
  },
  {
    English: "Logo",
    French: "Logo",
    Spanish: "Logo",
    key: "Logo",
  },
  {
    English: "Apply Parent Logo?",
    French: "Appliquer le logo parent ?",
    Spanish: "¿Aplicar logotipo principal?",
    key: "Apply_Parent_Logo",
  },
  {
    English: "Please choose form logo",
    French: "Veuillez choisir le logo du formulaire",
    Spanish: "Por favor elija el logotipo del formulario",
    key: "Please_choose_form_logo",
  },
  {
    English: "Choose File",
    French: "Choisir un fichier",
    Spanish: "Elija archivo",
    key: "Choose_File",
  },
  {
    English: "No file chosen",
    French: "Aucun fichier choisi",
    Spanish: "Ningún archivo elegido",
    key: "No_file_chosen",
  },
  {
    English: "Please select atleast one plan",
    French: "Veuillez sélectionner au moins un forfait",
    Spanish: "Por favor seleccione al menos un plan",
    key: "Please_select_atleast_one_plan",
  },
  {
    English: "Pricing",
    French: "Tarifs",
    Spanish: "Precios",
    key: "Pricing",
  },
  {
    English: "GIG",
    French: "CABRIOLET",
    Spanish: "CONCIERTO",
    key: "GIG",
  },
  {
    English: "GROUP",
    French: "GROUPE",
    Spanish: "GRUPO",
    key: "GROUP",
  },
  {
    English: "Edit Signup Form Details",
    French: "Modifier les détails du formulaire d'inscription",
    Spanish: "Editar detalles del formulario de registro",
    key: "Edit_Signup_Form_Details",
  },
  {
    English: "(Click to update logo)",
    French: "(Cliquez pour mettre à jour le logo)",
    Spanish: "(Haga clic para actualizar el logotipo)",
    key: "Click_to_update_logo",
  },
  {
    English: "Are you sure you want to delete this form?",
    French: "Êtes-vous sûr de vouloir supprimer ce formulaire ?",
    Spanish: "¿Está seguro de que desea eliminar este formulario?",
    key: "Are_you_sure_you_want_to_delete_this_form",
  },
  {
    English: "Brokers involved in shared account",
    French: "Courtiers impliqués dans le compte partagé",
    Spanish: "Corredores involucrados en cuenta compartida",
    key: "Brokers_involved_in_shared_account",
  },
  {
    English: "New",
    French: "Nouveau",
    Spanish: "Nuevo",
    key: "New",
  },
  {
    English: "Existing",
    French: "Existant",
    Spanish: "Existente",
    key: "Existing",
  },
  {
    English: "Existing Broker/Advisor",
    French: "Courtier/Conseiller existant",
    Spanish: "Corredor/Asesor existente",
    key: "Existing_Broker_Advisor",
  },
  {
    English: "Shared account name",
    French: "Nom du compte partagé",
    Spanish: "Nombre de cuenta compartida",
    key: "Shared_account_name",
  },
  {
    English: "Name of the Shared account",
    French: "Nom du compte partagé",
    Spanish: "Nombre de la cuenta compartida",
    key: "Name_of_the_Shared_account",
  },
  {
    English: "Shared account created successfully",
    French: "Compte partagé créé avec succès",
    Spanish: "Cuenta compartida creada exitosamente",
    key: "Shared_account_created_successfully",
  },
  {
    English: "Add Broker License",
    French: "Ajouter une licence de courtier",
    Spanish: "Agregar licencia de corredor",
    key: "Add_Broker_License",
  },
  {
    English: "License coverage already exists in that state",
    French: "La couverture de licence existe déjà dans cet État",
    Spanish: "La cobertura de licencia ya existe en ese estado.",
    key: "License_coverage_already_exists_in_that_state",
  },
  {
    English: "Similar broker commissions exists. Kindly check the details",
    French:
      "Des commissions de courtier similaires existent. Veuillez vérifier les détails",
    Spanish:
      "Existen comisiones de corredores similares. Por favor revise los detalles",
    key: "Similar_broker_commissions_exists_Kindly_check_the_details",
  },
  {
    English: "Edit",
    French: "Modifier",
    Spanish: "Editar",
    key: "Edit",
  },
  {
    English: "No Details found",
    French: "Aucun détail trouvé",
    Spanish: "No se encontraron detalles",
    key: "No_Details_found",
  },
  {
    English: "Phone number already exists",
    French: "Le numéro de téléphone existe déjà",
    Spanish: "El número de teléfono ya existe",
    key: "Phone_number_already_exists",
  },
  {
    English: "Bank Number",
    French: "Numéro de Banque",
    Spanish: "Número de Banco",
    key: "Bank_Number",
  },
  {
    English: "Account Number",
    French: "Numéro de Compte",
    Spanish: "Número de Cuenta",
    key: "Account_Number",
  },
  {
    English: "Upload Void Cheque",
    French: "Télécharger un chèque annulé",
    Spanish: "Cargar cheque anulado",
    key: "Upload_Void_Cheque",
  },
  {
    English: "Please enter valid expiration",
    French: "Veuillez saisir une date d'expiration valide",
    Spanish: "Por favor ingrese una caducidad válida",
    key: "Please_enter_valid_expiration",
  },
  {
    English: "Please enter valid Card number",
    French: "Veuillez saisir un numéro de carte valide",
    Spanish: "Por favor ingrese un número de tarjeta válido",
    key: "Please_enter_valid_Card_number",
  },
  {
    English: "View Draft Invoice",
    French: "Afficher le projet de facture",
    Spanish: "Ver borrador de factura",
    key: "View_Draft_Invoice",
  },
  {
    English: "Your browser does not support the video tag",
    French: "Votre navigateur ne prend pas en charge la balise vidéo",
    Spanish: "Su navegador no soporta la etiqueta de video",
    key: "Your_browser_does_not_support_the_video_tag",
  },
  {
    English: "Filter by Status",
    French: "Filtrer par statut",
    Spanish: "Filtrar por estado",
    key: "Filter_by_Status",
  },
  {
    English: "List",
    French: "Liste",
    Spanish: "Lista",
    key: "List",
  },
  {
    English: "Sales Code",
    French: "Code de vente",
    Spanish: "Código de venta",
    key: "Sales_Code",
  },
  {
    English: "Showing 0 to 0 of 0 entries",
    French: "Affichage de 0 à 0 sur 0 entrées",
    Spanish: "Mostrando 0 a 0 de 0 entradas",
    key: "Showing_0_to_0_of_0_entries",
  },
  {
    English: "Corp",
    French: "Corp.",
    Spanish: "corporación",
    key: "Corp",
  },
  {
    English: "Sub Brokers List",
    French: "Liste des sous-courtiers",
    Spanish: "Lista de subcorredores",
    key: "Sub_Brokers_List",
  },
  {
    English: "Prov Lic",
    French: "Licence Prov",
    Spanish: "Lic. Prov.",
    key: "Prov_Lic",
  },
  {
    English: "Count",
    French: "Compter",
    Spanish: "Contar",
    key: "Count",
  },
  {
    English: "View",
    French: "Voir",
    Spanish: "Vista",
    key: "View",
  },
  {
    English: "E&O Status",
    French: "Statut E&O",
    Spanish: "Estado de E&O",
    key: "E_O_Status",
  },
  {
    English: "Broker Type",
    French: "Type de courtier",
    Spanish: "Tipo de corredor",
    key: "Broker_Type",
  },
  {
    English: "Customers",
    French: "Clients",
    Spanish: "Clientes",
    key: "Customers",
  },
  {
    English: "Sub Brokers",
    French: "Sous-courtiers",
    Spanish: "Subcorredores",
    key: "Sub_Brokers",
  },
  {
    English: "Price",
    French: "Prix",
    Spanish: "Precio",
    key: "Price",
  },
  {
    English: "DOB",
    French: "Date de naissance",
    Spanish: "fecha de nacimiento",
    key: "DOB",
  },
  {
    English: "Plan List",
    French: "Liste des forfaits",
    Spanish: "Lista de planes",
    key: "Plan_List",
  },
  {
    English: "No data available in table",
    French: "Aucune donnée disponible dans le tableau",
    Spanish: "No hay datos disponibles en la tabla",
    key: "No_data_available_in_table",
  },
  {
    English: "About to Expire",
    French: "Sur le point d'expirer",
    Spanish: "A punto de caducar",
    key: "About_to_Expire",
  },
  {
    English: "Signup Date",
    French: "Date d'inscription",
    Spanish: "Fecha de registro",
    key: "Signup_Date",
  },
  {
    English: "Enrolled Date",
    French: "Date d'inscription",
    Spanish: "Fecha de inscripción",
    key: "Enrolled_Date",
  },
  {
    English: "Expired",
    French: "Expiré",
    Spanish: "Caducado",
    key: "Expired",
  },
  {
    English: "Valid",
    French: "Valide",
    Spanish: "Válido",
    key: "Valid",
  },
  {
    English: "Send Logo Test portal access link to",
    French: "Envoyer le lien d'accès au portail Logo Test à",
    Spanish: "Enviar enlace de acceso al portal Logo Test a",
    key: "Send_Logo_Test_portal_access_link_to",
  },
  {
    English: "Please add atleast one group contact to send the Mail",
    French:
      "Veuillez ajouter au moins un contact de groupe pour envoyer le courrier",
    Spanish: "Agregue al menos un contacto de grupo para enviar el correo.",
    key: "Please_add_atleast_one_group_contact_to_send_the_Mail",
  },
  {
    English: "Broker invitation sent successfully",
    French: "Invitation de courtier envoyée avec succès",
    Spanish: "La invitación del corredor se envió correctamente",
    key: "Broker_invitation_sent_successfully",
  },
  {
    English: "Please choose valid group contact details",
    French: "Veuillez choisir des coordonnées de groupe valides",
    Spanish: "Por favor elija datos de contacto de grupo válidos",
    key: "Please_choose_valid_group_contact_details",
  },
  {
    English: "All",
    French: "Tous",
    Spanish: "Todo",
    key: "All",
  },
  {
    English: "portal access link to",
    French: "lien d'accès au portail vers",
    Spanish: "enlace de acceso al portal para",
    key: "portal_access_link_to",
  },
  {
    English: "Are you sure you want to change this",
    French: "Êtes-vous sûr de vouloir changer cela",
    Spanish: "¿Estás seguro de que quieres cambiar esto?",
    key: "Are_you_sure_you_want_to_change_this",
  },
  {
    English: "List - Members of Advisor",
    French: "Liste - Membres du conseiller",
    Spanish: "Lista - Miembros del Asesor",
    key: "List_Members_of_Advisor",
  },
  {
    English: "Send",
    French: "Envoyer",
    Spanish: "Enviar",
    key: "Send",
  },
  {
    English: "Are you sure you want to delete this",
    French: "Etes-vous sûr de vouloir supprimer ceci",
    Spanish: "¿Estás seguro de que quieres eliminar esto?",
    key: "Are_you_sure_you_want_to_delete_this",
  },
  {
    English: "status",
    French: "statut",
    Spanish: "estado",
    key: "status",
  },
  {
    English: "Shared",
    French: "Commun",
    Spanish: "Compartido",
    key: "Shared",
  },
  {
    English: "Select commission-based type of broker account",
    French:
      "Sélectionnez le type de compte de courtier basé sur les commissions",
    Spanish: "Seleccione el tipo de cuenta de corredor basada en comisiones",
    key: "Select_commission_based_type_of_broker_account",
  },
  {
    English: "Advisor Information",
    French: "Informations sur le conseiller",
    Spanish: "Información del asesor",
    key: "Advisor_Information",
  },
  {
    English: "Brokerage/ Parent Advisor Select Advisor Portal",
    French: "Courtage/ Conseiller Parent Portail Conseiller Sélect",
    Spanish: "Portal de Asesor Selecto de Corretaje/Asesor de Padres",
    key: "Brokerage_Parent_Advisor_Select_Advisor_Portal",
  },
  {
    English: "Sole",
    French: "Seul",
    Spanish: "Único",
    key: "Sole",
  },
  {
    English: "Missing Info in add and edit Advsiors",
    French:
      "Informations manquantes dans l'ajout et la modification des conseillers",
    Spanish: "Falta información al agregar y editar asesores",
    key: "Missing_Info_in_add_and_edit_Advsiors",
  },
  {
    English: "First Name must not exceed 20 characters",
    French: "Le prénom ne doit pas dépasser 20 caractères",
    Spanish: "El nombre no debe exceder los 20 caracteres",
    key: "First_Name_must_not_exceed_20_characters",
  },
  {
    English: "First Name should be 3 characters",
    French: "Le prénom doit être composé de 3 caractères",
    Spanish: "El nombre debe tener 3 caracteres.",
    key: "First_Name_should_be_3_characters",
  },
  {
    English: "Please select brokershare",
    French: "Veuillez sélectionner Brokershare",
    Spanish: "Por favor seleccione brokershare",
    key: "Please_select_brokershare",
  },
  {
    English: "Please select no.of brokers",
    French: "Veuillez sélectionner le nombre de courtiers",
    Spanish: "Por favor seleccione el número de corredores",
    key: "Please_select_no_of_brokers",
  },
  {
    English: "Brokerage / Parent Advisor",
    French: "Courtage / Conseiller aux parents",
    Spanish: "Corretaje / Asesor de padres",
    key: "Brokerage_Parent_Advisor",
  },
  {
    English: "Please select parent advisor",
    French: "Veuillez sélectionner le conseiller parental",
    Spanish: "Por favor seleccione padre asesor",
    key: "Please_select_parent_advisor",
  },
  {
    English: "Please save signup form",
    French: "Veuillez enregistrer le formulaire d'inscription",
    Spanish: "Por favor guarde el formulario de registro",
    key: "Please_save_signup_form",
  },
  {
    English: "Notifications",
    French: "Notifications",
    Spanish: "Notificaciones",
    key: "Notifications",
  },
  {
    English: "E&O Information",
    French: "Informations E&O",
    Spanish: "Información de E&O",
    key: "E_O_Information",
  },
  {
    English: "Sales Tracking Information",
    French: "Informations sur le suivi des ventes",
    Spanish: "Información de seguimiento de ventas",
    key: "Sales_Tracking_Information",
  },
  {
    English: "Please enter reminder days",
    French: "Veuillez saisir les jours de rappel",
    Spanish: "Por favor ingrese los días de recordatorio",
    key: "Please_enter_reminder_days",
  },
  {
    English: "broker",
    French: "courtier",
    Spanish: "corredor",
    key: "broker",
  },
  {
    English: "Add Signup Form",
    French: "Ajouter un formulaire d'inscription",
    Spanish: "Agregar formulario de registro",
    key: "Add_Signup_Form",
  },
  {
    English: "Please select logo type",
    French: "Veuillez sélectionner le type de logo",
    Spanish: "Por favor seleccione el tipo de logotipo",
    key: "Please_select_logo_type",
  },
  {
    English: "License number must not exceed 100 characters",
    French: "Le numéro de licence ne doit pas dépasser 100 caractères",
    Spanish: "El número de licencia no debe exceder los 100 caracteres",
    key: "License_number_must_not_exceed_100_characters",
  },
  {
    English: "Insurer name must not exceed 100 characters",
    French: "Le nom de l'assureur ne doit pas dépasser 100 caractères",
    Spanish: "El nombre de la aseguradora no debe exceder los 100 caracteres.",
    key: "Insurer_name_must_not_exceed_100_characters",
  },
  {
    English: "Last Name should be 3 characters",
    French: "Le nom de famille doit contenir 3 caractères",
    Spanish: "El apellido debe tener 3 caracteres.",
    key: "Last_Name_should_be_3_characters",
  },
  {
    English: "Last Name must not exceed 20 characters",
    French: "Le nom de famille ne doit pas dépasser 20 caractères",
    Spanish: "El apellido no debe exceder los 20 caracteres",
    key: "Last_Name_must_not_exceed_20_characters",
  },
  {
    English: "Please select logo type",
    French: "Veuillez sélectionner le type de logo",
    Spanish: "Por favor seleccione el tipo de logotipo",
    key: "Please_select_logo_type",
  },
  {
    English: "Last name should be 3 characters",
    French: "Le nom de famille doit contenir 3 caractères",
    Spanish: "El apellido debe tener 3 caracteres.",
    key: "Last_name_should_be_3_characters",
  },
  {
    English: "Edit EO",
    French: "Modifier l'EO",
    Spanish: "Editar OE",
    key: "Edit_EO",
  },
  {
    English: "Please enter Insurer name",
    French: "Veuillez entrer le nom de l'assureur",
    Spanish: "Por favor ingrese el nombre de la aseguradora",
    key: "Please_enter_Insurer_name",
  },
  {
    English: "Insurer name must not exceed 100 characters",
    French: "Le nom de l'assureur ne doit pas dépasser 100 caractères",
    Spanish: "El nombre de la aseguradora no debe exceder los 100 caracteres.",
    key: "Insurer_name_must_not_exceed_100_characters",
  },
  {
    English: "Please select parent logo",
    French: "Veuillez sélectionner le logo du parent",
    Spanish: "Por favor seleccione el logotipo principal",
    key: "Please_select_parent_logo",
  },
  {
    English: "Please upload Parent logo",
    French: "Veuillez télécharger le logo du parent",
    Spanish: "Por favor cargue el logotipo de los padres",
    key: "Please_upload_Parent_logo",
  },
  {
    English: "Please select parent disclosure",
    French: "Veuillez sélectionner la divulgation aux parents",
    Spanish: "Por favor seleccione divulgación para padres",
    key: "Please_select_parent_disclosure",
  },
  {
    English: "Please upload disclosure agreement",
    French: "Veuillez télécharger l'accord de divulgation",
    Spanish: "Por favor cargue el acuerdo de divulgación",
    key: "Please_upload_disclosure_agreement",
  },
  {
    English: "Please select signup form",
    French: "Veuillez sélectionner le formulaire d'inscription",
    Spanish: "Por favor seleccione el formulario de registro",
    key: "Please_select_signup_form",
  },
  {
    English: "View Full Details",
    French: "Afficher tous les détails",
    Spanish: "Ver todos los detalles",
    key: "View_Full_Details",
  },
  {
    English: "Service Unavailability",
    French: "Indisponibilité du service",
    Spanish: "Indisponibilidad del servicio",
    key: "Service_Unavailability",
  },
  {
    English:
      "service not available in Quebec presently. Please check back in 2025",
    French:
      "service non disponible au Québec présentement. Veuillez revenir en 2025",
    Spanish:
      "El servicio no está disponible actualmente en Quebec. Vuelve a consultar en 2025.",
    key: "service_not_available_in_Quebec_presently_Please_check_back_in_2025",
  },
  {
    English: "Broker Details",
    French: "Détails du courtier",
    Spanish: "Detalles del corredor",
    key: "Broker_Details",
  },
  {
    English: "Select broker status",
    French: "Sélectionnez le statut de courtier",
    Spanish: "Seleccione el estado del corredor",
    key: "Select_broker_status",
  },
  {
    English: "Edit Sales TrackingCode",
    French: "Modifier le code de suivi des ventes",
    Spanish: "Editar código de seguimiento de ventas",
    key: "Edit_Sales_TrackingCode",
  },
  {
    English: "Add Email",
    French: "Ajouter un e-mail",
    Spanish: "Agregar correo electrónico",
    key: "Add_Email",
  },
  {
    English: "Please select broker status",
    French: "Veuillez sélectionner le statut de courtier",
    Spanish: "Por favor seleccione el estado del corredor",
    key: "Please_select_broker_status",
  },
  {
    English: "Copy",
    French: "Copie",
    Spanish: "Copiar",
    key: "Copy",
  },
  {
    English: "USA",
    French: "USA",
    Spanish: "EE.UU",
    key: "USA",
  },
  {
    English: "Sign-up Link",
    French: "Lien d'inscription",
    Spanish: "Enlace de registro",
    key: "Sign_up_Link",
  },
  {
    English: "Please enter valid postal code\n",
    French: "Veuillez entrer un code postal valide\n",
    Spanish: "Por favor introduce un código postal válido\n",
    key: "Please_enter_valid_postal_code",
  },
  {
    English: "Note",
    French: "Note",
    Spanish: "Nota",
    key: "Note",
  },
  {
    English:
      "Premiums may change on the renewal date. Please contact your Broker/Advisor for more information.\n\n",
    French:
      "Les primes peuvent changer à la date de renouvellement. Veuillez contacter votre courtier/conseiller pour plus d’informations.\n\n",
    Spanish:
      "Las primas pueden cambiar en la fecha de renovación. Comuníquese con su corredor/asesor para obtener más información.\n\n",
    key: "Premiums_may_change_on_the_renewal_date_Please_contact_your_Broker_Advisor_for_more_information",
  },
  {
    English: "Corporate Portal",
    French: "Portail d'entreprise",
    Spanish: "Portal Corporativo",
    key: "Corporate_Portal",
  },
  {
    English: "Corporate Information Updated Successfully",
    French: "Informations sur l'entreprise mises à jour avec succès",
    Spanish: "Información corporativa actualizada con éxito",
    key: "Corporate_Information_Updated_Successfully",
  },
  {
    English: "\nUnit/Apt/Suite #",
    French: "\nNuméro d'unité/app/suite",
    Spanish: "\nUnidad/Apto/Suite #",
    key: "Unit_Apt_Suite",
  },
  {
    English: "Corporate InformationEdit",
    French: "Informations sur l'entreprise",
    Spanish: "Información corporativa",
    key: "Corporate_InformationEdit",
  },
  {
    English: "Update Corporate Information",
    French: "Mettre à jour les informations de l'entreprise",
    Spanish: "Actualizar información corporativa",
    key: "Update_Corporate_Information",
  },
  {
    English: "Plan Level \n",
    French: "Niveau du forfait \n",
    Spanish: "Nivel del plan \n",
    key: "Plan_Level",
  },
  {
    English: "Corporate Tier Plans",
    French: "Plans de niveau entreprise",
    Spanish: "Planes de nivel corporativo",
    key: "Corporate_Tier_Plans",
  },
  {
    English: "Waiting Period for new hires",
    French: "Délai d'attente pour les nouvelles recrues",
    Spanish: "Periodo de espera para nuevas contrataciones",
    key: "Waiting_Period_for_new_hires",
  },
  {
    English: "Employees",
    French: "Employés",
    Spanish: "Empleados",
    key: "Employees",
  },
  {
    English: "Plan Type",
    French: "Type de régime",
    Spanish: "Tipo de plan",
    key: "Plan_Type",
  },
  {
    English: "Wait time",
    French: "Temps d'attente",
    Spanish: "tiempo de espera",
    key: "Wait_time",
  },
  {
    English: "GroupBenefitz WalletTM for employees?",
    French: "GroupBenefitz WalletTM pour les employés ?",
    Spanish: "¿GroupBenefitz WalletTM para empleados?",
    key: "GroupBenefitz_WalletTM_for_employees",
  },
  {
    English: "Wait time for initial signup",
    French: "Temps d'attente pour la première inscription",
    Spanish: "Tiempo de espera para el registro inicial",
    key: "Wait_time_for_initial_signup",
  },
  {
    English: "Corporate settings updated successfully.",
    French: "Paramètres d'entreprise mis à jour avec succès.",
    Spanish: "La configuración corporativa se actualizó correctamente.",
    key: "Corporate_settings_updated_successfully",
  },
  {
    English: "Payment method",
    French: "Mode de paiement",
    Spanish: "Método de pago",
    key: "Payment_method",
  },
  {
    English: "Show employer name for signup",
    French: "Afficher le nom de l'employeur pour l'inscription",
    Spanish: "Mostrar el nombre del empleador para registrarse",
    key: "Show_employer_name_for_signup",
  },
  {
    English: "Advisor Information \n",
    French: "Informations sur le conseiller \n",
    Spanish: "Información del asesor \n",
    key: "Advisor_Information",
  },
  {
    English: "House Clients (Gavin Mosley) \n",
    French: "Clients de la maison (Gavin Mosley) \n",
    Spanish: "Clientes de la casa (Gavin Mosley) \n",
    key: "House_Clients_Gavin_Mosley",
  },
  {
    English: "Show employer name for signup",
    French: "Afficher le nom de l'employeur pour l'inscription",
    Spanish: "Mostrar el nombre del empleador para registrarse",
    key: "Show_employer_name_for_signup",
  },
  {
    English: "Group Benefits Invoices \n",
    French: "Factures d’assurance collective \n",
    Spanish: "Facturas de beneficios grupales \n",
    key: "Group_Benefits_Invoices",
  },
  {
    English: "Group Benefits Resources \n",
    French: "Ressources sur les avantages sociaux collectifs \n",
    Spanish: "Recursos de beneficios grupales \n",
    key: "Group_Benefits_Resources",
  },
  {
    English: "green shield canada",
    French: "bouclier vert canada",
    Spanish: "escudo verde canadá",
    key: "green_shield_canada",
  },
  {
    English: "Group Benefits Plans Summary \n",
    French: "Sommaire des régimes d’avantages sociaux collectifs \n",
    Spanish: "Resumen de planes de beneficios grupales \n",
    key: "Group_Benefits_Plans_Summary",
  },
  {
    English: "\nShow all invoices",
    French: "\nAfficher toutes les factures",
    Spanish: "\nMostrar todas las facturas",
    key: "Show_all_invoices",
  },
  {
    English: "Invoice \n",
    French: "Facture \n",
    Spanish: "Factura \n",
    key: "Invoice",
  },
  {
    English: "Click here to login",
    French: "Cliquez ici pour vous connecter",
    Spanish: "Haga clic aquí para iniciar sesión",
    key: "Click_here_to_login",
  },
  {
    English: "View your plan Benifits",
    French: "Consultez votre forfait",
    Spanish: "Ver tu plan Beneficios",
    key: "View_your_plan_Benifits",
  },
  {
    English: "Visit: https://teledoc.ca/medical-experts",
    French: "Visitez : https://teledoc.ca/medical-experts",
    Spanish: "Visite: https://teledoc.ca/medical-experts",
    key: "Visit_https_teledoc_ca_medical_experts",
  },
  {
    English:
      "You may now book a pain management appointmentwith an athletic therapist",
    French:
      "Vous pouvez désormais prendre rendez-vous pour la gestion de la douleur avec un thérapeute du sport",
    Spanish:
      "Ahora puede reservar una cita para el tratamiento del dolor con un terapeuta deportivo.",
    key: "You_may_now_book_a_pain_management_appointmentwith_an_athletic_therapist",
  },
  {
    English:
      "You may also choose the Self Service option that matches recommended stretches with your specific pain",
    French:
      "Vous pouvez également choisir l'option Self Service qui adapte les étirements recommandés à votre douleur spécifique.",
    Spanish:
      "También puede elegir la opción de Autoservicio que combine los estiramientos recomendados con su dolor específico.",
    key: "You_may_also_choose_the_Self_Service_option_that_matches_recommended_stretches_with_your_specific_pain",
  },
  {
    English: "Order your Executive Health Assessment",
    French: "Commandez votre évaluation de santé des cadres",
    Spanish: "Solicite su Evaluación de Salud Ejecutiva",
    key: "Order_your_Executive_Health_Assessment",
  },
  {
    English: "Note \n\n",
    French: "Note \n\n",
    Spanish: "Nota \n\n",
    key: "Note",
  },
  {
    English:
      "Please update the payment method in the corporate dashboard. \n\n",
    French:
      "Veuillez mettre à jour le mode de paiement dans le tableau de bord de l'entreprise. \n\n",
    Spanish: "Actualice el método de pago en el panel corporativo. \n\n",
    key: "Please_update_the_payment_method_in_the_corporate_dashboard",
  },
  {
    English: "Request your CandooHealth Access here",
    French: "Demandez votre accès CandooHealth ici",
    Spanish: "Solicita tu Acceso CandooHealth aquí",
    key: "Request_your_CandooHealth_Access_here",
  },
  {
    English: "Corporate Proposal Status \n",
    French: "Statut de la proposition d'entreprise \n",
    Spanish: "Estado de la propuesta corporativa \n",
    key: "Corporate_Proposal_Status",
  },
  {
    English: "Proposal received on",
    French: "Proposition reçue le",
    Spanish: "Propuesta recibida el",
    key: "Proposal_received_on",
  },
  {
    English: "Amendments",
    French: "Amendements",
    Spanish: "Enmiendas",
    key: "Amendments",
  },
  {
    English: "Enrolled",
    French: "Inscrit",
    Spanish: "Inscrito",
    key: "Enrolled",
  },
  {
    English: "Enrollment Summary \n",
    French: "Résumé des inscriptions \n",
    Spanish: "Resumen de inscripción \n",
    key: "Enrollment_Summary",
  },
  {
    English: "Employees invited to Enroll",
    French: "Salariés invités à s'inscrire",
    Spanish: "Empleados invitados a inscribirse",
    key: "Employees_invited_to_Enroll",
  },
  {
    English: "Marketing & Promotions",
    French: "Commercialisation et promotions",
    Spanish: "Marketing y promociones",
    key: "Marketing_Promotions",
  },
  {
    English: "Password must not exceed 40 characters \n",
    French: "Le mot de passe ne doit pas dépasser 40 caractères \n",
    Spanish: "La contraseña no debe exceder los 40 caracteres \n",
    key: "Password_must_not_exceed_40_characters",
  },
  {
    English: "Password must be at least 8 characters \n",
    French: "Le mot de passe doit contenir au moins 8 caractères \n",
    Spanish: "La contraseña debe tener al menos 8 caracteres. \n",
    key: "Password_must_be_at_least_8_characters",
  },
  {
    English: "Passwords did not match \n",
    French: "Les mots de passe ne correspondent pas \n",
    Spanish: "Las contraseñas no coincidieron \n",
    key: "Passwords_did_not_match",
  },
  {
    English: "Please enter confirm password \n",
    French: "Veuillez saisir le mot de passe confirmé \n",
    Spanish: "Por favor ingrese confirmar contraseña \n",
    key: "Please_enter_confirm_password",
  },
  {
    English: "Total",
    French: "Total",
    Spanish: "Total",
    key: "Total",
  },
  {
    English: "Guaranteed Approval",
    French: "Approbation garantie",
    Spanish: "Aprobación garantizada",
    key: "Guaranteed_Approval",
  },
  {
    English: "Pending Approval",
    French: "En attente d'approbation",
    Spanish: "Pendiente de aprobación",
    key: "Pending_Approval",
  },
  {
    English: "The GroupBenefitz Platform Inc.",
    French: "La Plateforme GroupBenefitz Inc.",
    Spanish: "El grupo Benefitz Platform Inc.",
    key: "The_GroupBenefitz_Platform_Inc",
  },
  {
    English: "Version",
    French: "Version",
    Spanish: "Versión",
    key: "Version",
  },
  {
    English:
      "An error occurred while processing the transaction. possible failure reasons are",
    French:
      "Une erreur s'est produite lors du traitement de la transaction. les raisons possibles de l'échec sont",
    Spanish:
      "Se produjo un error al procesar la transacción. Las posibles razones del fallo son",
    key: "An_error_occurred_while_processing_the_transaction_possible_failure_reasons_are",
  },
  {
    English: "The payment information could not be verified",
    French: "Les informations de paiement n'ont pas pu être vérifiées",
    Spanish: "No se pudo verificar la información de pago.",
    key: "The_payment_information_could_not_be_verified",
  },
  {
    English: "No Health Cards Found",
    French: "Aucune carte de santé trouvée",
    Spanish: "No se encontraron tarjetas sanitarias",
    key: "No_Health_Cards_Found",
  },
  {
    English: "No booklets Selected",
    French: "Aucun livret sélectionné",
    Spanish: "No hay folletos seleccionados",
    key: "No_booklets_Selected",
  },
  {
    English: "No Booklets Found",
    French: "Aucun livret trouvé",
    Spanish: "No se encontraron folletos",
    key: "No_Booklets_Found",
  },
  {
    English: "Please enter no.of employees",
    French: "Veuillez entrer le nombre d'employés",
    Spanish: "Por favor ingrese el número de empleados",
    key: "Please_enter_no_of_employees",
  },
  {
    English:
      "Annual Income Shouldn't allow numbers, special characters and blank spaces",
    French:
      "Le revenu annuel ne doit pas autoriser les chiffres, les caractères spéciaux et les espaces vides",
    Spanish:
      "El ingreso anual no debe permitir números, caracteres especiales ni espacios en blanco.",
    key: "Annual_Income_Shouldn_t_allow_numbers_special_characters_and_blank_spaces",
  },
  {
    English: "Please select Marital Status",
    French: "Veuillez sélectionner votre état civil",
    Spanish: "Por favor seleccione Estado Civil",
    key: "Please_select_Marital_Status",
  },
  {
    English: "Please enter annual income",
    French: "Veuillez saisir le revenu annuel",
    Spanish: "Por favor ingrese el ingreso anual",
    key: "Please_enter_annual_income",
  },
  {
    English:
      "Numerics, Special Characters, Blank Spaces are not allowed in First Name.",
    French:
      "Les chiffres, les caractères spéciaux et les espaces vides ne sont pas autorisés dans le prénom.",
    Spanish:
      "No se permiten números, caracteres especiales ni espacios en blanco en el nombre.",
    key: "Numerics_Special_Characters_Blank_Spaces_are_not_allowed_in_First_Name",
  },
  {
    English: "Plan enrollment date is-",
    French: "La date d’inscription au plan est-",
    Spanish: "La fecha de inscripción del plan es-",
    key: "Plan_enrollment_date_is",
  },
  {
    English: "Post-Secondary Student",
    French: "Étudiant postsecondaire",
    Spanish: "Estudiante postsecundario",
    key: "Post_Secondary_Student",
  },
  {
    English: "Primary Information",
    French: "Informations primaires",
    Spanish: "Información primaria",
    key: "Primary_Information",
  },
  {
    English: "User Name",
    French: "Nom d'utilisateur",
    Spanish: "Nombre de usuario",
    key: "User_Name",
  },
  {
    English: "Current period",
    French: "Période actuelle",
    Spanish: "Periodo actual",
    key: "Current_period",
  },
  {
    English: "CA",
    French: "Californie",
    Spanish: "California",
    key: "CA",
  },
  {
    English: "Plans & Cost",
    French: "Forfaits et coûts",
    Spanish: "Planes y costos",
    key: "Plans_Cost",
  },
  {
    English: "Upload Plans",
    French: "Télécharger des forfaits",
    Spanish: "Subir Planes",
    key: "Upload_Plans",
  },
  {
    English: "Upcoming Period",
    French: "Période à venir",
    Spanish: "Próximo período",
    key: "Upcoming_Period",
  },
  {
    English: "Tax",
    French: "Impôt",
    Spanish: "Impuesto",
    key: "Tax",
  },
  {
    English: "Proceed With PHR",
    French: "Continuer avec PHR",
    Spanish: "Continuar con PHR",
    key: "Proceed_With_PHR",
  },
  {
    English: "Service Type",
    French: "Type de service",
    Spanish: "Tipo de servicio",
    key: "Service_Type",
  },
  {
    English: "Customer Type",
    French: "Type de client",
    Spanish: "Tipo de cliente",
    key: "Customer_Type",
  },
  {
    English: "Registration Date",
    French: "Date d'inscription",
    Spanish: "Fecha de registro",
    key: "Registration_Date",
  },
  {
    English: "Plan enrollment date is",
    French: "La date d’adhésion au plan est",
    Spanish: "La fecha de inscripción al plan es",
    key: "Plan_enrollment_date_is",
  },
  {
    English: "IGBMS Id",
    French: "Identifiant IGBMS",
    Spanish: "Identificación del IGBMS",
    key: "IGBMS_Id",
  },
  {
    English: "Are you sure you want to send an invitation to",
    French: "Etes-vous sûr de vouloir envoyer une invitation à",
    Spanish: "¿Está seguro de que desea enviar una invitación a",
    key: "Are_you_sure_you_want_to_send_an_invitation_to",
  },
  {
    English: "Minimium Date :",
    French: "Date minimale :",
    Spanish: "Fecha mínima:",
    key: "Minimium_Date",
  },
  {
    English: "No Plans Defined Currently",
    French: "Aucun plan défini actuellement",
    Spanish: "No hay planes definidos actualmente",
    key: "No_Plans_Defined_Currently",
  },
  {
    English: "Partially Completed",
    French: "Partiellement terminé",
    Spanish: "Parcialmente completado",
    key: "Partially_Completed",
  },
  {
    English: "Profiles",
    French: "Profils",
    Spanish: "Perfiles",
    key: "Profiles",
  },
  {
    English: "Pending",
    French: "En instance",
    Spanish: "Pendiente",
    key: "Pending",
  },
  {
    English: "enter old password",
    French: "entrez l'ancien mot de passe",
    Spanish: "ingrese la contraseña anterior",
    key: "enter_old_password",
  },
  {
    English: "Member Name",
    French: "Nom du membre",
    Spanish: "Nombre de miembro",
    key: "Member_Name",
  },
  {
    English: "Switch Profiles",
    French: "Changer de profil",
    Spanish: "Cambiar perfiles",
    key: "Switch_Profiles",
  },
  {
    English: "Log Out",
    French: "Se déconnecter",
    Spanish: "Finalizar la sesión",
    key: "Log_Out",
  },
  {
    English: "Manage Corporate Clients",
    French: "Gérer les clients corporatifs",
    Spanish: "Gestionar clientes corporativos",
    key: "Manage_Corporate_Clients",
  },
  {
    English: "Account Status",
    French: "Statut du compte",
    Spanish: "Estado de la cuenta",
    key: "Account_Status",
  },
  {
    English: "Completed",
    French: "Complété",
    Spanish: "Terminado",
    key: "Completed",
  },
  {
    English: "Old password same as New password",
    French: "Ancien mot de passe identique au nouveau mot de passe",
    Spanish: "Contraseña anterior igual que la nueva contraseña",
    key: "Old_password_same_as_New_password",
  },
  {
    English: "Date of hire",
    French: "Date d'embauche",
    Spanish: "Fecha de contratación",
    key: "Date_of_hire",
  },
  {
    English: "No Membership Cards available",
    French: "Aucune carte de membre disponible",
    Spanish: "No hay tarjetas de membresía disponibles",
    key: "No_Membership_Cards_available",
  },
  {
    English: "A/c No",
    French: "Climatisation Non",
    Spanish: "Aire acondicionado No",
    key: "A_c_No",
  },
  {
    English: "Emp Id",
    French: "Identifiant d'employé",
    Spanish: "Identificación del emp",
    key: "Emp_Id",
  },
  {
    English: "Province Name",
    French: "Nom de la province",
    Spanish: "Nombre de la Provincia",
    key: "Province_Name",
  },
  {
    English: "No Data Available",
    French: "Aucune Donnée Disponible",
    Spanish: "No hay Datos Disponibles",
    key: "No_Data_Available",
  },
  {
    English: "My Contracts",
    French: "Mes contrats",
    Spanish: "Mis contratos",
    key: "My_Contracts",
  },
  {
    English: "ROE Agreement",
    French: "Accord RE",
    Spanish: "Acuerdo ROE",
    key: "ROE_Agreement",
  },
  {
    English: "(Group)",
    French: "(Groupe)",
    Spanish: "(Grupo)",
    key: "Group",
  },
  {
    English: "No Tier Plans to show",
    French: "Aucun plan de niveau à afficher",
    Spanish: "No hay planes de niveles para mostrar",
    key: "No_Tier_Plans_to_show",
  },
  {
    English: "Expiry",
    French: "Expiration",
    Spanish: "Expiración",
    key: "Expiry",
  },
  {
    English: "Please Select waiting period for employees on initial Signup",
    French:
      "Veuillez sélectionner la période d'attente pour les employés lors de l'inscription initiale",
    Spanish:
      "Seleccione el período de espera para los empleados en el registro inicial",
    key: "Please_Select_waiting_period_for_employees_on_initial_Signup",
  },
  {
    English: "Please Select",
    French: "Veuillez sélectionner",
    Spanish: "Por favor seleccione",
    key: "Please_Select",
  },
  {
    English: "Please enter role name",
    French: "Veuillez saisir le nom du rôle",
    Spanish: "Por favor ingrese el nombre del rol",
    key: "Please_enter_role_name",
  },
  {
    English:
      "First name Shouldn't allow numbers, special characters and blank spaces",
    French:
      "Prénom Ne doit pas autoriser les chiffres, les caractères spéciaux et les espaces",
    Spanish:
      "Nombre No debe permitir números, caracteres especiales y espacios en blanco",
    key: "First_name_Shouldn_t_allow_numbers_special_characters_and_blank_spaces",
  },
  {
    English: "View ROEs",
    French: "Afficher les RE",
    Spanish: "Ver ROE",
    key: "View_ROEs",
  },
  {
    English: "Edit settings",
    French: "Modifier les paramètres",
    Spanish: "Editar configuración",
    key: "Edit_settings",
  },
  {
    English: "Please update the payment method in the corporate dashboard",
    French:
      "Veuillez mettre à jour le mode de paiement dans le tableau de bord de l'entreprise",
    Spanish: "Actualice el método de pago en el panel corporativo.",
    key: "Please_update_the_payment_method_in_the_corporate_dashboard",
  },
  {
    English: "ROE Agreement",
    French: "Accord RE",
    Spanish: "Acuerdo ROE",
    key: "ROE_Agreement",
  },
  {
    English:
      "Last name Shouldn't allow numbers, special characters and blank spaces",
    French:
      "Nom de famille Ne doit pas autoriser les chiffres, les caractères spéciaux et les espaces",
    Spanish:
      "Apellido No debe permitir números, caracteres especiales ni espacios en blanco.",
    key: "Last_name_Shouldn_t_allow_numbers_special_characters_and_blank_spaces",
  },
  {
    English: "Corporation name should be 3 characters",
    French: "Le nom de la société doit comporter 3 caractères",
    Spanish: "El nombre de la corporación debe tener 3 caracteres.",
    key: "Corporation_name_should_be_3_characters",
  },
  {
    English: "View Your Plan Benefits",
    French: "Consultez les avantages de votre régime",
    Spanish: "Vea los beneficios de su plan",
    key: "View_Your_Plan_Benefits",
  },
  {
    English:
      "Corporation name Shouldn't allow numbers, special characters and blank spaces",
    French:
      "Le nom de la société ne doit pas autoriser les chiffres, les caractères spéciaux et les espaces",
    Spanish:
      "Nombre de la corporación No debe permitir números, caracteres especiales ni espacios en blanco.",
    key: "Corporation_name_Shouldn_t_allow_numbers_special_characters_and_blank_spaces",
  },
  {
    English: "Please select country",
    French: "Veuillez sélectionner un pays",
    Spanish: "Por favor seleccione país",
    key: "Please_select_country",
  },
  {
    English: "Corporation name must not exceed 70 characters",
    French: "Le nom de la société ne doit pas dépasser 70 caractères",
    Spanish: "El nombre de la corporación no debe exceder los 70 caracteres.",
    key: "Corporation_name_must_not_exceed_70_characters",
  },
  {
    English: "Please select at least one Province",
    French: "Veuillez sélectionner au moins une province",
    Spanish: "Por favor seleccione al menos una Provincia",
    key: "Please_select_at_least_one_Province",
  },
  {
    English: "Please enter corporation name",
    French: "Veuillez entrer le nom de la société",
    Spanish: "Por favor ingrese el nombre de la corporación",
    key: "Please_enter_corporation_name",
  },
  {
    English: "Add Employee",
    French: "Ajouter un employé",
    Spanish: "Agregar empleado",
    key: "Add_Employee",
  },
  {
    English: "Please choose policy start date",
    French: "Veuillez choisir la date de début de la police",
    Spanish: "Por favor elija la fecha de inicio de la póliza",
    key: "Please_choose_policy_start_date",
  },
  {
    English: "Are you sure you want to delete this contact?",
    French: "Êtes-vous sûr de vouloir supprimer ce contact ?",
    Spanish: "¿Estás seguro de que deseas eliminar este contacto?",
    key: "Are_you_sure_you_want_to_delete_this_contact",
  },
  {
    English: "Bank Code",
    French: "Code Bancaire",
    Spanish: "Código Bancario",
    key: "Bank_Code",
  },
  {
    English: "Bank code must be 3 digits",
    French: "Le code bancaire doit être composé de 3 chiffres",
    Spanish: "El código bancario debe tener 3 dígitos.",
    key: "Bank_code_must_be_3_digits",
  },
  {
    English: "Please enter bank code",
    French: "Veuillez saisir le code bancaire",
    Spanish: "Por favor ingrese el código bancario",
    key: "Please_enter_bank_code",
  },
  {
    English: "Bank code must be 3 digits",
    French: "Le code bancaire doit être composé de 3 chiffres",
    Spanish: "El código bancario debe tener 3 dígitos.",
    key: "Bank_code_must_be_3_digits",
  },
  {
    English: "Bank transit must be 5 digits",
    French: "Le transit bancaire doit être composé de 5 chiffres",
    Spanish: "El tránsito bancario debe tener 5 dígitos.",
    key: "Bank_transit_must_be_5_digits",
  },
  {
    English: "Please enter bank transit",
    French: "Veuillez saisir le transit bancaire",
    Spanish: "Por favor ingrese tránsito bancario",
    key: "Please_enter_bank_transit",
  },
  {
    English: "Please enter Account number",
    French: "Veuillez entrer le numéro de compte",
    Spanish: "Por favor ingrese el número de cuenta",
    key: "Please_enter_Account_number",
  },
  {
    English: "Bank transit must be 5 digits",
    French: "Le transit bancaire doit être composé de 5 chiffres",
    Spanish: "El tránsito bancario debe tener 5 dígitos.",
    key: "Bank_transit_must_be_5_digits",
  },
  {
    English: "Account No",
    French: "Numéro de compte ",
    Spanish: "Número de cuenta ",
    key: "Account_No",
  },
  {
    English: "Account number minimum of 5 digits",
    French: "Numéro de compte minimum de 5 chiffres",
    Spanish: "Número de cuenta mínimo de 5 dígitos",
    key: "Account_number_minimum_of_5_digits",
  },
  {
    English: "Account number maximum of 12 digits",
    French: "Numéro de compte maximum de 12 chiffres",
    Spanish: "Número de cuenta máximo de 12 dígitos",
    key: "Account_number_maximum_of_12_digits",
  },
  {
    English: "Please enter Card number",
    French: "Veuillez saisir le numéro de carte",
    Spanish: "Por favor ingrese el número de tarjeta",
    key: "Please_enter_Card_number",
  },
  {
    English: "Expiry Month",
    French: "Mois d'expiration",
    Spanish: "Mes de vencimiento",
    key: "Expiry_Month",
  },
  {
    English: "Please select expiry month",
    French: "Veuillez sélectionner le mois d'expiration",
    Spanish: "Por favor seleccione el mes de vencimiento",
    key: "Please_select_expiry_month",
  },
  {
    English: "CVV",
    French: "CVV",
    Spanish: "CVV",
    key: "CVV",
  },
  {
    English: "Expiry Year",
    French: "Année d'expiration",
    Spanish: "Año de vencimiento",
    key: "Expiry_Year",
  },
  {
    English: "Please select expiry year",
    French: "Veuillez sélectionner l'année d'expiration",
    Spanish: "Por favor seleccione el año de vencimiento",
    key: "Please_select_expiry_year",
  },
  {
    English: "CVV must be 3 or 4 digits",
    French: "Le CVV doit être composé de 3 ou 4 chiffres",
    Spanish: "CVV debe tener 3 o 4 dígitos",
    key: "CVV_must_be_3_or_4_digits",
  },
  {
    English: "Please enter cvv",
    French: "Veuillez entrer cvv",
    Spanish: "Por favor introduce cvv",
    key: "Please_enter_cvv",
  },
  {
    English: "Please select recaptcha",
    French: "Veuillez sélectionner recaptcha",
    Spanish: "Por favor seleccione recaptcha",
    key: "Please_select_recaptcha",
  },
  {
    English: "Employee Delete",
    French: "Employé Supprimer",
    Spanish: "Eliminar empleado",
    key: "Employee_Delete",
  },
  {
    English: "Are you sure you want to delete?",
    French: "Êtes-vous sûr de vouloir supprimer ?",
    Spanish: "¿Estás seguro de que deseas eliminar?",
    key: "Are_you_sure_you_want_to_delete",
  },
  {
    English: "Membership Card",
    French: "Carte de membre",
    Spanish: "Tarjeta de Membresía",
    key: "Membership_Card",
  },
  {
    English: "re you sure you want to delete this Logo?",
    French: "Êtes-vous sûr de vouloir supprimer ce logo ?",
    Spanish: "¿Estás seguro de que deseas eliminar este logotipo?",
    key: "re_you_sure_you_want_to_delete_this_Logo",
  },
  {
    English: "Please enter role name",
    French: "Veuillez saisir le nom du rôle",
    Spanish: "Por favor ingrese el nombre del rol",
    key: "Please_enter_role_name",
  },
  {
    English: "Are you sure you want to delete this Logo?",
    French: "Êtes-vous sûr de vouloir supprimer ce logo ?",
    Spanish: "¿Está seguro de que desea eliminar este logotipo?",
    key: "Are_you_sure_you_want_to_delete_this_Logo",
  },
  {
    English: "File size is too large,maximum file size is 1 Mb",
    French:
      "La taille du fichier est trop grande, la taille maximale du fichier est de 1 Mo.",
    Spanish:
      "El tamaño del archivo es demasiado grande, el tamaño máximo del archivo es 1 Mb",
    key: "File_size_is_too_large_maximum_file_size_is_1_Mb",
  },
  {
    English: "Add PAD",
    French: "Ajouter un PAD",
    Spanish: "Agregar almohadilla",
    key: "Add_PAD",
  },
  {
    English: "Add Credit Card",
    French: "Ajouter une carte de crédit",
    Spanish: "Agregar tarjeta de crédito",
    key: "Add_Credit_Card",
  },
  {
    English: "warning",
    French: "avertissement",
    Spanish: "advertencia",
    key: "warning",
  },
  {
    English: "Can't delete the contact when there is only one",
    French: "Impossible de supprimer le contact lorsqu'il n'y en a qu'un",
    Spanish: "No se puede eliminar el contacto cuando solo hay uno",
    key: "Can_t_delete_the_contact_when_there_is_only_one",
  },
  {
    English: "Group admin details updated successfully",
    French:
      "Les détails de l'administrateur du groupe ont été mis à jour avec succès",
    Spanish: "Detalles del administrador del grupo actualizados exitosamente",
    key: "Group_admin_details_updated_successfully",
  },
  {
    English: "Some fields have invalid email, please check",
    French:
      "Certains champs ont une adresse e-mail invalide, veuillez vérifier",
    Spanish:
      "Algunos campos tienen un correo electrónico no válido, verifíquelo",
    key: "Some_fields_have_invalid_email_please_check",
  },
  {
    English: "Province of Employment is not listed",
    French: "La province d'emploi n'est pas répertoriée",
    Spanish: "La provincia de empleo no figura en la lista",
    key: "Province_of_Employment_is_not_listed",
  },
  {
    English: "Province of Employment can't be empty",
    French: "La province d'emploi ne peut pas être vide",
    Spanish: "La Provincia de Empleo no puede estar vacía",
    key: "Province_of_Employment_can_t_be_empty",
  },
  {
    English: "Employee Count updated successfully.",
    French: "Le nombre d'employés a été mis à jour avec succès.",
    Spanish: "El recuento de empleados se actualizó correctamente.",
    key: "Employee_Count_updated_successfully",
  },
  {
    English: "mail already exists in existing file",
    French: "le courrier existe déjà dans le fichier existant",
    Spanish: "el correo ya existe en el archivo existente",
    key: "mail_already_exists_in_existing_file",
  },
  {
    English: "Please selected employees must be",
    French: "Veuillez sélectionner les employés doivent être",
    Spanish: "Por favor, los empleados seleccionados deben ser",
    key: "Please_selected_employees_must_be",
  },
  {
    English: "Employee count updated successfully to",
    French: "Le nombre d'employés a été mis à jour avec succès pour",
    Spanish: "El recuento de empleados se actualizó correctamente para",
    key: "Employee_count_updated_successfully_to",
  },
  {
    English: "Procced",
    French: "Continuer",
    Spanish: "Procedido",
    key: "Procced",
  },
  {
    English: "Broker",
    French: "Courtier",
    Spanish: "Corredor",
    key: "Broker",
  },
  {
    English: "Check",
    French: "Vérifier",
    Spanish: "Controlar",
    key: "Check",
  },
  {
    English: "Form",
    French: "Formulaire",
    Spanish: "Forma",
    key: "Form",
  },
  {
    English: "Please select Form type",
    French: "Veuillez sélectionner le type de formulaire",
    Spanish: "Por favor seleccione tipo de formulario",
    key: "Please_select_Form_type",
  },
  {
    English: "Plan Selection",
    French: "Sélection de forfaits",
    Spanish: "Selección de planes",
    key: "Plan_Selection",
  },
  {
    English: "Personal Info",
    French: "Informations personnelles",
    Spanish: "Información personal",
    key: "Personal_Info",
  },
  {
    English: "Please select broker name",
    French: "Veuillez sélectionner le nom du courtier",
    Spanish: "Por favor seleccione el nombre del corredor",
    key: "Please_select_broker_name",
  },
  {
    English: "Employee Information",
    French: "Informations sur les employés",
    Spanish: "Información del empleado",
    key: "Employee_Information",
  },
  {
    English: "Enrollment Summary",
    French: "Résumé des inscriptions",
    Spanish: "Resumen de inscripción",
    key: "Enrollment_Summary",
  },
  {
    English: "Please choose plan enrollment date",
    French: "Veuillez choisir la date d'adhésion au plan",
    Spanish: "Por favor elija la fecha de inscripción al plan",
    key: "Please_choose_plan_enrollment_date",
  },
  {
    English: "Invalid phone number format",
    French: "Format de numéro de téléphone invalide",
    Spanish: "Formato de número de teléfono no válido",
    key: "Invalid_phone_number_format",
  },
  {
    English: "Please Choose Date of Birth",
    French: "Veuillez choisir votre date de naissance",
    Spanish: "Por favor elija fecha de nacimiento",
    key: "Please_Choose_Date_of_Birth",
  },
  {
    English: "Registrant age must be 16 or greater",
    French: "L'âge de l'inscrit doit être de 16 ans ou plus",
    Spanish: "La edad del registrante debe ser mayor de 16 años.",
    key: "Registrant_age_must_be_16_or_greater",
  },
  {
    English: "Registrant age must be 60 or below",
    French: "L'âge du participant doit être de 60 ans ou moins",
    Spanish: "La edad del registrante debe ser 60 años o menos.",
    key: "Registrant_age_must_be_60_or_below",
  },
  {
    English: "Non_Binary",
    French: "Non_binaire",
    Spanish: "No binario",
    key: "Non_Binary",
  },
  {
    English: "undisclosed",
    French: "non divulgué",
    Spanish: "no revelado",
    key: "undisclosed",
  },
  {
    English: "Please Select Gender",
    French: "Veuillez sélectionner le sexe",
    Spanish: "Por favor seleccione género",
    key: "Please_Select_Gender",
  },
  {
    English: "Please enter Street Address",
    French: "Veuillez entrer l'adresse postale",
    Spanish: "Por favor ingrese la dirección",
    key: "Please_enter_Street_Address",
  },
  {
    English: "Home Mailing Address",
    French: "Adresse postale du domicile",
    Spanish: "Dirección postal de casa",
    key: "Home_Mailing_Address",
  },
  {
    English: "Please enter City",
    French: "Veuillez entrer la ville",
    Spanish: "Por favor ingrese la ciudad",
    key: "Please_enter_City",
  },
  {
    English: "Spouse Information",
    French: "Informations sur le conjoint",
    Spanish: "Información del cónyuge",
    key: "Spouse_Information",
  },
  {
    English:
      "I confirm that I am actively working 20 or more hours per week to meet plan eligibility",
    French:
      "Je confirme que je travaille activement 20 heures ou plus par semaine pour répondre à mon admissibilité au plan.",
    Spanish:
      "Confirmo que estoy trabajando activamente 20 horas o más por semana para cumplir con la elegibilidad del plan.",
    key: "I_confirm_that_I_am_actively_working_20_or_more_hours_per_week_to_meet_plan_eligibility",
  },
  {
    English:
      "To enroll in the plan you need to be working 20 or more hours per week",
    French:
      "Pour adhérer au plan, vous devez travailler 20 heures ou plus par semaine",
    Spanish:
      "Para inscribirse en el plan es necesario trabajar 20 horas o más por semana.",
    key: "To_enroll_in_the_plan_you_need_to_be_working_20_or_more_hours_per_week",
  },
  {
    English: "How many hours per week do you work?",
    French: "Combien d'heures par semaine travaillez-vous ?",
    Spanish: "¿Cuántas horas por semana trabajas?",
    key: "How_many_hours_per_week_do_you_work",
  },
  {
    English: "Hours Per week should be less than 80",
    French: "Les heures par semaine devraient être inférieures à 80",
    Spanish: "Las horas por semana deben ser menos de 80.",
    key: "Hours_Per_week_should_be_less_than_80",
  },
  {
    English: "Please select working hours per week",
    French: "Veuillez sélectionner les heures de travail par semaine",
    Spanish: "Por favor seleccione horas de trabajo por semana",
    key: "Please_select_working_hours_per_week",
  },
  {
    English: "Hours Per week should be more than 20",
    French: "Les heures par semaine devraient être supérieures à 20",
    Spanish: "Las horas por semana deben ser más de 20.",
    key: "Hours_Per_week_should_be_more_than_20",
  },
  {
    English:
      "You are not eligible to apply without a health card from your province.",
    French:
      "Vous ne pouvez pas présenter de demande sans une carte Santé de votre province.",
    Spanish:
      "No eres elegible para postularte sin una tarjeta sanitaria de tu provincia.",
    key: "You_are_not_eligible_to_apply_without_a_health_card_from_your_province",
  },
  {
    English:
      "I confirm that I have provincial health coverage in my province of residence",
    French:
      "Je confirme que j'ai une couverture santé provinciale dans ma province de résidence",
    Spanish:
      "Confirmo que tengo cobertura sanitaria provincial en mi provincia de residencia",
    key: "I_confirm_that_I_have_provincial_health_coverage_in_my_province_of_residence",
  },
  {
    English: "Date of Arrival in Canada",
    French: "Date d'arrivée au Canada",
    Spanish: "Fecha de llegada a Canadá",
    key: "Date_of_Arrival_in_Canada",
  },
  {
    English: "Please select date of arrival in Canada",
    French: "Veuillez sélectionner la date d'arrivée au Canada",
    Spanish: "Por favor seleccione la fecha de llegada a Canadá",
    key: "Please_select_date_of_arrival_in_Canada",
  },
  {
    English: "Country of Origin",
    French: "Pays d'origine",
    Spanish: "País natal",
    key: "Country_of_Origin",
  },
  {
    English: "Please select country of origin.",
    French: "Veuillez sélectionner le pays d'origine.",
    Spanish: "Por favor seleccione país de origen.",
    key: "Please_select_country_of_origin",
  },
  {
    English: "Is the employee a landed immigrant?",
    French: "L'employé est-il un immigrant reçu?",
    Spanish: "¿Es el empleado un inmigrante desembarcado?",
    key: "Is_the_employee_a_landed_immigrant",
  },
  {
    English: "Please choose employee landed immigrant",
    French: "Veuillez choisir un employé immigrant reçu",
    Spanish: "Por favor elija empleado inmigrante desembarcado",
    key: "Please_choose_employee_landed_immigrant",
  },
  {
    English: "Will he/she be applying for landed status?",
    French: "Va-t-il demander le statut d'établissement?",
    Spanish: "¿Solicitará el estatus de terrateniente?",
    key: "Will_he_she_be_applying_for_landed_status",
  },
  {
    English: "Please choose landed status",
    French: "Veuillez choisir le statut d'établissement",
    Spanish: "Por favor elija el estado aterrizado",
    key: "Please_choose_landed_status",
  },
  {
    English: "Is coverage required for the employee?",
    French: "Une couverture est-elle obligatoire pour le salarié ?",
    Spanish: "¿Se requiere cobertura para el empleado?",
    key: "Is_coverage_required_for_the_employee",
  },
  {
    English: "Please select coverage required for employee.",
    French: "Veuillez sélectionner la couverture requise pour l'employé.",
    Spanish: "Seleccione la cobertura requerida para el empleado.",
    key: "Please_select_coverage_required_for_employee",
  },
  {
    English:
      "Do you have a spouse (married or living common-law for at least one year)?",
    French:
      "Avez-vous un conjoint (marié ou vivant en union libre depuis au moins un an) ?",
    Spanish:
      "¿Tiene cónyuge (casado o en unión libre durante al menos un año)?",
    key: "Do_you_have_a_spouse_married_or_living_common_law_for_at_least_one_year",
  },
  {
    English: "Spouse Information",
    French: "Informations sur le conjoint",
    Spanish: "Información del cónyuge",
    key: "Spouse_Information",
  },
  {
    English: "Please choose spouse status",
    French: "Veuillez choisir le statut de conjoint",
    Spanish: "Por favor elija el estado del cónyuge",
    key: "Please_choose_spouse_status",
  },
  {
    English: "Please enter spouse first name",
    French: "Veuillez saisir le prénom du conjoint",
    Spanish: "Por favor ingrese el nombre del cónyuge",
    key: "Please_enter_spouse_first_name",
  },
  {
    English: "Please enter spouse last name",
    French: "Veuillez saisir le nom de famille du conjoint",
    Spanish: "Por favor ingrese el apellido del cónyuge",
    key: "Please_enter_spouse_last_name",
  },
  {
    English: "Name Of The Carrier",
    French: "Nom du transporteur",
    Spanish: "Nombre del transportista",
    key: "Name_Of_The_Carrier",
  },
  {
    English: "Coordination of Benefits (COB) Coverage",
    French: "Couverture de la Coordination des Prestations (COB)",
    Spanish: "Cobertura de Coordinación de Beneficios (COB)",
    key: "Coordination_of_Benefits_COB_Coverage",
  },
  {
    English: "Please select name of COB Coverage",
    French: "Veuillez sélectionner le nom de la couverture COB",
    Spanish: "Por favor seleccione el nombre de la Cobertura COB",
    key: "Please_select_name_of_COB_Coverage",
  },
  {
    English: "Please enter name of the carrier",
    French: "Veuillez entrer le nom du transporteur",
    Spanish: "Por favor ingrese el nombre del transportista",
    key: "Please_enter_name_of_the_carrier",
  },
  {
    English: "Dependent Children Information",
    French: "Informations sur les enfants à charge",
    Spanish: "Información sobre hijos dependientes",
    key: "Dependent_Children_Information",
  },
  {
    English: "Please choose children status",
    French: "Veuillez choisir le statut des enfants",
    Spanish: "Por favor elija el estado de los niños",
    key: "Please_choose_children_status",
  },
  {
    English: "please select option",
    French: "veuillez sélectionner l'option",
    Spanish: "por favor seleccione la opción",
    key: "please_select_option",
  },
  {
    English: "Is Coverage required for Dependent(s)",
    French: "La couverture est-elle requise pour les personnes à charge",
    Spanish: "¿Se requiere cobertura para los dependientes?",
    key: "Is_Coverage_required_for_Dependent_s",
  },
  {
    English: "Dependent(s) Information",
    French: "Informations sur les personnes à charge",
    Spanish: "Información de dependientes",
    key: "Dependent_s_Information",
  },
  {
    English: "Please select coverage required for dependents(s).",
    French:
      "Veuillez sélectionner la couverture requise pour les personnes à charge.",
    Spanish: "Seleccione la cobertura requerida para los dependientes.",
    key: "Please_select_coverage_required_for_dependents_s",
  },
  {
    English: "Dependent(s) Date of Arrival in Canada",
    French: "Personne(s) à charge Date d'arrivée au Canada",
    Spanish: "Dependiente(s) Fecha de llegada a Canadá",
    key: "Dependent_s_Date_of_Arrival_in_Canada",
  },
  {
    English: "Please Select date of arrival in Canada",
    French: "Veuillez sélectionner la date d'arrivée au Canada",
    Spanish: "Por favor seleccione fecha de llegada a Canadá",
    key: "Please_Select_date_of_arrival_in_Canada",
  },
  {
    English: "Country of Origin",
    French: "Pays d'origine",
    Spanish: "País natal",
    key: "Country_of_Origin",
  },
  {
    English: "Will they be applying for landed immigrant status?",
    French: "Vont-ils demander le statut d’immigrant reçu ?",
    Spanish: "¿Solicitarán el estatus de inmigrantes terratenientes?",
    key: "Will_they_be_applying_for_landed_immigrant_status",
  },
  {
    English: "Please Select dependent(s) landed immigrant",
    French: "Veuillez sélectionner la ou les personnes à charge immigrant reçu",
    Spanish: "Por favor seleccione dependiente(s) inmigrante aterrizado",
    key: "Please_Select_dependent_s_landed_immigrant",
  },
  {
    English: "Please select dependent(s) country of origin",
    French: "Veuillez sélectionner le pays d'origine des personnes à charge",
    Spanish: "Por favor seleccione el país de origen de los dependientes",
    key: "Please_select_dependent_s_country_of_origin",
  },
  {
    English: "Are the dependents landed immigrants?",
    French: "Les personnes à charge sont-elles des immigrants reçus ?",
    Spanish: "¿Los dependientes son inmigrantes desembarcados?",
    key: "Are_the_dependents_landed_immigrants",
  },
  {
    English: "Please Select dependents(s) landed status",
    French:
      "Veuillez sélectionner les personnes à charge ayant le statut d'établissement",
    Spanish: "Seleccione el estado de aterrizaje de los dependientes",
    key: "Please_Select_dependents_s_landed_status",
  },
  {
    English: "Company Paid",
    French: "Payé par l'entreprise",
    Spanish: "Pagado por la empresa",
    key: "Company_Paid",
  },
  {
    English: "Please Select status of dependent(s) in Canada",
    French: "Veuillez sélectionner le statut des personnes à charge au Canada",
    Spanish: "Seleccione el estado de los dependientes en Canadá",
    key: "Please_Select_status_of_dependent_s_in_Canada",
  },
  {
    English: "Will the dependent(s) be in Canada for more than 3 months?",
    French:
      "La ou les personnes à charge seront-elles au Canada pendant plus de 3 mois ?",
    Spanish: "¿Estarán los dependientes en Canadá por más de 3 meses?",
    key: "Will_the_dependent_s_be_in_Canada_for_more_than_3_months",
  },
  {
    English: "Upgrade To",
    French: "Mettre à niveau vers",
    Spanish: "Actualizar a",
    key: "Upgrade_To",
  },
  {
    English: "Voluntary",
    French: "Volontaire",
    Spanish: "Voluntario",
    key: "Voluntary",
  },
  {
    English: "Opy-In",
    French: "Inscription",
    Spanish: "Opy-In",
    key: "Opy_In",
  },
  {
    English: "Employee pays",
    French: "L'employé paie",
    Spanish: "El empleado paga",
    key: "Employee_pays",
  },
  {
    English: "Employee pays through payroll deduction",
    French: "L'employé paie par retenues sur salaire",
    Spanish: "El empleado paga mediante deducción de nómina",
    key: "Employee_pays_through_payroll_deduction",
  },
  {
    English: "Employee pays through CC/PAD",
    French: "L'employé paie via CC/PAD",
    Spanish: "El empleado paga a través de CC/PAD",
    key: "Employee_pays_through_CC_PAD",
  },
  {
    English: "Plans Enrolled",
    French: "Plans inscrits",
    Spanish: "Planes inscritos",
    key: "Plans_Enrolled",
  },
  {
    English: "Plan Name",
    French: "Nom du régime",
    Spanish: "Nombre del plan",
    key: "Plan_Name",
  },
  {
    English: "Home Address same as billing Address",
    French: "Adresse du domicile identique à l'adresse de facturation",
    Spanish: "Dirección de casa igual que la dirección de facturación",
    key: "Home_Address_same_as_billing_Address",
  },
  {
    English: "Pre_authorized_Debit",
    French: "Débit_pré_autorisé",
    Spanish: "Débito_preautorizado",
    key: "Pre_authorized_Debit",
  },
  {
    English: "AptSuite",
    French: "AptSuite",
    Spanish: "AptoSuite",
    key: "AptSuite",
  },
  {
    English: "Please enter valid aptSuite",
    French: "Veuillez saisir une aptSuite valide",
    Spanish: "Por favor introduce aptSuite válido",
    key: "Please_enter_valid_aptSuite",
  },
  {
    English: "SELECTED PLANS",
    French: "FORFAITS SÉLECTIONNÉS",
    Spanish: "PLANES SELECCIONADOS",
    key: "SELECTED_PLANS",
  },
  {
    English: "Plan",
    French: "Plan",
    Spanish: "Plan",
    key: "Plan",
  },
  {
    English: "(Employee)",
    French: "(Employé)",
    Spanish: "(Empleado)",
    key: "Employee",
  },
  {
    English: "All Selected Plans",
    French: "Tous les forfaits sélectionnés",
    Spanish: "Todos los planes seleccionados",
    key: "All_Selected_Plans",
  },
  {
    English: "Premium",
    French: "Prime",
    Spanish: "De primera calidad",
    key: "Premium",
  },
  {
    English: "Monthly Payment Summary",
    French: "Sommaire des paiements mensuels",
    Spanish: "Resumen de pago mensual",
    key: "Monthly_Payment_Summary",
  },
  {
    English: "Company Pays",
    French: "L'entreprise paie",
    Spanish: "La empresa paga",
    key: "Company_Pays",
  },
  {
    English: "Total charge to Company",
    French: "Charge totale pour l'entreprise",
    Spanish: "Cargo total a la empresa",
    key: "Total_charge_to_Company",
  },
  {
    English: "Employee pays through CC/PAD",
    French: "L'employé paie via CC/PAD",
    Spanish: "El empleado paga a través de CC/PAD",
    key: "Employee_pays_through_CC_PAD",
  },
  {
    English: "Total charge to Employee",
    French: "Charge totale pour l'employé",
    Spanish: "Cargo total al empleado",
    key: "Total_charge_to_Employee",
  },
  {
    English: "Plan Summary",
    French: "Sommaire du régime",
    Spanish: "Resumen del plan",
    key: "Plan_Summary",
  },
  {
    English: "Provincial Health Coverage",
    French: "Couverture santé provinciale",
    Spanish: "Cobertura de Salud Provincial",
    key: "Provincial_Health_Coverage",
  },
  {
    English: "Provincial health Coverage is a prerequisite. Please visit",
    French:
      "La couverture santé provinciale est une condition préalable. Veuillez visiter",
    Spanish:
      "La cobertura sanitaria provincial es un requisito previo. Por favor visita",
    key: "Provincial_health_Coverage_is_a_prerequisite_Please_visit",
  },
  {
    English:
      "to apply for provincial health coverage and reapply when it is received.",
    French:
      "demander une assurance-maladie provinciale et présenter une nouvelle demande dès qu’elle est reçue.",
    Spanish:
      "solicitar cobertura sanitaria provincial y volver a solicitarla cuando la reciba.",
    key: "to_apply_for_provincial_health_coverage_and_reapply_when_it_is_received",
  },
  {
    English: "Add Dependent",
    French: "Ajouter une personne à charge",
    Spanish: "Agregar dependiente",
    key: "Add_Dependent",
  },
  {
    English: "Update Dependent",
    French: "Dépendant de la mise à jour",
    Spanish: "Dependiente de la actualización",
    key: "Update_Dependent",
  },
  {
    English:
      "Please ensure the graduation date is later than the date of birth.",
    French:
      "Veuillez vous assurer que la date d'obtention du diplôme est postérieure à la date de naissance.",
    Spanish:
      "Asegúrese de que la fecha de graduación sea posterior a la fecha de nacimiento.",
    key: "Please_ensure_the_graduation_date_is_later_than_the_date_of_birth",
  },
  {
    English: "Choose Options",
    French: "Choisissez les options",
    Spanish: "Elija opciones",
    key: "Choose_Options",
  },
  {
    English:
      "The selection includes GreenShield plans. Do you want to provision in GreenShield?",
    French:
      "La sélection comprend des plans GreenShield. Souhaitez-vous effectuer un provisionnement dans GreenShield ?",
    Spanish:
      "La selección incluye planes GreenShield. ¿Quieres aprovisionar en GreenShield?",
    key: "The_selection_includes_GreenShield_plans_Do_you_want_to_provision_in_GreenShield",
  },
  {
    English: "Provision",
    French: "Disposition",
    Spanish: "Disposición",
    key: "Provision",
  },
  {
    English: "already provisioned",
    French: "déjà provisionné",
    Spanish: "ya aprovisionado",
    key: "already_provisioned",
  },
  {
    English: "Please Select GreenShield provisioning choice.",
    French: "Veuillez sélectionner le choix d'approvisionnement GreenShield.",
    Spanish: "Seleccione la opción de aprovisionamiento GreenShield.",
    key: "Please_Select_GreenShield_provisioning_choice",
  },
  {
    English: "GreenShield Membership Id",
    French: "Identifiant de membre GreenShield",
    Spanish: "Identificación de membresía de GreenShield",
    key: "GreenShield_Membership_Id",
  },
  {
    English: "Please enter greenshield membership Id.",
    French: "Veuillez saisir votre identifiant de membre greenshield.",
    Spanish: "Ingrese el ID de membresía de Greenshield.",
    key: "Please_enter_greenshield_membership_Id",
  },
  {
    English:
      "The selection includes Equitable plans. Do you want to provision in Equitable?",
    French:
      "La sélection comprend des plans Équitables. Souhaitez-vous provisionner en Equitable ?",
    Spanish:
      "La selección incluye planes Equitable. ¿Quieres provisionar en Equitable?",
    key: "The_selection_includes_Equitable_plans_Do_you_want_to_provision_in_Equitable",
  },
  {
    English: "Please Select Equitable provisioning choice..",
    French: "Veuillez sélectionner un choix d'approvisionnement équitable.",
    Spanish: "Seleccione la opción de aprovisionamiento equitativo.",
    key: "Please_Select_Equitable_provisioning_choice",
  },
  {
    English: "Equitable Certifciate Id",
    French: "Identifiant de certificat équitable",
    Spanish: "Identificación del certificado equitativo",
    key: "Equitable_Certifciate_Id",
  },
  {
    English: "Please enter Equitable certificate Id.",
    French: "Veuillez saisir l'ID du certificat Equitable.",
    Spanish: "Introduzca el ID del certificado equitativo.",
    key: "Please_enter_Equitable_certificate_Id",
  },
  {
    English:
      "The selection includes Provincial Health Replacement Plan. Do you want to provision in Cowan?",
    French:
      "La sélection comprend le Plan provincial de remplacement des soins de santé. Vous souhaitez vous approvisionner à Cowan ?",
    Spanish:
      "La selección incluye Plan Provincial de Reposición de Salud. ¿Quieres aprovisionar en Cowan?",
    key: "The_selection_includes_Provincial_Health_Replacement_Plan_Do_you_want_to_provision_in_Cowan",
  },
  {
    English: "Please Select PHR provisioning choice.",
    French: "Veuillez sélectionner le choix de provisionnement PHR.",
    Spanish: "Seleccione la opción de aprovisionamiento de PHR.",
    key: "Please_Select_PHR_provisioning_choice",
  },
  {
    English: "PHR Membership Id",
    French: "Identifiant de membre PHR",
    Spanish: "Identificación de membresía de PHR",
    key: "PHR_Membership_Id",
  },
  {
    English: "Please enter PHR membership Id.",
    French: "Veuillez saisir votre identifiant de membre PHR.",
    Spanish: "Ingrese el ID de membresía de PHR.",
    key: "Please_enter_PHR_membership_Id",
  },
  {
    English:
      "The selection includes KixCare plans. Do you want to provision in KixCare?",
    French:
      "La sélection comprend les plans KixCare. Vous souhaitez vous approvisionner dans KixCare ?",
    Spanish:
      "La selección incluye planes KixCare. ¿Quieres aprovisionar en KixCare?",
    key: "The_selection_includes_KixCare_plans_Do_you_want_to_provision_in_KixCare",
  },
  {
    English: "Please Select KixCare provisioning choice..",
    French: "Veuillez sélectionner le choix d'approvisionnement KixCare.",
    Spanish: "Seleccione la opción de aprovisionamiento de KixCare.",
    key: "Please_Select_KixCare_provisioning_choice",
  },
  {
    English:
      "Send welcome email with Member Portal link upon successful enrollment?",
    French:
      "Envoyer un e-mail de bienvenue avec le lien vers le portail des membres une fois l'inscription réussie ?",
    Spanish:
      "¿Enviar un correo electrónico de bienvenida con el enlace al Portal para miembros tras una inscripción exitosa?",
    key: "Send_welcome_email_with_Member_Portal_link_upon_successful_enrollment",
  },
  {
    English: "Alternate Email",
    French: "E-mail secondaire",
    Spanish: "Correo electrónico alternativo",
    key: "Alternate_Email",
  },
  {
    English: "Please Select invitation mail choice",
    French: "Veuillez sélectionner le choix de courrier d'invitation",
    Spanish: "Seleccione la opción de correo de invitación",
    key: "Please_Select_invitation_mail_choice",
  },
  {
    English: "View Member",
    French: "Afficher le membre",
    Spanish: "Ver miembro",
    key: "View_Member",
  },
  {
    English: "Add Another Member",
    French: "Ajouter un autre membre",
    Spanish: "Agregar otro miembro",
    key: "Add_Another_Member",
  },
  {
    English: "Employee upgraded using payroll deduction",
    French: "Employé reclassé grâce à la retenue sur salaire",
    Spanish: "Empleado ascendido mediante deducción de nómina",
    key: "Employee_upgraded_using_payroll_deduction",
  },
  {
    English: "using payroll deduction",
    French: "utiliser la retenue sur salaire",
    Spanish: "usando la deducción de nómina",
    key: "using_payroll_deduction",
  },
  {
    English: "Employee upgraded using Direct payment",
    French: "Employé reclassé grâce au paiement direct",
    Spanish: "Empleado actualizado mediante pago directo",
    key: "Employee_upgraded_using_Direct_payment",
  },
  {
    English: "using Direct payment",
    French: "en utilisant le paiement direct",
    Spanish: "usando pago directo",
    key: "using_Direct_payment",
  },
  {
    English: "User Not Exists in Stax and Not in BMS",
    French: "L'utilisateur n'existe pas dans Stax et pas dans BMS",
    Spanish: "El usuario no existe en Stax ni en BMS",
    key: "User_Not_Exists_in_Stax_and_Not_in_BMS",
  },
  {
    English: "Please select all plan options",
    French: "Veuillez sélectionner toutes les options du forfait",
    Spanish: "Por favor seleccione todas las opciones del plan",
    key: "Please_select_all_plan_options",
  },
  {
    English: "No Active plans",
    French: "Aucun forfait actif",
    Spanish: "No hay planes activos",
    key: "No_Active_plans",
  },
  {
    English: "Subscription ID",
    French: "Identifiant d'abonnement",
    Spanish: "ID de suscripción",
    key: "Subscription_ID",
  },
  {
    English: "Activation Date",
    French: "Date d'activation",
    Spanish: "Fecha de activación",
    key: "Activation_Date",
  },
  {
    English: "Created Date",
    French: "Date de création",
    Spanish: "Fecha de creación",
    key: "Created_Date",
  },
  {
    English: "Backdated Registration Date",
    French: "Date d'enregistrement antidatée",
    Spanish: "Fecha de registro retroactiva",
    key: "Backdated_Registration_Date",
  },
  {
    English: "Corporate Details",
    French: "Détails de l'entreprise",
    Spanish: "Detalles Corporativos",
    key: "Corporate_Details",
  },
  {
    English: "Customer Details",
    French: "Détails du client",
    Spanish: "Detalles del cliente",
    key: "Customer_Details",
  },
  {
    English: "Stax Account Type",
    French: "Type de compte Stax",
    Spanish: "Tipo de cuenta Stax",
    key: "Stax_Account_Type",
  },
  {
    English: "GreenShield Member-Id",
    French: "ID de membre GreenShield",
    Spanish: "ID de miembro de GreenShield",
    key: "GreenShield_Member_Id",
  },
  {
    English: "GreenShield Member-Status",
    French: "Statut de membre GreenShield",
    Spanish: "Estado de miembro de GreenShield",
    key: "GreenShield_Member_Status",
  },
  {
    English: "Equitable Member-Id",
    French: "ID de membre équitable",
    Spanish: "ID de miembro equitativo",
    key: "Equitable_Member_Id",
  },
  {
    English: "Equitable Member-Status",
    French: "Statut de membre équitable",
    Spanish: "Estado de miembro equitativo",
    key: "Equitable_Member_Status",
  },
  {
    English: "Upload Membership Card",
    French: "Télécharger la carte de membre",
    Spanish: "Cargar tarjeta de membresía",
    key: "Upload_Membership_Card",
  },
  {
    English: "Your card will be available from",
    French: "Votre carte sera disponible à partir de",
    Spanish: "Su tarjeta estará disponible desde",
    key: "Your_card_will_be_available_from",
  },
  {
    English: "Member premium paid by company.",
    French: "Prime de membre payée par l'entreprise.",
    Spanish: "Prima de miembro pagada por la empresa.",
    key: "Member_premium_paid_by_company",
  },
  {
    English: "Invite",
    French: "Inviter",
    Spanish: "Invitar",
    key: "Invite",
  },
  {
    English: "Invoices available at the company level.",
    French: "Factures disponibles au niveau de l'entreprise.",
    Spanish: "Facturas disponibles a nivel de empresa.",
    key: "Invoices_available_at_the_company_level",
  },
  {
    English: "to update payment method",
    French: "mettre à jour le mode de paiement",
    Spanish: "para actualizar el método de pago",
    key: "to_update_payment_method",
  },
  {
    English: "Paid by Company",
    French: "Payé par l'entreprise",
    Spanish: "Pagado por la empresa",
    key: "Paid_by_Company",
  },
  {
    English: "Feature is pending",
    French: "La fonctionnalité est en attente",
    Spanish: "La función está pendiente",
    key: "Feature_is_pending",
  },
  {
    English: "Update Phone No.",
    French: "Mettre à jour le numéro de téléphone",
    Spanish: "Actualizar número de teléfono",
    key: "Update_Phone_No",
  },
  {
    English: "Update Member Info",
    French: "Mettre à jour les informations sur les membres",
    Spanish: "Actualizar información de miembro",
    key: "Update_Member_Info",
  },
  {
    English: "Primary Phone Number",
    French: "Numéro de téléphone principal",
    Spanish: "Número de teléfono principal",
    key: "Primary_Phone_Number",
  },
  {
    English: "Secondary Phone Number",
    French: "Numéro de téléphone secondaire",
    Spanish: "Número de teléfono secundario",
    key: "Secondary_Phone_Number",
  },
  {
    English: "Member Cards",
    French: "Cartes de membre",
    Spanish: "Tarjetas de miembro",
    key: "Member_Cards",
  },
  {
    English: "Please choose date of birth",
    French: "Veuillez choisir la date de naissance",
    Spanish: "Por favor elige fecha de nacimiento",
    key: "Please_choose_date_of_birth",
  },
  {
    English: "Send link to update payment details of",
    French: "Envoyer le lien pour mettre à jour les détails de paiement de",
    Spanish: "Enviar enlace para actualizar los detalles de pago de",
    key: "Send_link_to_update_payment_details_of",
  },
  {
    English: "Please upload void cheque",
    French: "Veuillez télécharger un chèque annulé",
    Spanish: "Por favor cargue el cheque anulado",
    key: "Please_upload_void_cheque",
  },
  {
    English: "Add Plan",
    French: "Ajouter un forfait",
    Spanish: "Agregar plan",
    key: "Add_Plan",
  },
  {
    English: "Upload HealthCard",
    French: "Télécharger la carte santé",
    Spanish: "Cargar tarjeta sanitaria",
    key: "Upload_HealthCard",
  },
  {
    English: "Please select health card",
    French: "Veuillez sélectionner la carte de santé",
    Spanish: "Por favor seleccione tarjeta sanitaria",
    key: "Please_select_health_card",
  },
  {
    English: "Please upload all required health cards",
    French: "Veuillez télécharger toutes les cartes de santé requises",
    Spanish: "Cargue todas las tarjetas sanitarias requeridas.",
    key: "Please_upload_all_required_health_cards",
  },
  {
    English: "Please select service",
    French: "Veuillez sélectionner un service",
    Spanish: "Por favor seleccione servicio",
    key: "Please_select_service",
  },
  {
    English: "Please choose Plan Enrollment Date",
    French: "Veuillez choisir la date d'adhésion au plan",
    Spanish: "Elija la fecha de inscripción del plan",
    key: "Please_choose_Plan_Enrollment_Date",
  },
  {
    English: "Upload atleast one Card",
    French: "Téléchargez au moins une carte",
    Spanish: "Sube al menos una tarjeta",
    key: "Upload_atleast_one_Card",
  },
  {
    English: "Please select Provider",
    French: "Veuillez sélectionner le fournisseur",
    Spanish: "Por favor seleccione Proveedor",
    key: "Please_select_Provider",
  },
  {
    English: "Kindly ensure that you have added a plan",
    French: "Veuillez vous assurer que vous avez ajouté un plan",
    Spanish: "Asegúrese de haber agregado un plan",
    key: "Kindly_ensure_that_you_have_added_a_plan",
  },
  {
    English: "Add Plan Details",
    French: "Ajouter des détails sur le forfait",
    Spanish: "Agregar detalles del plan",
    key: "Add_Plan_Details",
  },
  {
    English: "Plan Details",
    French: "Détails du forfait",
    Spanish: "Detalles del plan",
    key: "Plan_Details",
  },
  {
    English: "Current Plan",
    French: "Forfait actuel",
    Spanish: "Plan actual",
    key: "Current_Plan",
  },
  {
    English: "New Taxes",
    French: "Nouvelles taxes",
    Spanish: "Nuevos Impuestos",
    key: "New_Taxes",
  },
  {
    English: "New Plan",
    French: "Nouveau forfait",
    Spanish: "Nuevo Plan",
    key: "New_Plan",
  },
  {
    English: "Warning",
    French: "Avertissement",
    Spanish: "Advertencia",
    key: "Warning",
  },
  {
    English: "Proceed With Greenshield Registraiton",
    French: "Procéder à l'enregistrement Greenshield",
    Spanish: "Continuar con el registro de Greenshield",
    key: "Proceed_With_Greenshield_Registraiton",
  },
  {
    English: "Proceed With Greenshield Termination",
    French: "Procéder à la résiliation de Greenshield",
    Spanish: "Continuar con la terminación de Greenshield",
    key: "Proceed_With_Greenshield_Termination",
  },
  {
    English: "Proceed With Equitable Termination",
    French: "Procéder à une résiliation équitable",
    Spanish: "Proceder con la terminación equitativa",
    key: "Proceed_With_Equitable_Termination",
  },
  {
    English: "Proceed With Equitable Registraion",
    French: "Procédez à une inscription équitable",
    Spanish: "Proceder con el registro equitativo",
    key: "Proceed_With_Equitable_Registraion",
  },
  {
    English: "No new plans added.Please add a plan.",
    French: "Aucun nouveau forfait ajouté. Veuillez ajouter un forfait.",
    Spanish: "No se agregaron nuevos planes. Agregue un plan.",
    key: "No_new_plans_added_Please_add_a_plan",
  },
  {
    English: "Cancel Plan",
    French: "Annuler le forfait",
    Spanish: "Cancelar plan",
    key: "Cancel_Plan",
  },
  {
    English: "Please choose Plan Termination Date",
    French: "Veuillez choisir la date de résiliation du plan",
    Spanish: "Por favor elija la Fecha de Terminación del Plan",
    key: "Please_choose_Plan_Termination_Date",
  },
  {
    English: "Tax Details",
    French: "Détails fiscaux",
    Spanish: "Detalles de impuestos",
    key: "Tax_Details",
  },
  {
    English: "Cancel Plan Details",
    French: "Annuler les détails du forfait",
    Spanish: "Cancelar detalles del plan",
    key: "Cancel_Plan_Details",
  },
  {
    English: "No services to upload Membership Cards",
    French: "Aucun service pour télécharger des cartes de membre",
    Spanish: "No hay servicios para cargar Tarjetas de Membresía",
    key: "No_services_to_upload_Membership_Cards",
  },
  {
    English: "Providers",
    French: "Fournisseurs",
    Spanish: "Proveedores",
    key: "Providers",
  },
  {
    English: "Select Card Type",
    French: "Sélectionnez le type de carte",
    Spanish: "Seleccionar tipo de tarjeta",
    key: "Select_Card_Type",
  },
  {
    English: "Update Spouse's Health Plan",
    French: "Mettre à jour le plan de santé du conjoint",
    Spanish: "Actualizar el plan de salud del cónyuge",
    key: "Update_Spouse_s_Health_Plan",
  },
  {
    English: "Expires",
    French: "Expire",
    Spanish: "Vence",
    key: "Expires",
  },
  {
    English: "Append - File will be appended to the existing list.",
    French: "Ajouter - Le fichier sera ajouté à la liste existante.",
    Spanish: "Agregar: el archivo se agregará a la lista existente.",
    key: "Append_File_will_be_appended_to_the_existing_list",
  },
  {
    English: "Please modify & re-upload.",
    French: "Veuillez modifier et télécharger à nouveau.",
    Spanish: "Modifíquelo y vuelva a cargarlo.",
    key: "Please_modify_re_upload",
  },
  {
    English: "Replace - Existing replaced with new file",
    French: "Remplacer – Existant remplacé par un nouveau fichier",
    Spanish: "Reemplazar: existente reemplazado por un archivo nuevo",
    key: "Replace_Existing_replaced_with_new_file",
  },
  {
    English: "No. of Children",
    French: "Nombre d'enfants",
    Spanish: "No. de niños",
    key: "No_of_Children",
  },
  {
    English: "Please add at least one child",
    French: "Veuillez ajouter au moins un enfant",
    Spanish: "Por favor agregue al menos un niño",
    key: "Please_add_at_least_one_child",
  },
  {
    English: "Do you have dependent children?",
    French: "Avez-vous des enfants à charge ?",
    Spanish: "¿Tiene hijos dependientes?",
    key: "Do_you_have_dependent_children",
  },
  {
    English: "Please enter no of children",
    French: "Veuillez entrer le nombre d'enfants",
    Spanish: "Por favor ingrese el número de niños",
    key: "Please_enter_no_of_children",
  },
  {
    English: "Please enter valid Postal Code",
    French: "Veuillez entrer un code postal valide",
    Spanish: "Por favor ingrese un código postal válido",
    key: "Please_enter_valid_Postal_Code",
  },
  {
    English: "Please select atleast one Plan",
    French: "Veuillez sélectionner au moins un forfait",
    Spanish: "Por favor seleccione al menos un Plan",
    key: "Please_select_atleast_one_Plan",
  },
  {
    English:
      "Please select a Provincial Health Replacement Plan along with a Health & Dental Insurance Plan.",
    French:
      "Veuillez sélectionner un régime provincial de remplacement des soins de santé ainsi qu'un régime d'assurance maladie et dentaire.",
    Spanish:
      "Seleccione un Plan Provincial de Reemplazo de Salud junto con un Plan de Seguro Médico y Dental.",
    key: "Please_select_a_Provincial_Health_Replacement_Plan_along_with_a_Health_Dental_Insurance_Plan",
  },
  {
    English: "Are you sure you want to Cancel plan?",
    French: "Etes-vous sûr de vouloir annuler le forfait ?",
    Spanish: "¿Estás seguro de que deseas cancelar el plan?",
    key: "Are_you_sure_you_want_to_Cancel_plan",
  },
  {
    English: "File size is too large,maximum file size is 5MB",
    French:
      "La taille du fichier est trop grande, la taille maximale du fichier est de 5 Mo.",
    Spanish:
      "El tamaño del archivo es demasiado grande, el tamaño máximo del archivo es 5 MB",
    key: "File_size_is_too_large_maximum_file_size_is_5MB",
  },
  {
    English: "Invalid file type. Only pdf files is allowed.",
    French: "Type de fichier invalide. Seuls les fichiers pdf sont autorisés.",
    Spanish: "Tipo de archivo no válido. Sólo se permiten archivos pdf.",
    key: "Invalid_file_type_Only_pdf_files_is_allowed",
  },
  {
    English: "Please select Service And Provider",
    French: "Veuillez sélectionner le service et le fournisseur",
    Spanish: "Por favor seleccione Servicio y Proveedor",
    key: "Please_select_Service_And_Provider",
  },
  {
    English: "Please enter email Id.",
    French: "Veuillez saisir votre identifiant de messagerie.",
    Spanish: "Por favor ingrese el ID de correo electrónico.",
    key: "Please_enter_email_Id",
  },
  {
    English: "Age must be below 21 years",
    French: "L'âge doit être inférieur à 21 ans",
    Spanish: "La edad debe ser inferior a 21 años.",
    key: "Age_must_be_below_21_years",
  },
  {
    English: "Voluntary Plans (Premium paid 100% by employee directly)",
    French: "Plans volontaires (prime payée à 100 % directement par l'employé)",
    Spanish:
      "Planes Voluntarios (Prima pagada 100% directamente por el empleado)",
    key: "Voluntary_Plans_Premium_paid_100_by_employee_directly",
  },
  {
    English:
      "Service not available in Quebec presently. Please check back in 2025",
    French:
      "Service non disponible au Québec présentement. Veuillez revenir en 2025",
    Spanish:
      "Servicio no disponible actualmente en Quebec. Vuelve a consultar en 2025.",
    key: "Service_not_available_in_Quebec_presently_Please_check_back_in_2025",
  },
  {
    English: "All selected plans summary",
    French: "Récapitulatif de tous les forfaits sélectionnés",
    Spanish: "Resumen de todos los planes seleccionados",
    key: "All_selected_plans_summary",
  },
  {
    English:
      "Enrolled full time in and attending an accredited college, university or educational institution.",
    French:
      "Inscrit à temps plein et fréquentant un collège, une université ou un établissement d'enseignement accrédité.",
    Spanish:
      "Inscrito a tiempo completo y asistiendo a un colegio, universidad o institución educativa acreditada.",
    key: "Enrolled_full_time_in_and_attending_an_accredited_college_university_or_educational_institution",
  },
  {
    English:
      "Coverage for disabled dependent children will be based on the definition in the specific insurer’s master contract. You will be contacted for additional information once your application has been received.",
    French:
      "La couverture des enfants à charge handicapés sera basée sur la définition du contrat-cadre spécifique de l’assureur. Vous serez contacté pour des informations complémentaires une fois votre candidature reçue.",
    Spanish:
      "La cobertura para hijos dependientes discapacitados se basará en la definición del contrato marco de la aseguradora específica. Se le contactará para obtener información adicional una vez que se haya recibido su solicitud.",
    key: "Coverage_for_disabled_dependent_children_will_be_based_on_the_definition_in_the_specific_insurer_s_master_contract_You_will_be_contacted_for_additional_information_once_your_application_has_been_received",
  },
  {
    English: "Reports Schedule",
    French: "Calendrier des rapports",
    Spanish: "Calendario de informes",
    key: "Reports_Schedule",
  },
  {
    English: "Travel Commissions",
    French: "Commissions de voyage",
    Spanish: "Comisiones de viaje",
    key: "Travel_Commissions",
  },
  {
    English: "Invalid date",
    French: "Date invalide",
    Spanish: "Fecha no válida",
    key: "Invalid_date",
  },
  {
    English: "Please choose date of hire \r\n",
    French: "Veuillez choisir la date de location \r\n",
    Spanish: "Por favor elija la fecha de contratación \r\n",
    key: "Please_choose_date_of_hire",
  },
  {
    English: "Do you have dependent children?",
    French: "Avez-vous des enfants à charge ?",
    Spanish: "¿Tiene hijos dependientes?",
    key: "Do_you_have_dependent_children",
  },
  {
    English: "Province of Residence",
    French: "Province de résidence",
    Spanish: "Provincia de residencia",
    key: "Province_of_Residence",
  },
  {
    English:
      "Coverage for disabled dependent children will be based on the definition in the specific insurer’s master contract. You will be contacted for additional information once your application has been received. \r\n\r\n",
    French:
      "La couverture des enfants à charge handicapés sera basée sur la définition du contrat-cadre spécifique de l’assureur. Vous serez contacté pour des informations complémentaires une fois votre candidature reçue. \r\n\r\n",
    Spanish:
      "La cobertura para hijos dependientes discapacitados se basará en la definición del contrato marco de la aseguradora específica. Se le contactará para obtener información adicional una vez que se haya recibido su solicitud. \r\n\r\n",
    key: "Coverage_for_disabled_dependent_children_will_be_based_on_the_definition_in_the_specific_insurer_s_master_contract_You_will_be_contacted_for_additional_information_once_your_application_has_been_received",
  },
  {
    English: "No. of Children \r\n",
    French: "Nombre d'enfants \r\n",
    Spanish: "No. de niños \r\n",
    key: "No_of_Children",
  },
  {
    English:
      "Enrolled full time in and attending an accredited college, university or educational institution. \r\n\r\n",
    French:
      "Inscrit à temps plein et fréquentant un collège, une université ou un établissement d'enseignement accrédité. \r\n\r\n",
    Spanish:
      "Inscrito a tiempo completo y asistiendo a un colegio, universidad o institución educativa acreditada. \r\n\r\n",
    key: "Enrolled_full_time_in_and_attending_an_accredited_college_university_or_educational_institution",
  },
  {
    English: "Are you sure you want to delete? \r\n",
    French: "Êtes-vous sûr de vouloir supprimer ? \r\n",
    Spanish: "¿Estás seguro de que deseas eliminar? \r\n",
    key: "Are_you_sure_you_want_to_delete",
  },
  {
    English: "Monthly premium \r\nTaxes included",
    French: "Prime mensuelle \r\nTaxes incluses",
    Spanish: "Prima mensual \r\nImpuestos incluidos",
    key: "Monthly_premium_Taxes_included",
  },
  {
    English: "Please enter email Id. \r\n",
    French: "Veuillez saisir votre identifiant de messagerie. \r\n",
    Spanish: "Por favor ingrese el ID de correo electrónico. \r\n",
    key: "Please_enter_email_Id",
  },
  {
    English: "Parent Information",
    French: "Informations pour les parents",
    Spanish: "Información para padres",
    key: "Parent_Information",
  },
  {
    English: "Advisor Information \r\n",
    French: "Informations sur le conseiller",
    Spanish: "Información del asesor",
    key: "Advisor_Information",
  },
  {
    English: "Edit Advisor Information \r\n",
    French: "Modifier les informations du conseiller",
    Spanish: "Editar información del asesor",
    key: "Edit_Advisor_Information",
  },
  {
    English: "Last name must not exceed 20 characters \r\n",
    French: "Le nom de famille ne doit pas dépasser 20 caractères",
    Spanish: "El apellido no debe exceder los 20 caracteres.",
    key: "Last_name_must_not_exceed_20_characters",
  },
  {
    English: "First name should be 3 characters \r\n",
    French: "Le prénom doit être composé de 3 caractères",
    Spanish: "El nombre debe tener 3 caracteres.",
    key: "First_name_should_be_3_characters",
  },
  {
    English: "First name must not exceed 20 characters \r\n",
    French: "Le prénom ne doit pas dépasser 20 caractères",
    Spanish: "El nombre no debe exceder los 20 caracteres",
    key: "First_name_must_not_exceed_20_characters",
  },
  {
    English: "Add Broker License \r\n",
    French: "Ajouter une licence de courtier",
    Spanish: "Agregar licencia de corredor",
    key: "Add_Broker_License",
  },
  {
    English: "Last name should be 3 characters \r\n",
    French: "Le nom de famille doit contenir 3 caractères",
    Spanish: "El apellido debe tener 3 caracteres.",
    key: "Last_name_should_be_3_characters",
  },
  {
    English: "Select Both (Life, Accident and Sickness)",
    French: "Sélectionnez les deux (vie, accident et maladie)",
    Spanish: "Seleccione Ambos (Vida, Accidente y Enfermedad)",
    key: "Select_Both_Life_Accident_and_Sickness",
  },
  {
    English: "Sales Tracking Code \r\n",
    French: "Code de suivi des ventes",
    Spanish: "Código de seguimiento de ventas",
    key: "Sales_Tracking_Code",
  },
  {
    English: "Edit Sales tracking code \r\n",
    French: "Modifier le code de suivi des ventes",
    Spanish: "Editar código de seguimiento de ventas",
    key: "Edit_Sales_tracking_code",
  },
  {
    English: "Are you sure you want to delete ?",
    French: "Etes-vous sûr de vouloir supprimer ?",
    Spanish: "¿Está seguro de que desea eliminar?",
    key: "Are_you_sure_you_want_to_delete",
  },
  {
    English: "Please Add broker and percentage in the empty fields",
    French:
      "Veuillez ajouter un courtier et un pourcentage dans les champs vides",
    Spanish: "Agregue corredor y porcentaje en los campos vacíos",
    key: "Please_Add_broker_and_percentage_in_the_empty_fields",
  },
  {
    English:
      "Invalid sales tracking code share percentage (The whole percentage should be equal to 100 please check and confirm)",
    French:
      "Pourcentage de partage de code de suivi des ventes invalide (le pourcentage total doit être égal à 100, veuillez vérifier et confirmer)",
    Spanish:
      "Porcentaje de participación del código de seguimiento de ventas no válido (el porcentaje total debe ser igual a 100, verifique y confirme)",
    key: "Invalid_sales_tracking_code_share_percentage_The_whole_percentage_should_be_equal_to_100_please_check_and_confirm",
  },
  {
    English: "Can't delete the row when there is only one row",
    French:
      "Impossible de supprimer la ligne lorsqu'il n'y a qu'une seule ligne",
    Spanish: "No se puede eliminar la fila cuando solo hay una fila",
    key: "Can_t_delete_the_row_when_there_is_only_one_row",
  },
  {
    English: "Shares updated successfully \r\n",
    French: "Partages mis à jour avec succès",
    Spanish: "Acciones actualizadas exitosamente",
    key: "Shares_updated_successfully",
  },
  {
    English: "Add E&O Information\r\n",
    French: "Ajouter des informations E&O",
    Spanish: "Agregar información de E&O",
    key: "Add_E_O_Information",
  },
  {
    English: "Are you sure you want to delete this E&O?",
    French: "Etes-vous sûr de vouloir supprimer cet E&O ?",
    Spanish: "¿Estás seguro de que deseas eliminar este E&O?",
    key: "Are_you_sure_you_want_to_delete_this_E_O",
  },
  {
    English: "No Data Available \r\n",
    French: "Aucune donnée disponible",
    Spanish: "No hay datos disponibles",
    key: "No_Data_Available",
  },
  {
    English: "E&O insurances created successfully",
    French: "Assurances E&O créées avec succès",
    Spanish: "Seguros E&O creados con éxito",
    key: "E_O_insurances_created_successfully",
  },
  {
    English: "Signup Form Information \r\n",
    French: "Informations sur le formulaire d'inscription",
    Spanish: "Información del formulario de registro",
    key: "Signup_Form_Information",
  },
  {
    English: "Edit Signup Form Details \r\n",
    French: "Modifier les détails du formulaire d'inscription",
    Spanish: "Editar detalles del formulario de registro",
    key: "Edit_Signup_Form_Details",
  },
  {
    English: "Form modified successfully",
    French: "Formulaire modifié avec succès",
    Spanish: "Formulario modificado exitosamente",
    key: "Form_modified_successfully",
  },
  {
    English: "Please enter form title \r\n",
    French: "Veuillez saisir le titre du formulaire",
    Spanish: "Por favor ingrese el título del formulario",
    key: "Please_enter_form_title",
  },
  {
    English: "No file choosen",
    French: "Aucun fichier choisi",
    Spanish: "No se ha elegido ningún archivo",
    key: "No_file_choosen",
  },
  {
    English: "Please enter form description \r\n",
    French: "Veuillez saisir la description du formulaire",
    Spanish: "Por favor ingrese la descripción del formulario",
    key: "Please_enter_form_description",
  },
  {
    English: "Download template",
    French: "Télécharger le modèle",
    Spanish: "Descargar plantilla",
    key: "Download_template",
  },
  {
    English: "Upload Employee?Entity List",
    French: "Télécharger la liste des employés ? Entités",
    Spanish: "Cargar lista de entidades de empleados",
    key: "Upload_Employee_Entity_List",
  },
  {
    English: "Actions",
    French: "Actions",
    Spanish: "Acciones",
    key: "Actions",
  },
  {
    English: "Please enter head count for Mind & Body \r\n",
    French: "Veuillez saisir le nombre d'employés pour Mind & Body \r\n",
    Spanish: "Por favor ingrese el número de personas para Mente y Cuerpo \r\n",
    key: "Please_enter_head_count_for_Mind_Body",
  },
  {
    English: "Cleveland Clinic Express Care Online-required head-count 100",
    French: "Cleveland Clinic Express Care Online - effectif requis 100",
    Spanish:
      "Cleveland Clinic Express Care Online-recuento de personal requerido 100",
    key: "Cleveland_Clinic_Express_Care_Online_required_head_count_100",
  },
  {
    English: "Please enter head count for EAP 2.0 \r\n",
    French: "Veuillez saisir le nombre d'employés pour EAP 2.0 \r\n",
    Spanish: "Por favor ingrese el número de empleados para EAP 2.0 \r\n",
    key: "Please_enter_head_count_for_EAP_2_0",
  },
  {
    English: "Please enter head count for Mind & Body \r\n",
    French: "Veuillez saisir le nombre d'employés pour Mind & Body \r\n",
    Spanish: "Por favor ingrese el número de personas para Mente y Cuerpo \r\n",
    key: "Please_enter_head_count_for_Mind_Body",
  },
  {
    English: "Please enter head count for Dialogue Primary Care \r\n",
    French:
      "Veuillez saisir le nombre d'effectifs pour Dialogue Primary Care \r\n",
    Spanish:
      "Por favor ingrese el número de personas para Diálogo de Atención Primaria \r\n",
    key: "Please_enter_head_count_for_Dialogue_Primary_Care",
  },
  {
    English:
      "Please enter head count for Dialogue Extended EAP (Mental Health+) \r\n",
    French:
      "Veuillez saisir le nombre d'employés pour le PAE prolongé de Dialogue (santé mentale+). \r\n",
    Spanish:
      "Ingrese el recuento de personas para Dialogue Extended EAP (Mental Health+) \r\n",
    key: "Please_enter_head_count_for_Dialogue_Extended_EAP_Mental_Health",
  },
  {
    English: "Dialogue Primary Care-required head-count 2",
    French: "Dialogue Soins Primaires Effectifs requis 2",
    Spanish: "Diálogo Atención Primaria-recuento requerido 2",
    key: "Dialogue_Primary_Care_required_head_count_2",
  },
  {
    English: "Info \r\nPlease enter head count for Dialogue Basic EAP \r\n",
    French:
      "Informations \r\nVeuillez saisir le nombre d'employés pour le PAE de base de Dialogue. \r\n",
    Spanish:
      "Información \r\nIngrese el número de empleados para Dialogue Basic EAP \r\n",
    key: "Info_Please_enter_head_count_for_Dialogue_Basic_EAP",
  },
  {
    English:
      "Please enter head count for Dialogue Mind & Body (Primary Care + EAP + Mental Health+) \r\n",
    French:
      "Veuillez saisir le nombre d'effectifs pour Dialogue Mind & Body (Soins primaires + PAE + Santé mentale+) \r\n",
    Spanish:
      "Ingrese el recuento de personas para Diálogo Mente y Cuerpo (Atención primaria + EAP + Salud mental+) \r\n",
    key: "Please_enter_head_count_for_Dialogue_Mind_Body_Primary_Care_EAP_Mental_Health",
  },
  {
    English: "ClassicBronze",
    French: "ClassiqueBronze",
    Spanish: "ClásicoBronce",
    key: "ClassicBronze",
  },
  {
    English: "Month Range Selection",
    French: "Sélection de la plage de mois",
    Spanish: "Selección de rango de meses",
    key: "Month_Range_Selection",
  },
  {
    English: "Corporate",
    French: "Entreprise",
    Spanish: "Corporativo",
    key: "Corporate",
  },
  {
    English: "TPA",
    French: "TPA",
    Spanish: "TPA",
    key: "TPA",
  },
  {
    English: "GroupBenefitz Waddel",
    French: "GroupBenefitz Waddel",
    Spanish: "GrupoBenefitz Waddel",
    key: "GroupBenefitz_Waddel",
  },
  {
    English: "Apply Filters",
    French: "Appliquer des filtres",
    Spanish: "Aplicar filtros",
    key: "Apply_Filters",
  },
  {
    English: "Reset Filters",
    French: "Réinitialiser les filtres",
    Spanish: "Restablecer filtros",
    key: "Reset_Filters",
  },
  {
    English: "Corporate",
    French: "Entreprise",
    Spanish: "Corporativo",
    key: "Corporate",
  },
  {
    English: "ClassicSilver",
    French: "ClassiqueArgent",
    Spanish: "ClásicoPlata",
    key: "ClassicSilver",
  },
  {
    English: "Select Invoice",
    French: "Sélectionnez une facture",
    Spanish: "Seleccionar factura",
    key: "Select_Invoice",
  },
  {
    English: "TPA",
    French: "TPA",
    Spanish: "TPA",
    key: "TPA",
  },
  {
    English: "GroupBenifitz",
    French: "GroupeBenifitz",
    Spanish: "GrupoBeniritz",
    key: "GroupBenifitz",
  },
  {
    English: "Waddel",
    French: "Waddel",
    Spanish: "waddel",
    key: "Waddel",
  },
  {
    English: "Get Invoices",
    French: "Obtenir des factures",
    Spanish: "Obtener facturas",
    key: "Get_Invoices",
  },
  {
    English: "Apply filter",
    French: "Appliquer le filtre",
    Spanish: "Aplicar filtro",
    key: "Apply_filter",
  },
  {
    English: "Reset filter",
    French: "Réinitialiser le filtre",
    Spanish: "Restablecer filtro",
    key: "Reset_filter",
  },
  {
    English: "Report Type",
    French: "Type de rapport",
    Spanish: "Tipo de informe",
    key: "Report_Type",
  },
  {
    English: "Remainder Days",
    French: "Jours restants",
    Spanish: "Días restantes",
    key: "Remainder_Days",
  },
  {
    English: "Edit E&O Details",
    French: "Modifier les détails des erreurs et omissions",
    Spanish: "Editar detalles de E&O",
    key: "Edit_E_O_Details",
  },
  {
    English: "Please enter Certificate number",
    French: "Veuillez saisir le numéro de certificat",
    Spanish: "Por favor ingrese el número de certificado",
    key: "Please_enter_Certificate_number",
  },
  {
    English: "Please enter valid city name",
    French: "Veuillez entrer un nom de ville valide",
    Spanish: "Por favor ingrese un nombre de ciudad válido",
    key: "Please_enter_valid_city_name",
  },
  {
    English: "Code",
    French: "Code",
    Spanish: "Código",
    key: "Code",
  },
  {
    English: "Link",
    French: "Lien",
    Spanish: "Enlace",
    key: "Link",
  },
  {
    English: "Please select broker type",
    French: "Veuillez sélectionner le type de courtier",
    Spanish: "Por favor seleccione el tipo de corredor",
    key: "Please_select_broker_type",
  },
  {
    English: "Currently remainder days are limited to maximum of days",
    French: "Actuellement, les jours restants sont limités au maximum de jours",
    Spanish:
      "Actualmente los días restantes están limitados al máximo de días.",
    key: "Currently_remainder_days_are_limited_to_maximum_of_days",
  },
  {
    English: "group contact updated successfully",
    French: "contact du groupe mis à jour avec succès",
    Spanish: "contacto de grupo actualizado exitosamente",
    key: "group_contact_updated_successfully",
  },
  {
    English: "Coverages",
    French: "Couvertures",
    Spanish: "Coberturas",
    key: "Coverages",
  },
  {
    English: "Signup Link",
    French: "Lien d'inscription",
    Spanish: "Enlace de registro",
    key: "Signup_Link",
  },
  {
    English: "Business Number",
    French: "Numéro d'entreprise",
    Spanish: "Número de negocio",
    key: "Business_Number",
  },
  {
    English: "Please enter Certificate Name",
    French: "Veuillez entrer le nom du certificat",
    Spanish: "Por favor ingrese el nombre del certificado",
    key: "Please_enter_Certificate_Name",
  },
  {
    English: "Are you sure you want to delete Form",
    French: "Êtes-vous sûr de vouloir supprimer le formulaire",
    Spanish: "¿Estás seguro de que deseas eliminar el formulario?",
    key: "Are_you_sure_you_want_to_delete_Form",
  },
  {
    English: "Primary and secondary email must be different.",
    French: "Les e-mails principal et secondaire doivent être différents.",
    Spanish:
      "El correo electrónico primario y secundario deben ser diferentes.",
    key: "Primary_and_secondary_email_must_be_different",
  },
  {
    English: "Secondary and third email must be different.",
    French: "Les e-mails secondaire et troisième doivent être différents.",
    Spanish:
      "El correo electrónico secundario y el tercero deben ser diferentes.",
    key: "Secondary_and_third_email_must_be_different",
  },
  {
    English: "Primary and secondary email must be different.",
    French: "Les e-mails principal et secondaire doivent être différents.",
    Spanish:
      "El correo electrónico primario y secundario deben ser diferentes.",
    key: "Primary_and_secondary_email_must_be_different",
  },
  {
    English: "File size is too large,maximum file size is 1 MB.",
    French:
      "La taille du fichier est trop grande, la taille maximale du fichier est de 1 Mo.",
    Spanish:
      "El tamaño del archivo es demasiado grande, el tamaño máximo del archivo es 1 MB.",
    key: "File_size_is_too_large_maximum_file_size_is_1_MB",
  },
  {
    English: "Primary and third email must be different",
    French:
      "L'adresse e-mail principale et la troisième doivent être différentes",
    Spanish:
      "El correo electrónico principal y el tercero deben ser diferentes.",
    key: "Primary_and_third_email_must_be_different",
  },
  {
    English:
      "Please enter head count for Dialogue Mind & Body (Primary Care + EAP + Mental Health+) \n",
    French:
      "Veuillez saisir le nombre d'effectifs pour Dialogue Mind & Body (Soins primaires + PAE + Santé mentale+) \n",
    Spanish:
      "Ingrese el recuento de personas para Diálogo Mente y Cuerpo (Atención primaria + EAP + Salud mental+) \n",
    key: "Please_enter_head_count_for_Dialogue_Mind_Body_Primary_Care_EAP_Mental_Health",
  },
  {
    English: "Go to dashboard",
    French: "Aller au tableau de bord",
    Spanish: "Ir al panel",
    key: "Go_to_dashboard",
  },
  {
    English: "Info \nPlease enter head count for Dialogue Basic EAP \n",
    French:
      "Informations \nVeuillez saisir le nombre d'employés pour le PAE de base de Dialogue. \n",
    Spanish:
      "Información \nIngrese el número de empleados para Dialogue Basic EAP \n",
    key: "Info_Please_enter_head_count_for_Dialogue_Basic_EAP",
  },
  {
    English: "Month",
    French: "Mois",
    Spanish: "Mes",
    key: "Month",
  },
  {
    English: "Please select member type",
    French: "Veuillez sélectionner le type de membre",
    Spanish: "Por favor seleccione el tipo de miembro",
    key: "Please_select_member_type",
  },
  {
    English: "Student",
    French: "Étudiant",
    Spanish: "Alumno",
    key: "Student",
  },
  {
    English: "Employer Name",
    French: "Nom de l'employeur",
    Spanish: "Nombre del empleador",
    key: "Employer_Name",
  },
  {
    English: "Please enter Employer Name",
    French: "Veuillez entrer le nom de l'employeur",
    Spanish: "Por favor ingrese el nombre del empleador",
    key: "Please_enter_Employer_Name",
  },
  {
    English: "Member Type",
    French: "Type de membre",
    Spanish: "Tipo de miembro",
    key: "Member_Type",
  },
  {
    English: "plans summary",
    French: "résumé des plans",
    Spanish: "resumen de planes",
    key: "plans_summary",
  },
  {
    English: "Student Id",
    French: "Carte d'étudiant",
    Spanish: "Identificación de estudiante",
    key: "Student_Id",
  },
  {
    English: "First Name as shown on Provincial Health Card/UHIP Card",
    French:
      "Prénom tel qu'indiqué sur la carte d'assurance maladie provinciale/carte RAMU",
    Spanish:
      "Nombre como se muestra en la Tarjeta de Salud Provincial/Tarjeta UHIP",
    key: "First_Name_as_shown_on_Provincial_Health_Card_UHIP_Card",
  },
  {
    English: "Taxes included",
    French: "Taxes incluses",
    Spanish: "Impuestos incluidos",
    key: "Taxes_included",
  },
  {
    English: "Monthly premium",
    French: "Prime mensuelle",
    Spanish: "Prima mensual",
    key: "Monthly_premium",
  },
  {
    English: "Adding Employee for",
    French: "Ajout d'un employé pour",
    Spanish: "Agregar empleado para",
    key: "Adding_Employee_for",
  },
  {
    English: "Please enter student id",
    French: "Veuillez saisir votre numéro d'étudiant",
    Spanish: "Por favor ingrese la identificación del estudiante",
    key: "Please_enter_student_id",
  },
  {
    English: "Last Name as shown on Provincial Health Card/UHIP Card",
    French:
      "Nom de famille tel qu'indiqué sur la carte d'assurance maladie provinciale/carte RAMU",
    Spanish:
      "Apellido como se muestra en la Tarjeta de Salud Provincial/Tarjeta UHIP",
    key: "Last_Name_as_shown_on_Provincial_Health_Card_UHIP_Card",
  },
  {
    English: "Phone number is minimum of 10 digits",
    French: "Le numéro de téléphone comporte au minimum 10 chiffres",
    Spanish: "El número de teléfono tiene un mínimo de 10 dígitos.",
    key: "Phone_number_is_minimum_of_10_digits",
  },
  {
    English: "Unit/Apt/Suite #",
    French: "Numéro d'unité/app/suite",
    Spanish: "Unidad/Apto/Suite #",
    key: "Unit_Apt_Suite",
  },
  {
    English: "Please choose employee landed immigrant status",
    French: "Veuillez choisir le statut d'immigrant reçu d'employé",
    Spanish:
      "Por favor elija el estado de inmigrante desembarcado del empleado",
    key: "Please_choose_employee_landed_immigrant_status",
  },
  {
    English: "Phone number is maximum of 10 digits",
    French: "Le numéro de téléphone comporte au maximum 10 chiffres",
    Spanish: "El número de teléfono tiene un máximo de 10 dígitos.",
    key: "Phone_number_is_maximum_of_10_digits",
  },
  {
    English: "Name as shown on Provincial Health Card",
    French: "Nom tel qu'indiqué sur la carte de santé provinciale",
    Spanish: "Nombre que figura en la Tarjeta Sanitaria Provincial",
    key: "Name_as_shown_on_Provincial_Health_Card",
  },
  {
    English: "Please select dependent(s) country of Origin.",
    French: "Veuillez sélectionner le pays d'origine des personnes à charge.",
    Spanish: "Seleccione el país de origen de los dependientes.",
    key: "Please_select_dependent_s_country_of_Origin",
  },
  {
    English: "Name as shown on Provincial Health Card",
    French: "Nom tel qu'indiqué sur la carte de santé provinciale",
    Spanish: "Nombre que figura en la Tarjeta Sanitaria Provincial",
    key: "Name_as_shown_on_Provincial_Health_Card",
  },
  {
    English: "Voluntary Opt-In",
    French: "Inscription volontaire",
    Spanish: "Inscripción voluntaria",
    key: "Voluntary_Opt_In",
  },
  {
    English: "Home address is the same as billing address",
    French: "L'adresse du domicile est la même que l'adresse de facturation",
    Spanish:
      "La dirección de casa es la misma que la dirección de facturación.",
    key: "Home_address_is_the_same_as_billing_address",
  },
  {
    English: "Please enter valid Unit/Apt/Suite number",
    French: "Veuillez entrer un numéro d'unité/d'appartement/de suite valide",
    Spanish: "Por favor ingrese un número de unidad/apto/suite válido",
    key: "Please_enter_valid_Unit_Apt_Suite_number",
  },
  {
    English: "Opt-in plans summary",
    French: "Résumé des plans d'adhésion",
    Spanish: "Resumen de planes de suscripción",
    key: "Opt_in_plans_summary",
  },
  {
    English: "Dependent",
    French: "Dépendant",
    Spanish: "Dependiente",
    key: "Dependent",
  },
  {
    English: "No, already provisioned",
    French: "Non, déjà provisionné",
    Spanish: "No, ya aprovisionado",
    key: "No_already_provisioned",
  },
  {
    English: "File size is too large maximum file size is 5MB",
    French:
      "La taille du fichier est trop grande. La taille maximale du fichier est de 5 Mo.",
    Spanish:
      "El tamaño del archivo es demasiado grande. El tamaño máximo del archivo es 5 MB.",
    key: "File_size_is_too_large_maximum_file_size_is_5MB",
  },
  {
    English: "Invalid file type Only pdf files is allowed",
    French: "Type de fichier invalide Seuls les fichiers PDF sont autorisés",
    Spanish: "Tipo de archivo no válido. Sólo se permiten archivos pdf.",
    key: "Invalid_file_type_Only_pdf_files_is_allowed",
  },
  {
    English: "Done",
    French: "Fait",
    Spanish: "Hecho",
    key: "Done",
  },
  {
    English: "MEMBER",
    French: "MEMBRE",
    Spanish: "MIEMBRO",
    key: "MEMBER",
  },
  {
    English: "SPOUSE",
    French: "CONJOINTE",
    Spanish: "CÓNYUGE",
    key: "SPOUSE",
  },
  {
    English: "Tier Name",
    French: "Nom du niveau",
    Spanish: "Nombre del nivel",
    key: "Tier_Name",
  },
  {
    English: "Length of Service",
    French: "Ancienneté",
    Spanish: "Duración del servicio",
    key: "Length_of_Service",
  },
  {
    English: "and your dependent(s)",
    French: "et vos personnes à charge",
    Spanish: "y sus dependientes",
    key: "and_your_dependent_s",
  },
  {
    English: "Based on the information provided, you and your dependent(s)",
    French:
      "Sur la base des informations fournies, vous et les personnes à votre charge",
    Spanish: "Según la información proporcionada, usted y sus dependientes",
    key: "Based_on_the_information_provided_you_and_your_dependent_s",
  },
  {
    English: "are eligible to apply for the following plans.",
    French: "sont éligibles pour postuler aux plans suivants.",
    Spanish: "son elegibles para solicitar los siguientes planes.",
    key: "are_eligible_to_apply_for_the_following_plans",
  },
  {
    English: "Based on the information provided, you , your spouse",
    French: "Sur la base des informations fournies, vous, votre conjoint",
    Spanish: "Según la información proporcionada, usted, su cónyuge",
    key: "Based_on_the_information_provided_you_your_spouse",
  },
  {
    English:
      "Based on the information provided, you are eligible to apply for the following plans.",
    French:
      "Sur la base des informations fournies, vous êtes éligible pour postuler aux plans suivants.",
    Spanish:
      "Según la información proporcionada, usted es elegible para solicitar los siguientes planes.",
    key: "Based_on_the_information_provided_you_are_eligible_to_apply_for_the_following_plans",
  },
  {
    English: "Please choose date of hire",
    French: "Veuillez choisir la date d’embauche",
    Spanish: "Por favor, elija la fecha de contratación",
    key: "Please_choose_date_of_hire",
  },
  {
    English: "Showing",
    French: "Affichage",
    Spanish: "Demostración",
    key: "Showing",
  },
  {
    English: "Do you have dependent children?",
    French: "Avez-vous des enfants à charge ?",
    Spanish: "¿Tiene hijos dependientes?",
    key: "Do_you_have_dependent_children",
  },
  {
    English: "Please select a Provincial Health Replacement Plan.",
    French:
      "Veuillez sélectionner un régime provincial de remplacement des soins de santé.",
    Spanish: "Por favor seleccione un Plan Provincial de Reemplazo de Salud.",
    key: "Please_select_a_Provincial_Health_Replacement_Plan",
  },
  {
    English:
      "Premiums may change on the renewal date. Please contact your Broker/Advisor for more information.",
    French:
      "Les primes peuvent changer à la date de renouvellement. Veuillez contacter votre courtier/conseiller pour plus d’informations.",
    Spanish:
      "Las primas pueden cambiar en la fecha de renovación. Comuníquese con su corredor/asesor para obtener más información.",
    key: "Premiums_may_change_on_the_renewal_date_Please_contact_your_Broker_Advisor_for_more_information",
  },
  {
    English: "Plan Level",
    French: "Niveau du forfait",
    Spanish: "Nivel del plan",
    key: "Plan_Level",
  },
  {
    English: "Show all invoices",
    French: "Afficher toutes les factures",
    Spanish: "Mostrar todas las facturas",
    key: "Show_all_invoices",
  },
  {
    English: "Group Benefits Invoices",
    French: "Factures d’assurance collective",
    Spanish: "Facturas de beneficios grupales",
    key: "Group_Benefits_Invoices",
  },
  {
    English: "Group Benefits Plans Summary",
    French: "Sommaire des régimes d’avantages sociaux collectifs",
    Spanish: "Resumen de planes de beneficios grupales",
    key: "Group_Benefits_Plans_Summary",
  },
  {
    English: "Corporate Proposal Status",
    French: "Statut de la proposition d'entreprise",
    Spanish: "Estado de la propuesta corporativa",
    key: "Corporate_Proposal_Status",
  },
  {
    English: "Please update the payment method in the corporate dashboard.",
    French:
      "Veuillez mettre à jour le mode de paiement dans le tableau de bord de l'entreprise.",
    Spanish: "Actualice el método de pago en el panel corporativo.",
    key: "Please_update_the_payment_method_in_the_corporate_dashboard",
  },
  {
    English: "Group Benefits Resources",
    French: "Ressources sur les avantages sociaux collectifs",
    Spanish: "Recursos de beneficios grupales",
    key: "Group_Benefits_Resources",
  },
  {
    English: "House Clients (Gavin Mosley)",
    French: "Clients de la maison (Gavin Mosley)",
    Spanish: "Clientes de la casa (Gavin Mosley)",
    key: "House_Clients_Gavin_Mosley",
  },
  {
    English: "Use Parent Disclosure?",
    French: "Utiliser la divulgation parentale ?",
    Spanish: "¿Utilizar la divulgación para padres?",
    key: "Use_Parent_Disclosure",
  },
  {
    English: "Please enter head count for Dialogue Primary Care",
    French: "Veuillez saisir le nombre d'effectifs pour Dialogue Primary Care",
    Spanish:
      "Por favor ingrese el número de personas para Diálogo de Atención Primaria",
    key: "Please_enter_head_count_for_Dialogue_Primary_Care",
  },
  {
    English: "Please enter head count for EAP 2.0",
    French: "Veuillez saisir le nombre d'employés pour EAP 2.0",
    Spanish: "Por favor ingrese el número de empleados para EAP 2.0",
    key: "Please_enter_head_count_for_EAP_2_0",
  },
  {
    English: "Please enter head count for Mind & Body",
    French: "Veuillez saisir le nombre d'employés pour Mind & Body",
    Spanish: "Por favor ingrese el número de personas para Mente y Cuerpo",
    key: "Please_enter_head_count_for_Mind_Body",
  },
  {
    English:
      "Please enter head count for Dialogue Extended EAP (Mental Health+)",
    French:
      "Veuillez saisir le nombre d'employés pour le PAE prolongé de Dialogue (santé mentale+).",
    Spanish:
      "Ingrese el recuento de personas para Dialogue Extended EAP (Mental Health+)",
    key: "Please_enter_head_count_for_Dialogue_Extended_EAP_Mental_Health",
  },
  {
    English: "Please enter head count for Mind & Body",
    French: "Veuillez saisir le nombre d'employés pour Mind & Body",
    Spanish: "Por favor ingrese el número de personas para Mente y Cuerpo",
    key: "Please_enter_head_count_for_Mind_Body",
  },
  {
    English:
      "Please enter head count for Dialogue Mind & Body (Primary Care + EAP + Mental Health+)",
    French:
      "Veuillez saisir le nombre d'effectifs pour Dialogue Mind & Body (Soins primaires + PAE + Santé mentale+)",
    Spanish:
      "Ingrese el recuento de personas para Diálogo Mente y Cuerpo (Atención primaria + EAP + Salud mental+)",
    key: "Please_enter_head_count_for_Dialogue_Mind_Body_Primary_Care_EAP_Mental_Health",
  },
  {
    English: "Info \r\nPlease enter head count for Dialogue Basic EAP",
    French:
      "Informations \r\nVeuillez saisir le nombre d'employés pour le PAE de base de Dialogue.",
    Spanish:
      "Información \r\nIngrese el número de empleados para Dialogue Basic EAP",
    key: "Info_Please_enter_head_count_for_Dialogue_Basic_EAP",
  },
  {
    English: "Currently remainder days are limited to maximum of",
    French: "Actuellement, les jours restants sont limités à un maximum de",
    Spanish: "Actualmente los días restantes están limitados a un máximo de",
    key: "Currently_remainder_days_are_limited_to_maximum_of",
  },
  {
    English: "days",
    French: "jours",
    Spanish: "días",
    key: "days",
  },
  {
    English: "Do you have dependent children?** (two mandatory marks)",
    French: "Avez-vous des enfants à charge ?** (deux points obligatoires)",
    Spanish: "¿Tiene hijos dependientes?** (dos puntos obligatorios)",
    key: "Do_you_have_dependent_children_two_mandatory_marks",
  },
  {
    English: "100% Company Paid",
    French: "100 % payé par l'entreprise",
    Spanish: "100% pagado por la empresa",
    key: "100_Company_Paid",
  },
  {
    English: "User Exists in Stax and Not in BMS",
    French: "L’utilisateur existe dans Stax et non dans BMS",
    Spanish: "El usuario existe en Stax y no en BMS",
    key: "User_Exists_in_Stax_and_Not_in_BMS",
  },
  {
    English: "Are you sure you want to import the data?",
    French: "Êtes-vous sûr de vouloir importer les données ?",
    Spanish: "¿Estás seguro de que quieres importar los datos?",
    key: "Are_you_sure_you_want_to_import_the_data",
  },
  {
    English:
      "Please select a Health Dental Insurance Plan along with a Life or Critical Insurance Plan",
    French:
      "Veuillez choisir un régime d’assurance soins dentaires ainsi qu’un régime d’assurance vie ou d’assurance critique",
    Spanish:
      "Seleccione un plan de seguro dental de salud junto con un plan de seguro de vida o crítico",
    key: "Please_select_a_Health_Dental_Insurance_Plan_along_with_a_Life_or_Critical_Insurance_Plan",
  },
  {
    English: "Voluntary Opt In",
    French: "Inscription volontaire",
    Spanish: "Opción voluntaria",
    key: "Voluntary_Opt_In",
  },
  {
    English: "Please Select Country",
    French: "Veuillez sélectionner un pays",
    Spanish: "Por favor seleccione país",
    key: "Please_Select_Country",
  },
  {
    English: "Working Province",
    French: "Province de travail",
    Spanish: "Provincia de trabajo",
    key: "Working_Province",
  },
  {
    English: "Please select working Provinces",
    French: "Veuillez sélectionner les provinces actives",
    Spanish: "Por favor seleccione Provincias de trabajo",
    key: "Please_select_working_Provinces",
  },
  {
    English:
      "This selection Include waddell plan, Do you want to provision in waddell.",
    French:
      "Cette sélection Inclut le plan Waddell, souhaitez-vous provisionner dans Waddell.",
    Spanish:
      "Esta selección incluye el plan Waddell. ¿Desea aprovisionar en Waddell",
    key: "This_selection_Include_waddell_plan_Do_you_want_to_provision_in_waddell",
  },
  {
    English: " Please select  the  waddell Provision choice ",
    French: "Veuillez sélectionner le choix Waddell Provision",
    Spanish: "Seleccione la opción de provisión de waddell",
    key: "Please_select_the_waddell_Provision_choice",
  },
  {
    English:
      "This selection Includes waddell plan, do you want to provision in waddell?",
    French:
      "Cette sélection inclut le plan waddell, voulez-vous provisionner dans waddell ?",
    Spanish:
      "Esta selección incluye el plan waddell, ¿desea aprovisionar en waddell?",
    key: "This_selection_Includes_waddell_plan_do_you_want_to_provision_in_waddell",
  },
  {
    English: "100% Compnay Paid",
    French: "100% payé par l’entreprise",
    Spanish: "100% Empresa Pagada",
    key: "100_Compnay_Paid",
  },
  {
    English: "Non Binary",
    French: "Non binaire",
    Spanish: "No binario",
    key: "Non_Binary",
  },
  {
    English: "Pre Authorized Debit",
    French: "Débit préautorisé",
    Spanish: "Débito preautorizado",
    key: "Pre_Authorized_Debit",
  },
  {
    English: "Admin Approved",
    French: "Approuvé par l'administrateur",
    Spanish: "Aprobado por el administrador",
    key: "Admin_Approved",
  },
  {
    English: "Marketing Brochures \r\n",
    French: "Brochures marketing \r\n",
    Spanish: "Folletos de marketing \r\n",
    key: "Marketing_Brochures",
  },
  {
    English: "Retry",
    French: "Réessayer",
    Spanish: "Rever",
    key: "Retry",
  },
  {
    English: "Customer",
    French: "Client",
    Spanish: "Cliente",
    key: "Customer",
  },
  {
    English: "Misc Data",
    French: "Données diverses",
    Spanish: "Datos varios",
    key: "Misc_Data",
  },
  {
    English: "Log File",
    French: "Fichier journal",
    Spanish: "Archivo de registro",
    key: "Log_File",
  },
  {
    English: "Execution ID",
    French: "ID d'exécution",
    Spanish: "ID de ejecución",
    key: "Execution_ID",
  },
  {
    English: "Video",
    French: "Vidéo",
    Spanish: "Video",
    key: "Video",
  },
  {
    English: "Payload",
    French: "Charge utile",
    Spanish: "Carga útil",
    key: "Payload",
  },
  {
    English: "Response",
    French: "Réponse",
    Spanish: "Respuesta",
    key: "Response",
  },
  {
    English: "Provisioning Queues",
    French: "Approvisionnement des files d'attente",
    Spanish: "Colas de aprovisionamiento",
    key: "Provisioning_Queues",
  },
  {
    English: "Plan Data",
    French: "Données du régime",
    Spanish: "Datos del plan",
    key: "Plan_Data",
  },
  {
    English: "Image File",
    French: "Fichier image",
    Spanish: "Archivo de imagen",
    key: "Image_File",
  },
  {
    English: "Are you sure you want to delete this Queue?",
    French: "Etes-vous sûr de vouloir supprimer cette file d'attente ?",
    Spanish: "¿Está seguro de que desea eliminar esta cola?",
    key: "Are_you_sure_you_want_to_delete_this_Queue",
  },
  {
    English: "Requeue",
    French: "Remettre en file d'attente",
    Spanish: "poner en cola",
    key: "Requeue",
  },
  {
    English: "The provisioning queue has been deleted successfully.",
    French: "La file d'attente de provisionnement a été supprimée avec succès.",
    Spanish: "La cola de aprovisionamiento se ha eliminado correctamente.",
    key: "The_provisioning_queue_has_been_deleted_successfully",
  },
  {
    English: "Timestamp",
    French: "Horodatage",
    Spanish: "Marca de tiempo",
    key: "Timestamp",
  },
  {
    English: "Log Type",
    French: "Type de journal",
    Spanish: "Tipo de registro",
    key: "Log_Type",
  },
  {
    English: "Test Case",
    French: "Cas de test",
    Spanish: "Caso de prueba",
    key: "Test_Case",
  },
  {
    English: "Data Set",
    French: "Ensemble de données",
    Spanish: "Conjunto de datos",
    key: "Data_Set",
  },
  {
    English: "Step No",
    French: "Étape Non",
    Spanish: "Paso No",
    key: "Step_No",
  },
  {
    English: "Image Gallery \r\n",
    French: "Galerie d'images \r\n",
    Spanish: "Galería de imágenes \r\n",
    key: "Image_Gallery",
  },
  {
    English: "Item",
    French: "Article",
    Spanish: "Artículo",
    key: "Item",
  },
  {
    English: "Step Info",
    French: "Informations sur l'étape",
    Spanish: "Información del paso",
    key: "Step_Info",
  },
  {
    English: "Duration",
    French: "Durée",
    Spanish: "Duración",
    key: "Duration",
  },
  {
    English: "Result",
    French: "Résultat",
    Spanish: "Resultado",
    key: "Result",
  },
  {
    English: "Response Data",
    French: "Données de réponse",
    Spanish: "Datos de respuesta",
    key: "Response_Data",
  },
  {
    English: "Payload Data",
    French: " Données de charge utile",
    Spanish: "Datos de carga útil",
    key: "Payload_Data",
  },
  {
    English: "Execution Screenshots",
    French: " Captures d'écran d'exécution",
    Spanish: "Capturas de pantalla de ejecución",
    key: "Execution_Screenshots",
  },
  {
    English: "Image",
    French: "Image",
    Spanish: "Imagen",
    key: "Image",
  },
  {
    English: "Failed",
    French: "Raté",
    Spanish: "Fracasado",
    key: "Failed",
  },
  {
    English: "Review",
    French: "Révision",
    Spanish: "Revisión",
    key: "Review",
  },
  {
    English: "Please select option",
    French: "Veuillez sélectionner l'option",
    Spanish: " Por favor seleccione la opción",
    key: "Please_select_option",
  },
  {
    English: "Record of Amendment",
    French: "Dossier de modification",
    Spanish: "Registro de enmienda",
    key: "Record_of_Amendment",
  },
  {
    English: "Select Month",
    French: "Sélectionnez le mois",
    Spanish: "Seleccionar mes",
    key: "Select_Month",
  },
  {
    English: "month",
    French: "mois",
    Spanish: "mes",
    key: "month",
  },
  {
    English: "Invoice Status",
    French: "Statut de la facture",
    Spanish: "Estado de la factura",
    key: "Invoice_Status",
  },
  {
    English: "Customer Name",
    French: "Nom du client",
    Spanish: "Nombre del cliente",
    key: "Customer_Name",
  },
  {
    English: "OverDue",
    French: "En retard",
    Spanish: "Atrasado",
    key: "OverDue",
  },
  {
    English: "Paid",
    French: "Payé",
    Spanish: "Pagado",
    key: "Paid",
  },
  {
    English: "Post",
    French: "Poste",
    Spanish: "Correo",
    key: "Post",
  },
  {
    English: "Void",
    French: "Vide",
    Spanish: "Vacío",
    key: "Void",
  },
  {
    English: "Invoice No",
    French: "Numéro de facture",
    Spanish: "Número de factura",
    key: "Invoice_No",
  },
  {
    English: "Customer ID",
    French: "Numéro client",
    Spanish: "ID de cliente",
    key: "Customer_ID",
  },
  {
    English: "Excel",
    French: "Exceller",
    Spanish: "Sobresalir",
    key: "Excel",
  },
  {
    English: "Mail",
    French: "Mail",
    Spanish: "Correo",
    key: "Mail",
  },
  {
    English: "Invoice Total",
    French: "Total de la facture",
    Spanish: "Total de la factura",
    key: "Invoice_Total",
  },
  {
    English: "Amount Paid",
    French: "Montant payé",
    Spanish: "Monto pagado",
    key: "Amount_Paid",
  },
  {
    English: "Write Off",
    French: "Radier",
    Spanish: "Pedir por escrito",
    key: "Write_Off",
  },
  {
    English: "Re-generate",
    French: "Régénérer",
    Spanish: "Regenerado",
    key: "Re_generate",
  },
  {
    English: "Due Date",
    French: "Date d'échéance",
    Spanish: "Fecha de vencimiento",
    key: "Due_Date",
  },
  {
    English: "Modified By",
    French: "Modifié par",
    Spanish: "Modificado por",
    key: "Modified_By",
  },
  {
    English: "Proceeed",
    French: "Continuer",
    Spanish: "Continuar",
    key: "Proceeed",
  },
  {
    English: "Corporate Accounts",
    French: "Comptes d'entreprise",
    Spanish: "Cuentas corporativas",
    key: "Corporate_Accounts",
  },
  {
    English: "Association Members",
    French: "Membres de l'association",
    Spanish: "Miembros de la asociación",
    key: "Association_Members",
  },
  {
    English: "GIG Workers",
    French: "Travailleurs de GIG",
    Spanish: "Trabajadores GIG",
    key: "GIG_Workers",
  },
  {
    English: "Students",
    French: "Étudiants",
    Spanish: "Estudiantes",
    key: "Students",
  },
  {
    English: "GIG Workers & Association Members",
    French: "Travailleurs du GIG et membres de l'association",
    Spanish: "Trabajadores de GIG y miembros de asociaciones",
    key: "GIG_Workers_Association_Members",
  },
  {
    English: "Electronic Fund Transfer",
    French: "Transfert électronique de fonds",
    Spanish: "Transferencia electrónica de fondos",
    key: "Electronic_Fund_Transfer",
  },
  {
    English: "Pre-Authorised Debit",
    French: "Débit préautorisé",
    Spanish: "Débito Preautorizado",
    key: "Pre_Authorised_Debit",
  },
  {
    English: "Range",
    French: "Gamme",
    Spanish: "Rango",
    key: "Range",
  },
  {
    English: "Send a link to update payment details for",
    French: "Envoyer un lien pour mettre à jour les détails de paiement pour",
    Spanish: "Enviar un enlace para actualizar los detalles de pago de",
    key: "Send_a_link_to_update_payment_details_for",
  },
  {
    English: "Last Name minimum of 1 Character and without numbers",
    French: "Nom de famille minimum de 1 caractère et sans chiffres",
    Spanish: "Apellido mínimo de 1 Carácter y sin números",
    key: "Last_Name_minimum_of_1_Character_and_without_numbers",
  },
  {
    English: "First Name minimum of 1 Character and without numbers",
    French: "Prénom minimum de 1 Caractère et sans chiffres",
    Spanish: "Nombre mínimo de 1 Carácter y sin números",
    key: "First_Name_minimum_of_1_Character_and_without_numbers",
  },
  {
    English: "GroupBenefitz Wallet™ for employees ?",
    French: "GroupBenefitz Wallet™ pour les employés ?",
    Spanish: "¿GroupBenefitz Wallet™ para empleados?",
    key: "GroupBenefitz_Wallet_for_employees",
  },
  {
    English:
      "You're currently have another active session. Would you like to log out from that session?",
    French:
      "Vous avez actuellement une autre session active. Souhaitez-vous vous déconnecter de cette session ?",
    Spanish:
      "Actualmente tienes otra sesión activa. ¿Le gustaría cerrar sesión en esa sesión?",
    key: "You_re_currently_have_another_active_session_Would_you_like_to_log_out_from_that_session",
  },
  {
    English: "Trouble creating new session",
    French: "Problème lors de la création d'une nouvelle session",
    Spanish: "Problemas para crear una nueva sesión",
    key: "Trouble_creating_new_session",
  },
  {
    English: "Session created successfully",
    French: "Session créée avec succès",
    Spanish: "Sesión creada exitosamente",
    key: "Session_created_successfully",
  },
  {
    English: "Logged out from all active sessions",
    French: "Déconnecté de toutes les sessions actives",
    Spanish: "Cerrado sesión en todas las sesiones activas",
    key: "Logged_out_from_all_active_sessions",
  },
  {
    English: "Something went wrong. Please try again",
    French: "Quelque chose s'est mal passé. Veuillez réessayer",
    Spanish: "Algo salió mal. Por favor inténtalo de nuevo",
    key: "Something_went_wrong_Please_try_again",
  },
  {
    English: "Enter credentials to continue",
    French: "Entrez les informations d'identification pour continuer",
    Spanish: "Ingrese las credenciales para continuar",
    key: "Enter_credentials_to_continue",
  },
  {
    English: "Your session has timed out",
    French: "Votre session a expiré",
    Spanish: "Tu sesión ha expirado",
    key: "Your_session_has_timed_out",
  },
  {
    English: "Please enter bank transit number",
    French: "Veuillez saisir le numéro de transit bancaire",
    Spanish: "Por favor ingrese el número de tránsito bancario",
    key: "Please_enter_bank_transit_number",
  },
  {
    English: "Please enter bank code \r\n",
    French: "Veuillez saisir le code bancaire \r\n",
    Spanish: "Por favor ingrese el código bancario \r\n",
    key: "Please_enter_bank_code",
  },
  {
    English: "Member Count",
    French: "Nombre de membres",
    Spanish: "Recuento de miembros",
    key: "Member_Count",
  },
  {
    English: "Please select tier status",
    French: "Veuillez sélectionner le statut du niveau",
    Spanish: "Seleccione el estado del nivel",
    key: "Please_select_tier_status",
  },
  {
    English: "Please enter wallet Amount \r\n",
    French: "Veuillez saisir le montant du portefeuille \r\n",
    Spanish: "Por favor ingrese el monto de la billetera \r\n",
    key: "Please_enter_wallet_Amount",
  },
  {
    English: "Please select effectiveDate \r\n",
    French: "Veuillez sélectionner la date d'entrée en vigueur \r\n",
    Spanish: "Por favor seleccione fecha efectiva \r\n",
    key: "Please_select_effectiveDate",
  },
  {
    English: "Please enter tier descrfiption",
    French: "Veuillez saisir la description du niveau",
    Spanish: "Por favor ingrese la descripción del nivel",
    key: "Please_enter_tier_descrfiption",
  },
  {
    English: "Please enter tier name \r\n",
    French: "Veuillez saisir le nom du niveau \r\n",
    Spanish: "Por favor ingrese el nombre del nivel \r\n",
    key: "Please_enter_tier_name",
  },
  {
    English: "Wallet",
    French: "Portefeuille",
    Spanish: "Billetera",
    key: "Wallet",
  },
  {
    English: "Please select carryForwordAmount \r\n",
    French: "Veuillez sélectionner carryForwordAmount \r\n",
    Spanish: "Por favor seleccione carryForwordAmount \r\n",
    key: "Please_select_carryForwordAmount",
  },
  {
    English: "Carry Forward Amount",
    French: "Montant reporté",
    Spanish: "Importe transferido",
    key: "Carry_Forward_Amount",
  },
  {
    English: "Wallet Amount \r\n",
    French: "Montant du portefeuille \r\n",
    Spanish: "Monto de la billetera \r\n",
    key: "Wallet_Amount",
  },
  {
    English: "Please select length of service",
    French: "Veuillez sélectionner l'ancienneté",
    Spanish: "Por favor seleccione duración del servicio",
    key: "Please_select_length_of_service",
  },
  {
    English: "Please select carry Forward Amount \r\n",
    French: "Veuillez sélectionner le montant du report \r\n",
    Spanish: "Seleccione el importe transferido \r\n",
    key: "Please_select_carry_Forward_Amount",
  },
  {
    English: "Industry Category",
    French: "Catégorie d'industrie",
    Spanish: "Categoría de industria",
    key: "Industry_Category",
  },
  {
    English: "Intial Balance Setup",
    French: "Configuration du solde initial",
    Spanish: "Configuración del saldo inicial",
    key: "Intial_Balance_Setup",
  },
  {
    English: "Please select Industry Category",
    French: "Veuillez sélectionner la catégorie d'industrie",
    Spanish: "Por favor seleccione la categoría de industria",
    key: "Please_select_Industry_Category",
  },
  {
    English: "Allocation",
    French: "Allocation",
    Spanish: "Asignación",
    key: "Allocation",
  },
  {
    English: "Please select Allocation \r\n",
    French: "Veuillez sélectionner Allocation \r\n",
    Spanish: "Por favor seleccione Asignación \r\n",
    key: "Please_select_Allocation",
  },
  {
    English: "Please select Intial BalanceSetup",
    French: "Veuillez sélectionner Configuration du solde initial",
    Spanish: "Seleccione Configuración de saldo inicial",
    key: "Please_select_Intial_BalanceSetup",
  },
  {
    English: "Advisor Commission \r\n",
    French: "Commission de conseillers \r\n",
    Spanish: "Comisión Asesora \r\n",
    key: "Advisor_Commission",
  },
  {
    English: "Advisor fee",
    French: "Honoraires du conseiller",
    Spanish: "Honorarios de asesor",
    key: "Advisor_fee",
  },
  {
    English: "Please enter Advisor fee\r\n",
    French: "Veuillez saisir les frais du conseiller\r\n",
    Spanish: "Por favor ingrese la tarifa del asesor\r\n",
    key: "Please_enter_Advisor_fee",
  },
  {
    English: "Please enter Coverage Percentage",
    French: "Veuillez saisir le pourcentage de couverture",
    Spanish: "Por favor ingrese el porcentaje de cobertura",
    key: "Please_enter_Coverage_Percentage",
  },
  {
    English: "Please select wallet Type\r\n",
    French: "Veuillez sélectionner le type de portefeuille\r\n",
    Spanish: "Por favor seleccione el tipo de billetera\r\n",
    key: "Please_select_wallet_Type",
  },
  {
    English: "Please select Min length of service",
    French: "Veuillez sélectionner l'ancienneté minimale",
    Spanish: "Por favor seleccione Duración mínima del servicio",
    key: "Please_select_Min_length_of_service",
  },
  {
    English: "Coverage Percentage",
    French: "Pourcentage de couverture",
    Spanish: "Porcentaje de cobertura",
    key: "Coverage_Percentage",
  },
  {
    English: "Min Length of Service",
    French: "Durée minimale de service",
    Spanish: "Duración mínima del servicio",
    key: "Min_Length_of_Service",
  },
  {
    English: "Wallet Type",
    French: "Type de portefeuille",
    Spanish: "Tipo de billetera",
    key: "Wallet_Type",
  },
  {
    English: "Max Length of Service",
    French: "Durée maximale de service",
    Spanish: "Duración máxima del servicio",
    key: "Max_Length_of_Service",
  },
  {
    English: "Please select Max length of service \r\n",
    French: "Veuillez sélectionner l'ancienneté maximale \r\n",
    Spanish: "Por favor seleccione Duración máxima del servicio \r\n",
    key: "Please_select_Max_length_of_service",
  },
  {
    English: "Define Plan Coverage tiers for employees",
    French: "Définir les niveaux de couverture du plan pour les employés",
    Spanish: "Definir niveles de cobertura del plan para los empleados",
    key: "Define_Plan_Coverage_tiers_for_employees",
  },
  {
    English: "Tax Table",
    French: "Tableau des taxes",
    Spanish: "Tabla de impuestos",
    key: "Tax_Table",
  },
  {
    English: "Supplier",
    French: "Fournisseur",
    Spanish: "Proveedor",
    key: "Supplier",
  },
  {
    English: "Product Catalog",
    French: "Catalogue de produits",
    Spanish: "Catálogo de productos",
    key: "Product_Catalog",
  },
  {
    English: "Corporate Customer Name",
    French: "Nom du client d'entreprise",
    Spanish: "Nombre del cliente corporativo",
    key: "Corporate_Customer_Name",
  },
  {
    English:
      "please ensure the graduation date is later than the date of birth",
    French:
      "veuillez vous assurer que la date d'obtention du diplôme est postérieure à la date de naissance",
    Spanish:
      "Asegúrese de que la fecha de graduación sea posterior a la fecha de nacimiento.",
    key: "please_ensure_the_graduation_date_is_later_than_the_date_of_birth",
  },
  {
    English:
      "Please ensure the graduation date is greater than the date of birth.",
    French:
      "Veuillez vous assurer que la date d’obtention du diplôme est ultérieure à la date de naissance.",
    Spanish:
      "Asegúrese de que la fecha de graduación sea posterior a la fecha de nacimiento.",
    key: "Please_ensure_the_graduation_date_is_greater_than_the_date_of_birth",
  },
  {
    English: "No Invoices Available",
    French: "Aucune facture disponible",
    Spanish: "No hay facturas disponibles",
    key: "No_Invoices_Available",
  },
  {
    English: "Supplier ID",
    French: "ID Fournisseur",
    Spanish: "ID del Proveedor",
    key: "Supplier_ID",
  },
  {
    English: "Supplier Name",
    French: "Nom du Fournisseur",
    Spanish: "Nombre del Proveedor",
    key: "Supplier_Name",
  },
  {
    English: "Contact Information",
    French: "Informations de Contact",
    Spanish: "Información de Contacto",
    key: "Contact_Information",
  },
  {
    English: "Product ID",
    French: "ID Produit",
    Spanish: "ID de Producto",
    key: "Product_ID",
  },
  {
    English: "Product Information",
    French: "Informations sur le Produit",
    Spanish: "Información del Producto",
    key: "Product_Information",
  },
  {
    English: "Product Name",
    French: "Nom du Produit",
    Spanish: "Nombre del Producto",
    key: "Product_Name",
  },
  {
    English: "Description Country",
    French: "Description Pays",
    Spanish: "Descripción País",
    key: "Description_Country",
  },
  {
    English: "Distribution Province",
    French: "Province de Distribution",
    Spanish: "Provincia de Distribución",
    key: "Distribution_Province",
  },
  {
    English: "Service Level",
    French: "Niveau de Service",
    Spanish: "Nivel de Servicio",
    key: "Service_Level",
  },
  {
    English: "Service Levels",
    French: "Niveaux de Service",
    Spanish: "Niveles de Servicio",
    key: "Service_Levels",
  },
  {
    English: "Level 1",
    French: "Niveau 1",
    Spanish: "Nivel 1",
    key: "Level_1",
  },
  {
    English: "Level 2",
    French: "Niveau 2",
    Spanish: "Nivel 2",
    key: "Level_2",
  },
  {
    English: "Level 3",
    French: "Niveau 3",
    Spanish: "Nivel 3",
    key: "Level_3",
  },
  {
    English: "Age Limited",
    French: "Limite d'Âge",
    Spanish: "Límite de Edad",
    key: "Age_Limited",
  },
  {
    English: "Min Age",
    French: "Âge Minimum",
    Spanish: "Edad Mínima",
    key: "Min_Age",
  },
  {
    English: "Max Age",
    French: "Âge Maximum",
    Spanish: "Edad Máxima",
    key: "Max_Age",
  },
  {
    English: "Dependent Age Out",
    French: "Âge de Cessation pour les Ayants Droit",
    Spanish: "Edad Máxima del Dependiente",
    key: "Dependent_Age_Out",
  },
  {
    English: "If Student",
    French: "Si Étudiant",
    Spanish: "Si es Estudiante",
    key: "If_Student",
  },
  {
    English: "Product Description",
    French: "Description du Produit",
    Spanish: "Descripción del Producto",
    key: "Product_Description",
  },
  {
    English: "Date Added",
    French: "Date d’Ajout",
    Spanish: "Fecha de Adición",
    key: "Date_Added",
  },
  {
    English: "Product Booklet",
    French: "Brochure Produit",
    Spanish: "Folleto del Producto",
    key: "Product_Booklet",
  },
  {
    English: "Pricing from Vendor",
    French: "Tarification Fournisseur",
    Spanish: "Precios del Proveedor",
    key: "Pricing_from_Vendor",
  },
  {
    English: "Levels Age Banded? (e.g., Life)",
    French: "Tranches d’Âge par Niveau ? (ex. Vie)",
    Spanish: "¿Niveles por Banda de Edad? (ej. Vida)",
    key: "Levels_Age_Banded_e_g_Life",
  },
  {
    English: "Fees & Commissions Included?",
    French: "Frais & Commissions Inclus ?",
    Spanish: "¿Honorarios y Comisiones Incluidos?",
    key: "Fees_Commissions_Included",
  },
  {
    English: "TAP Fee",
    French: "Frais TAP",
    Spanish: "Tarifa TAP",
    key: "TAP_Fee",
  },
  {
    English: "Advisor Commission",
    French: "Commission du Conseiller",
    Spanish: "Comisión del Asesor",
    key: "Advisor_Commission",
  },
  {
    English: "Other Fees",
    French: "Autres Frais",
    Spanish: "Otras Tarifas",
    key: "Other_Fees",
  },
  {
    English: "Invoicing",
    French: "Facturation",
    Spanish: "Facturación",
    key: "Invoicing",
  },
  {
    English: "Self-billing",
    French: "Auto-facturation",
    Spanish: "Auto-facturación",
    key: "Self_billing",
  },
  {
    English: "Method",
    French: "Méthode",
    Spanish: "Método",
    key: "Method",
  },
  {
    English: "Provider Invoice",
    French: "Facture Fournisseur",
    Spanish: "Factura del Proveedor",
    key: "Provider_Invoice",
  },
  {
    English: "PDA withdrawl from GB",
    French: "Retrait PDA depuis GB",
    Spanish: "Retiro de PDA desde GB",
    key: "PDA_withdrawl_from_GB",
  },
  {
    English: "Expected Payment Date",
    French: "Date de Paiement Prévue",
    Spanish: "Fecha de Pago Esperada",
    key: "Expected_Payment_Date",
  },
  {
    English: "Payment by PDA",
    French: "Paiement par PDA",
    Spanish: "Pago mediante PDA",
    key: "Payment_by_PDA",
  },
  {
    English: "Distribution Country",
    French: "Pays de distribution",
    Spanish: "País de distribución",
    key: "Distribution_Country",
  },
  {
    English: "Distribution",
    French: "Distribution",
    Spanish: "Distribución",
    key: "Distribution",
  },
  {
    English: "Roles",
    French: "Rôles",
    Spanish: "Roles",
    key: "Roles",
  },
  {
    English: "Reference ID",
    French: "ID de Référence",
    Spanish: "ID de Referencia",
    key: "Reference_ID",
  },
  {
    English: "Dist Country",
    French: "Pays de Distribution",
    Spanish: "País de Distribución",
    key: "Dist_Country",
  },
  {
    English: "Product Details",
    French: "Détails du Produit",
    Spanish: "Detalles del Producto",
    key: "Product_Details",
  },
  {
    English: "Invoiced",
    French: "Facturé",
    Spanish: "Facturado",
    key: "Invoiced",
  },
  {
    English: "Add Product",
    French: "Ajouter un Produit",
    Spanish: "Agregar Producto",
    key: "Add_Product",
  },
  {
    English: "PAD withdrawl from GB",
    French: "Prélèvement PAD depuis GB",
    Spanish: "Retiro PAD desde GB",
    key: "PAD_withdrawl_from_GB",
  },
  {
    English: "Distribution Date",
    French: "Date de Distribution",
    Spanish: "Fecha de Distribución",
    key: "Distribution_Date",
  },
  {
    English: "EFT to Vendor",
    French: "Virement au Fournisseur",
    Spanish: "Transferencia al Proveedor",
    key: "EFT_to_Vendor",
  },
  {
    English: "Group Benefitz Plan Summary",
    French: "Résumé du plan de Group Benefitz",
    Spanish: "Resumen del plan de Group Benefitz",
    key: "Group_Benefitz_Plan_Summary",
  },
  {
    English: "Group Benefitz Resources",
    French: "Ressources de Group Benefitz",
    Spanish: "Recursos de Group Benefitz",
    key: "Group_Benefitz_Resources",
  },
  {
    English: "Settings",
    French: "ParamÃ¨tres",
    Spanish: "Ajustes",
    key: "Settings",
  },
  {
    English: "Please enter valid email",
    French: "Veuillez entrer une adresse e-mail valide",
    Spanish: "Por favor ingrese un correo electrÃ³nico vÃ¡lido",
    key: "Please_enter_valid_email",
  },
  {
    English: "Dashboard",
    French: "Tableau de bord",
    Spanish: "Panel",
    key: "Dashboard",
  },
  {
    English: "System Users",
    French: "Utilisateurs du systÃ¨me",
    Spanish: "Usuarios del sistema",
    key: "System_Users",
  },
  {
    English: "Plans",
    French: "Forfaits",
    Spanish: " Spanish='Planes'\"",
    key: "Plans",
  },
  {
    English: "Advisors",
    French: "Conseillers",
    Spanish: "Asesores",
    key: "Advisors",
  },
  {
    English: "Payables",
    French: "Dettes",
    Spanish: "Cuentas por pagar",
    key: "Payables",
  },
  {
    English: "Corporate Customers",
    French: "Clients Entreprises",
    Spanish: "Clientes corporativos",
    key: "Corporate_Customers",
  },
  {
    English: "Members",
    French: "Membres",
    Spanish: "Miembros",
    key: "Members",
  },
  {
    English: "Invoices",
    French: "Factures",
    Spanish: " Spanish='Facturas'\"",
    key: "Invoices",
  },
  {
    English: "Reports",
    French: "Rapports",
    Spanish: "Informes",
    key: "Reports",
  },
  {
    English: "Change Password",
    French: "Changer le mot de passe",
    Spanish: "Cambiar la contraseÃ±a",
    key: "Change_Password",
  },
  {
    English: "Old Password",
    French: "Ancien mot de passe",
    Spanish: "ContraseÃ±a anterior",
    key: "Old_Password",
  },
  {
    English: "New Password",
    French: "Nouveau mot de passe",
    Spanish: "Nueva contraseÃ±a",
    key: "New_Password",
  },
];

export default strings;
